require("core-js/modules/es.array.unscopables.flat-map.js");
!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? n(exports, require("react"), require("react-dom")) : "function" == typeof define && define.amd ? define(["exports", "react", "react-dom"], n) : n((e = "undefined" != typeof globalThis ? globalThis : e || self)["lxui-Cascader"] = {}, e.React, e.ReactDOM);
}(this, function (e, n, t) {
  "use strict";

  function r(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }
  function o(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    return e && Object.keys(e).forEach(function (t) {
      if ("default" !== t) {
        var r = Object.getOwnPropertyDescriptor(e, t);
        Object.defineProperty(n, t, r.get ? r : {
          enumerable: !0,
          get: function () {
            return e[t];
          }
        });
      }
    }), n.default = e, Object.freeze(n);
  }
  var i = o(n),
    u = r(n),
    a = r(t);
  function c() {
    return c = Object.assign ? Object.assign.bind() : function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = arguments[n];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
      return e;
    }, c.apply(null, arguments);
  }
  function l(e, n) {
    (null == n || n > e.length) && (n = e.length);
    for (var t = 0, r = Array(n); t < n; t++) r[t] = e[t];
    return r;
  }
  function f(e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }
  function s(e, n) {
    if (e) {
      if ("string" == typeof e) return l(e, n);
      var t = {}.toString.call(e).slice(8, -1);
      return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? l(e, n) : void 0;
    }
  }
  function p(e) {
    return function (e) {
      if (Array.isArray(e)) return l(e);
    }(e) || f(e) || s(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function v(e) {
    if (Array.isArray(e)) return e;
  }
  function d() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function h(e, n) {
    return v(e) || function (e, n) {
      var t = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != t) {
        var r,
          o,
          i,
          u,
          a = [],
          c = !0,
          l = !1;
        try {
          if (i = (t = t.call(e)).next, 0 === n) {
            if (Object(t) !== t) return;
            c = !1;
          } else for (; !(c = (r = i.call(t)).done) && (a.push(r.value), a.length !== n); c = !0);
        } catch (e) {
          l = !0, o = e;
        } finally {
          try {
            if (!c && null != t.return && (u = t.return(), Object(u) !== u)) return;
          } finally {
            if (l) throw o;
          }
        }
        return a;
      }
    }(e, n) || s(e, n) || d();
  }
  function m(e, n) {
    if (null == e) return {};
    var t,
      r,
      o = function (e, n) {
        if (null == e) return {};
        var t = {};
        for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
          if (n.includes(r)) continue;
          t[r] = e[r];
        }
        return t;
      }(e, n);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);
      for (r = 0; r < i.length; r++) t = i[r], n.includes(t) || {}.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
    }
    return o;
  }
  function g(e) {
    return g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, g(e);
  }
  function y(e) {
    var n = function (e, n) {
      if ("object" != g(e) || !e) return e;
      var t = e[Symbol.toPrimitive];
      if (void 0 !== t) {
        var r = t.call(e, n || "default");
        if ("object" != g(r)) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === n ? String : Number)(e);
    }(e, "string");
    return "symbol" == g(n) ? n : n + "";
  }
  function b(e, n, t) {
    return (n = y(n)) in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }
  function w(e, n) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      n && (r = r.filter(function (n) {
        return Object.getOwnPropertyDescriptor(e, n).enumerable;
      })), t.push.apply(t, r);
    }
    return t;
  }
  function _(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = null != arguments[n] ? arguments[n] : {};
      n % 2 ? w(Object(t), !0).forEach(function (n) {
        b(e, n, t[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : w(Object(t)).forEach(function (n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
      });
    }
    return e;
  }
  function E(e) {
    var n = i.useRef();
    n.current = e;
    var t = i.useCallback(function () {
      for (var e, t = arguments.length, r = new Array(t), o = 0; o < t; o++) r[o] = arguments[o];
      return null === (e = n.current) || void 0 === e ? void 0 : e.call.apply(e, [n].concat(r));
    }, []);
    return t;
  }
  function S() {
    return !("undefined" == typeof window || !window.document || !window.document.createElement);
  }
  "function" == typeof SuppressedError && SuppressedError;
  var C = "test" !== process.env.NODE_ENV && S() ? i.useLayoutEffect : i.useEffect,
    x = function (e, n) {
      var t = i.useRef(!0);
      C(function () {
        return e(t.current);
      }, n), C(function () {
        return t.current = !1, function () {
          t.current = !0;
        };
      }, []);
    },
    O = function (e, n) {
      x(function (n) {
        if (!n) return e();
      }, n);
    };
  function k(e) {
    var n = i.useRef(!1),
      t = h(i.useState(e), 2),
      r = t[0],
      o = t[1];
    return i.useEffect(function () {
      return n.current = !1, function () {
        n.current = !0;
      };
    }, []), [r, function (e, t) {
      t && n.current || o(e);
    }];
  }
  function N(e) {
    return void 0 !== e;
  }
  function M(e, n) {
    var t = n || {},
      r = t.defaultValue,
      o = t.value,
      i = t.onChange,
      u = t.postState,
      a = h(k(function () {
        return N(o) ? o : N(r) ? "function" == typeof r ? r() : r : "function" == typeof e ? e() : e;
      }), 2),
      c = a[0],
      l = a[1],
      f = void 0 !== o ? o : c,
      s = u ? u(f) : f,
      p = E(i),
      v = h(k([f]), 2),
      d = v[0],
      m = v[1];
    return O(function () {
      var e = d[0];
      c !== e && p(c, e);
    }, [d]), O(function () {
      N(o) || l(o);
    }, [o]), [s, E(function (e, n) {
      l(e, n), m([f], n);
    })];
  }
  var R = {},
    A = [];
  function P(e, n) {
    if ("production" !== process.env.NODE_ENV && !e && void 0 !== console) {
      var t = A.reduce(function (e, n) {
        return n(null != e ? e : "", "warning");
      }, n);
      t && console.error("Warning: ".concat(t));
    }
  }
  function I(e, n) {
    if ("production" !== process.env.NODE_ENV && !e && void 0 !== console) {
      var t = A.reduce(function (e, n) {
        return n(null != e ? e : "", "note");
      }, n);
      t && console.warn("Note: ".concat(t));
    }
  }
  function D(e, n, t) {
    n || R[t] || (e(!1, t), R[t] = !0);
  }
  function T(e, n) {
    D(P, e, n);
  }
  function L(e, n) {
    D(I, e, n);
  }
  T.preMessage = function (e) {
    A.push(e);
  }, T.resetWarned = function () {
    R = {};
  }, T.noteOnce = L;
  var j = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
  function V(e) {
    var n = {
      exports: {}
    };
    return e(n, n.exports), n.exports;
    /*!
      	Copyright (c) 2018 Jed Watson.
      	Licensed under the MIT License (MIT), see
      	http://jedwatson.github.io/classnames
      */
  }
  var z,
    F = V(function (e) {
      !function () {
        var n = {}.hasOwnProperty;
        function t() {
          for (var e = "", n = 0; n < arguments.length; n++) {
            var t = arguments[n];
            t && (e = o(e, r(t)));
          }
          return e;
        }
        function r(e) {
          if ("string" == typeof e || "number" == typeof e) return e;
          if ("object" != typeof e) return "";
          if (Array.isArray(e)) return t.apply(null, e);
          if (e.toString !== Object.prototype.toString && !e.toString.toString().includes("[native code]")) return e.toString();
          var r = "";
          for (var i in e) n.call(e, i) && e[i] && (r = o(r, i));
          return r;
        }
        function o(e, n) {
          return n ? e ? e + " " + n : e + n : e;
        }
        e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
      }();
    }),
    W = function () {
      if ("undefined" == typeof navigator || "undefined" == typeof window) return !1;
      var e = navigator.userAgent || navigator.vendor || window.opera;
      return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(null == e ? void 0 : e.substr(0, 4));
    },
    H = {
      MAC_ENTER: 3,
      BACKSPACE: 8,
      TAB: 9,
      NUM_CENTER: 12,
      ENTER: 13,
      SHIFT: 16,
      CTRL: 17,
      ALT: 18,
      PAUSE: 19,
      CAPS_LOCK: 20,
      ESC: 27,
      SPACE: 32,
      PAGE_UP: 33,
      PAGE_DOWN: 34,
      END: 35,
      HOME: 36,
      LEFT: 37,
      UP: 38,
      RIGHT: 39,
      DOWN: 40,
      PRINT_SCREEN: 44,
      INSERT: 45,
      DELETE: 46,
      ZERO: 48,
      ONE: 49,
      TWO: 50,
      THREE: 51,
      FOUR: 52,
      FIVE: 53,
      SIX: 54,
      SEVEN: 55,
      EIGHT: 56,
      NINE: 57,
      QUESTION_MARK: 63,
      A: 65,
      B: 66,
      C: 67,
      D: 68,
      E: 69,
      F: 70,
      G: 71,
      H: 72,
      I: 73,
      J: 74,
      K: 75,
      L: 76,
      M: 77,
      N: 78,
      O: 79,
      P: 80,
      Q: 81,
      R: 82,
      S: 83,
      T: 84,
      U: 85,
      V: 86,
      W: 87,
      X: 88,
      Y: 89,
      Z: 90,
      META: 91,
      WIN_KEY_RIGHT: 92,
      CONTEXT_MENU: 93,
      NUM_ZERO: 96,
      NUM_ONE: 97,
      NUM_TWO: 98,
      NUM_THREE: 99,
      NUM_FOUR: 100,
      NUM_FIVE: 101,
      NUM_SIX: 102,
      NUM_SEVEN: 103,
      NUM_EIGHT: 104,
      NUM_NINE: 105,
      NUM_MULTIPLY: 106,
      NUM_PLUS: 107,
      NUM_MINUS: 109,
      NUM_PERIOD: 110,
      NUM_DIVISION: 111,
      F1: 112,
      F2: 113,
      F3: 114,
      F4: 115,
      F5: 116,
      F6: 117,
      F7: 118,
      F8: 119,
      F9: 120,
      F10: 121,
      F11: 122,
      F12: 123,
      NUMLOCK: 144,
      SEMICOLON: 186,
      DASH: 189,
      EQUALS: 187,
      COMMA: 188,
      PERIOD: 190,
      SLASH: 191,
      APOSTROPHE: 192,
      SINGLE_QUOTE: 222,
      OPEN_SQUARE_BRACKET: 219,
      BACKSLASH: 220,
      CLOSE_SQUARE_BRACKET: 221,
      WIN_KEY: 224,
      MAC_FF_META: 224,
      WIN_IME: 229,
      isTextModifyingKeyEvent: function (e) {
        var n = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || n >= H.F1 && n <= H.F12) return !1;
        switch (n) {
          case H.ALT:
          case H.CAPS_LOCK:
          case H.CONTEXT_MENU:
          case H.CTRL:
          case H.DOWN:
          case H.END:
          case H.ESC:
          case H.HOME:
          case H.INSERT:
          case H.LEFT:
          case H.MAC_FF_META:
          case H.META:
          case H.NUMLOCK:
          case H.NUM_CENTER:
          case H.PAGE_DOWN:
          case H.PAGE_UP:
          case H.PAUSE:
          case H.PRINT_SCREEN:
          case H.RIGHT:
          case H.SHIFT:
          case H.UP:
          case H.WIN_KEY:
          case H.WIN_KEY_RIGHT:
            return !1;
          default:
            return !0;
        }
      },
      isCharacterKey: function (e) {
        if (e >= H.ZERO && e <= H.NINE) return !0;
        if (e >= H.NUM_ZERO && e <= H.NUM_MULTIPLY) return !0;
        if (e >= H.A && e <= H.Z) return !0;
        if (-1 !== window.navigator.userAgent.indexOf("WebKit") && 0 === e) return !0;
        switch (e) {
          case H.SPACE:
          case H.QUESTION_MARK:
          case H.NUM_PLUS:
          case H.NUM_MINUS:
          case H.NUM_PERIOD:
          case H.NUM_DIVISION:
          case H.SEMICOLON:
          case H.DASH:
          case H.EQUALS:
          case H.COMMA:
          case H.PERIOD:
          case H.SLASH:
          case H.APOSTROPHE:
          case H.SINGLE_QUOTE:
          case H.OPEN_SQUARE_BRACKET:
          case H.BACKSLASH:
          case H.CLOSE_SQUARE_BRACKET:
            return !0;
          default:
            return !1;
        }
      }
    },
    U = Symbol.for("react.element"),
    K = Symbol.for("react.portal"),
    B = Symbol.for("react.fragment"),
    $ = Symbol.for("react.strict_mode"),
    Y = Symbol.for("react.profiler"),
    q = Symbol.for("react.provider"),
    G = Symbol.for("react.context"),
    X = Symbol.for("react.server_context"),
    Z = Symbol.for("react.forward_ref"),
    Q = Symbol.for("react.suspense"),
    J = Symbol.for("react.suspense_list"),
    ee = Symbol.for("react.memo"),
    ne = Symbol.for("react.lazy"),
    te = Symbol.for("react.offscreen");
  function re(e) {
    if ("object" == typeof e && null !== e) {
      var n = e.$$typeof;
      switch (n) {
        case U:
          switch (e = e.type) {
            case B:
            case Y:
            case $:
            case Q:
            case J:
              return e;
            default:
              switch (e = e && e.$$typeof) {
                case X:
                case G:
                case Z:
                case ne:
                case ee:
                case q:
                  return e;
                default:
                  return n;
              }
          }
        case K:
          return n;
      }
    }
  }
  z = Symbol.for("react.module.reference");
  var oe = {
      ContextConsumer: G,
      ContextProvider: q,
      Element: U,
      ForwardRef: Z,
      Fragment: B,
      Lazy: ne,
      Memo: ee,
      Portal: K,
      Profiler: Y,
      StrictMode: $,
      Suspense: Q,
      SuspenseList: J,
      isAsyncMode: function () {
        return !1;
      },
      isConcurrentMode: function () {
        return !1;
      },
      isContextConsumer: function (e) {
        return re(e) === G;
      },
      isContextProvider: function (e) {
        return re(e) === q;
      },
      isElement: function (e) {
        return "object" == typeof e && null !== e && e.$$typeof === U;
      },
      isForwardRef: function (e) {
        return re(e) === Z;
      },
      isFragment: function (e) {
        return re(e) === B;
      },
      isLazy: function (e) {
        return re(e) === ne;
      },
      isMemo: function (e) {
        return re(e) === ee;
      },
      isPortal: function (e) {
        return re(e) === K;
      },
      isProfiler: function (e) {
        return re(e) === Y;
      },
      isStrictMode: function (e) {
        return re(e) === $;
      },
      isSuspense: function (e) {
        return re(e) === Q;
      },
      isSuspenseList: function (e) {
        return re(e) === J;
      },
      isValidElementType: function (e) {
        return "string" == typeof e || "function" == typeof e || e === B || e === Y || e === $ || e === Q || e === J || e === te || "object" == typeof e && null !== e && (e.$$typeof === ne || e.$$typeof === ee || e.$$typeof === q || e.$$typeof === G || e.$$typeof === Z || e.$$typeof === z || void 0 !== e.getModuleId);
      },
      typeOf: re
    },
    ie = V(function (e, n) {
      "production" !== process.env.NODE_ENV && function () {
        var e,
          t = Symbol.for("react.element"),
          r = Symbol.for("react.portal"),
          o = Symbol.for("react.fragment"),
          i = Symbol.for("react.strict_mode"),
          u = Symbol.for("react.profiler"),
          a = Symbol.for("react.provider"),
          c = Symbol.for("react.context"),
          l = Symbol.for("react.server_context"),
          f = Symbol.for("react.forward_ref"),
          s = Symbol.for("react.suspense"),
          p = Symbol.for("react.suspense_list"),
          v = Symbol.for("react.memo"),
          d = Symbol.for("react.lazy"),
          h = Symbol.for("react.offscreen");
        function m(e) {
          if ("object" == typeof e && null !== e) {
            var n = e.$$typeof;
            switch (n) {
              case t:
                var h = e.type;
                switch (h) {
                  case o:
                  case u:
                  case i:
                  case s:
                  case p:
                    return h;
                  default:
                    var m = h && h.$$typeof;
                    switch (m) {
                      case l:
                      case c:
                      case f:
                      case d:
                      case v:
                      case a:
                        return m;
                      default:
                        return n;
                    }
                }
              case r:
                return n;
            }
          }
        }
        e = Symbol.for("react.module.reference");
        var g = c,
          y = a,
          b = t,
          w = f,
          _ = o,
          E = d,
          S = v,
          C = r,
          x = u,
          O = i,
          k = s,
          N = p,
          M = !1,
          R = !1;
        n.ContextConsumer = g, n.ContextProvider = y, n.Element = b, n.ForwardRef = w, n.Fragment = _, n.Lazy = E, n.Memo = S, n.Portal = C, n.Profiler = x, n.StrictMode = O, n.Suspense = k, n.SuspenseList = N, n.isAsyncMode = function (e) {
          return M || (M = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
        }, n.isConcurrentMode = function (e) {
          return R || (R = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
        }, n.isContextConsumer = function (e) {
          return m(e) === c;
        }, n.isContextProvider = function (e) {
          return m(e) === a;
        }, n.isElement = function (e) {
          return "object" == typeof e && null !== e && e.$$typeof === t;
        }, n.isForwardRef = function (e) {
          return m(e) === f;
        }, n.isFragment = function (e) {
          return m(e) === o;
        }, n.isLazy = function (e) {
          return m(e) === d;
        }, n.isMemo = function (e) {
          return m(e) === v;
        }, n.isPortal = function (e) {
          return m(e) === r;
        }, n.isProfiler = function (e) {
          return m(e) === u;
        }, n.isStrictMode = function (e) {
          return m(e) === i;
        }, n.isSuspense = function (e) {
          return m(e) === s;
        }, n.isSuspenseList = function (e) {
          return m(e) === p;
        }, n.isValidElementType = function (n) {
          return "string" == typeof n || "function" == typeof n || n === o || n === u || n === i || n === s || n === p || n === h || "object" == typeof n && null !== n && (n.$$typeof === d || n.$$typeof === v || n.$$typeof === a || n.$$typeof === c || n.$$typeof === f || n.$$typeof === e || void 0 !== n.getModuleId);
        }, n.typeOf = m;
      }();
    }),
    ue = V(function (e) {
      "production" === process.env.NODE_ENV ? e.exports = oe : e.exports = ie;
    });
  function ae(e, n, t) {
    var r = i.useRef({});
    return "value" in r.current && !t(r.current.condition, n) || (r.current.value = e(), r.current.condition = n), r.current.value;
  }
  var ce = Symbol.for("react.element"),
    le = Symbol.for("react.transitional.element"),
    fe = Symbol.for("react.fragment");
  function se(e) {
    return e && "object" === g(e) && (e.$$typeof === ce || e.$$typeof === le) && e.type === fe;
  }
  var pe = function (e, n) {
      "function" == typeof e ? e(n) : "object" === g(e) && e && "current" in e && (e.current = n);
    },
    ve = function () {
      for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++) n[t] = arguments[t];
      var r = n.filter(Boolean);
      return r.length <= 1 ? r[0] : function (e) {
        n.forEach(function (n) {
          pe(n, e);
        });
      };
    },
    de = function () {
      for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++) n[t] = arguments[t];
      return ae(function () {
        return ve.apply(void 0, n);
      }, n, function (e, n) {
        return e.length !== n.length || e.every(function (e, t) {
          return e !== n[t];
        });
      });
    },
    he = function (e) {
      var n, t;
      if (!e) return !1;
      if (me(e) && e.props.propertyIsEnumerable("ref")) return !0;
      var r = ue.isMemo(e) ? e.type.type : e.type;
      return !!("function" != typeof r || null !== (n = r.prototype) && void 0 !== n && n.render || r.$$typeof === ue.ForwardRef) && !!("function" != typeof e || null !== (t = e.prototype) && void 0 !== t && t.render || e.$$typeof === ue.ForwardRef);
    };
  function me(e) {
    return n.isValidElement(e) && !se(e);
  }
  var ge = function (e) {
      if (e && me(e)) {
        var n = e;
        return n.props.propertyIsEnumerable("ref") ? n.props.ref : n.ref;
      }
      return null;
    },
    ye = i.createContext(null);
  function be() {
    return i.useContext(ye);
  }
  function we() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 250,
      n = i.useRef(null),
      t = i.useRef(null);
    return i.useEffect(function () {
      return function () {
        window.clearTimeout(t.current);
      };
    }, []), [function () {
      return n.current;
    }, function (r) {
      (r || null === n.current) && (n.current = r), window.clearTimeout(t.current), t.current = window.setTimeout(function () {
        n.current = null;
      }, e);
    }];
  }
  var _e = "".concat("accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap", " ").concat("onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError").split(/[\s\n]+/);
  function Ee(e, n) {
    return 0 === e.indexOf(n);
  }
  function Se(e) {
    var n,
      t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    n = !1 === t ? {
      aria: !0,
      data: !0,
      attr: !0
    } : !0 === t ? {
      aria: !0
    } : _({}, t);
    var r = {};
    return Object.keys(e).forEach(function (t) {
      (n.aria && ("role" === t || Ee(t, "aria-")) || n.data && Ee(t, "data-") || n.attr && _e.includes(t)) && (r[t] = e[t]);
    }), r;
  }
  function Ce(e) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      t = [];
    return u.default.Children.forEach(e, function (e) {
      (null != e || n.keepEmpty) && (Array.isArray(e) ? t = t.concat(Ce(e)) : se(e) && e.props ? t = t.concat(Ce(e.props.children, n)) : t.push(e));
    }), t;
  }
  function xe(e) {
    return e instanceof HTMLElement || e instanceof SVGElement;
  }
  function Oe(e) {
    var n,
      t = function (e) {
        return e && "object" === g(e) && xe(e.nativeElement) ? e.nativeElement : xe(e) ? e : null;
      }(e);
    return t || (e instanceof u.default.Component ? null === (n = a.default.findDOMNode) || void 0 === n ? void 0 : n.call(a.default, e) : null);
  }
  var ke = i.createContext(null);
  var Ne = function () {
      if ("undefined" != typeof Map) return Map;
      function e(e, n) {
        var t = -1;
        return e.some(function (e, r) {
          return e[0] === n && (t = r, !0);
        }), t;
      }
      return function () {
        function n() {
          this.__entries__ = [];
        }
        return Object.defineProperty(n.prototype, "size", {
          get: function () {
            return this.__entries__.length;
          },
          enumerable: !0,
          configurable: !0
        }), n.prototype.get = function (n) {
          var t = e(this.__entries__, n),
            r = this.__entries__[t];
          return r && r[1];
        }, n.prototype.set = function (n, t) {
          var r = e(this.__entries__, n);
          ~r ? this.__entries__[r][1] = t : this.__entries__.push([n, t]);
        }, n.prototype.delete = function (n) {
          var t = this.__entries__,
            r = e(t, n);
          ~r && t.splice(r, 1);
        }, n.prototype.has = function (n) {
          return !!~e(this.__entries__, n);
        }, n.prototype.clear = function () {
          this.__entries__.splice(0);
        }, n.prototype.forEach = function (e, n) {
          void 0 === n && (n = null);
          for (var t = 0, r = this.__entries__; t < r.length; t++) {
            var o = r[t];
            e.call(n, o[1], o[0]);
          }
        }, n;
      }();
    }(),
    Me = "undefined" != typeof window && "undefined" != typeof document && window.document === document,
    Re = "undefined" != typeof global && global.Math === Math ? global : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(),
    Ae = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(Re) : function (e) {
      return setTimeout(function () {
        return e(Date.now());
      }, 1e3 / 60);
    };
  var Pe = ["top", "right", "bottom", "left", "width", "height", "size", "weight"],
    Ie = "undefined" != typeof MutationObserver,
    De = function () {
      function e() {
        this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = function (e, n) {
          var t = !1,
            r = !1,
            o = 0;
          function i() {
            t && (t = !1, e()), r && a();
          }
          function u() {
            Ae(i);
          }
          function a() {
            var e = Date.now();
            if (t) {
              if (e - o < 2) return;
              r = !0;
            } else t = !0, r = !1, setTimeout(u, n);
            o = e;
          }
          return a;
        }(this.refresh.bind(this), 20);
      }
      return e.prototype.addObserver = function (e) {
        ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
      }, e.prototype.removeObserver = function (e) {
        var n = this.observers_,
          t = n.indexOf(e);
        ~t && n.splice(t, 1), !n.length && this.connected_ && this.disconnect_();
      }, e.prototype.refresh = function () {
        this.updateObservers_() && this.refresh();
      }, e.prototype.updateObservers_ = function () {
        var e = this.observers_.filter(function (e) {
          return e.gatherActive(), e.hasActive();
        });
        return e.forEach(function (e) {
          return e.broadcastActive();
        }), e.length > 0;
      }, e.prototype.connect_ = function () {
        Me && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Ie ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
          attributes: !0,
          childList: !0,
          characterData: !0,
          subtree: !0
        })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
      }, e.prototype.disconnect_ = function () {
        Me && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
      }, e.prototype.onTransitionEnd_ = function (e) {
        var n = e.propertyName,
          t = void 0 === n ? "" : n;
        Pe.some(function (e) {
          return !!~t.indexOf(e);
        }) && this.refresh();
      }, e.getInstance = function () {
        return this.instance_ || (this.instance_ = new e()), this.instance_;
      }, e.instance_ = null, e;
    }(),
    Te = function (e, n) {
      for (var t = 0, r = Object.keys(n); t < r.length; t++) {
        var o = r[t];
        Object.defineProperty(e, o, {
          value: n[o],
          enumerable: !1,
          writable: !1,
          configurable: !0
        });
      }
      return e;
    },
    Le = function (e) {
      return e && e.ownerDocument && e.ownerDocument.defaultView || Re;
    },
    je = Ue(0, 0, 0, 0);
  function Ve(e) {
    return parseFloat(e) || 0;
  }
  function ze(e) {
    for (var n = [], t = 1; t < arguments.length; t++) n[t - 1] = arguments[t];
    return n.reduce(function (n, t) {
      return n + Ve(e["border-" + t + "-width"]);
    }, 0);
  }
  function Fe(e) {
    var n = e.clientWidth,
      t = e.clientHeight;
    if (!n && !t) return je;
    var r = Le(e).getComputedStyle(e),
      o = function (e) {
        for (var n = {}, t = 0, r = ["top", "right", "bottom", "left"]; t < r.length; t++) {
          var o = r[t],
            i = e["padding-" + o];
          n[o] = Ve(i);
        }
        return n;
      }(r),
      i = o.left + o.right,
      u = o.top + o.bottom,
      a = Ve(r.width),
      c = Ve(r.height);
    if ("border-box" === r.boxSizing && (Math.round(a + i) !== n && (a -= ze(r, "left", "right") + i), Math.round(c + u) !== t && (c -= ze(r, "top", "bottom") + u)), !function (e) {
      return e === Le(e).document.documentElement;
    }(e)) {
      var l = Math.round(a + i) - n,
        f = Math.round(c + u) - t;
      1 !== Math.abs(l) && (a -= l), 1 !== Math.abs(f) && (c -= f);
    }
    return Ue(o.left, o.top, a, c);
  }
  var We = "undefined" != typeof SVGGraphicsElement ? function (e) {
    return e instanceof Le(e).SVGGraphicsElement;
  } : function (e) {
    return e instanceof Le(e).SVGElement && "function" == typeof e.getBBox;
  };
  function He(e) {
    return Me ? We(e) ? function (e) {
      var n = e.getBBox();
      return Ue(0, 0, n.width, n.height);
    }(e) : Fe(e) : je;
  }
  function Ue(e, n, t, r) {
    return {
      x: e,
      y: n,
      width: t,
      height: r
    };
  }
  var Ke = function () {
      function e(e) {
        this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Ue(0, 0, 0, 0), this.target = e;
      }
      return e.prototype.isActive = function () {
        var e = He(this.target);
        return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
      }, e.prototype.broadcastRect = function () {
        var e = this.contentRect_;
        return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
      }, e;
    }(),
    Be = function (e, n) {
      var t,
        r,
        o,
        i,
        u,
        a,
        c,
        l = (r = (t = n).x, o = t.y, i = t.width, u = t.height, a = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object, c = Object.create(a.prototype), Te(c, {
          x: r,
          y: o,
          width: i,
          height: u,
          top: o,
          right: r + i,
          bottom: u + o,
          left: r
        }), c);
      Te(this, {
        target: e,
        contentRect: l
      });
    },
    $e = function () {
      function e(e, n, t) {
        if (this.activeObservations_ = [], this.observations_ = new Ne(), "function" != typeof e) throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = e, this.controller_ = n, this.callbackCtx_ = t;
      }
      return e.prototype.observe = function (e) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        if ("undefined" != typeof Element && Element instanceof Object) {
          if (!(e instanceof Le(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
          var n = this.observations_;
          n.has(e) || (n.set(e, new Ke(e)), this.controller_.addObserver(this), this.controller_.refresh());
        }
      }, e.prototype.unobserve = function (e) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        if ("undefined" != typeof Element && Element instanceof Object) {
          if (!(e instanceof Le(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
          var n = this.observations_;
          n.has(e) && (n.delete(e), n.size || this.controller_.removeObserver(this));
        }
      }, e.prototype.disconnect = function () {
        this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
      }, e.prototype.gatherActive = function () {
        var e = this;
        this.clearActive(), this.observations_.forEach(function (n) {
          n.isActive() && e.activeObservations_.push(n);
        });
      }, e.prototype.broadcastActive = function () {
        if (this.hasActive()) {
          var e = this.callbackCtx_,
            n = this.activeObservations_.map(function (e) {
              return new Be(e.target, e.broadcastRect());
            });
          this.callback_.call(e, n, e), this.clearActive();
        }
      }, e.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
      }, e.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
      }, e;
    }(),
    Ye = "undefined" != typeof WeakMap ? new WeakMap() : new Ne(),
    qe = function e(n) {
      if (!(this instanceof e)) throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
      var t = De.getInstance(),
        r = new $e(n, t, this);
      Ye.set(this, r);
    };
  ["observe", "unobserve", "disconnect"].forEach(function (e) {
    qe.prototype[e] = function () {
      var n;
      return (n = Ye.get(this))[e].apply(n, arguments);
    };
  });
  var Ge = void 0 !== Re.ResizeObserver ? Re.ResizeObserver : qe,
    Xe = new Map();
  function Ze(e) {
    e.forEach(function (e) {
      var n,
        t = e.target;
      null === (n = Xe.get(t)) || void 0 === n || n.forEach(function (e) {
        return e(t);
      });
    });
  }
  var Qe = new Ge(Ze);
  function Je(e, n) {
    if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function en(e, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, y(r.key), r);
    }
  }
  function nn(e, n, t) {
    return n && en(e.prototype, n), t && en(e, t), Object.defineProperty(e, "prototype", {
      writable: !1
    }), e;
  }
  function tn(e, n) {
    return tn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, n) {
      return e.__proto__ = n, e;
    }, tn(e, n);
  }
  function rn(e, n) {
    if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(n && n.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(e, "prototype", {
      writable: !1
    }), n && tn(e, n);
  }
  function on(e) {
    return on = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    }, on(e);
  }
  function un() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {}
    return (un = function () {
      return !!e;
    })();
  }
  function an(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function cn(e) {
    var n = un();
    return function () {
      var t,
        r = on(e);
      if (n) {
        var o = on(this).constructor;
        t = Reflect.construct(r, arguments, o);
      } else t = r.apply(this, arguments);
      return function (e, n) {
        if (n && ("object" == g(n) || "function" == typeof n)) return n;
        if (void 0 !== n) throw new TypeError("Derived constructors may only return object or undefined");
        return an(e);
      }(this, t);
    };
  }
  process.env.NODE_ENV, process.env.NODE_ENV;
  var ln = function (e) {
    rn(t, e);
    var n = cn(t);
    function t() {
      return Je(this, t), n.apply(this, arguments);
    }
    return nn(t, [{
      key: "render",
      value: function () {
        return this.props.children;
      }
    }]), t;
  }(i.Component);
  function fn(e, n) {
    var t = e.children,
      r = e.disabled,
      o = i.useRef(null),
      u = i.useRef(null),
      a = i.useContext(ke),
      c = "function" == typeof t,
      l = c ? t(o) : t,
      f = i.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
      }),
      s = !c && i.isValidElement(l) && he(l),
      p = s ? ge(l) : null,
      v = de(p, o),
      d = function () {
        var e;
        return Oe(o.current) || (o.current && "object" === g(o.current) ? Oe(null === (e = o.current) || void 0 === e ? void 0 : e.nativeElement) : null) || Oe(u.current);
      };
    i.useImperativeHandle(n, function () {
      return d();
    });
    var h = i.useRef(e);
    h.current = e;
    var m = i.useCallback(function (e) {
      var n = h.current,
        t = n.onResize,
        r = n.data,
        o = e.getBoundingClientRect(),
        i = o.width,
        u = o.height,
        c = e.offsetWidth,
        l = e.offsetHeight,
        s = Math.floor(i),
        p = Math.floor(u);
      if (f.current.width !== s || f.current.height !== p || f.current.offsetWidth !== c || f.current.offsetHeight !== l) {
        var v = {
          width: s,
          height: p,
          offsetWidth: c,
          offsetHeight: l
        };
        f.current = v;
        var d = c === Math.round(i) ? i : c,
          m = l === Math.round(u) ? u : l,
          g = _(_({}, v), {}, {
            offsetWidth: d,
            offsetHeight: m
          });
        null == a || a(g, e, r), t && Promise.resolve().then(function () {
          t(g, e);
        });
      }
    }, []);
    return i.useEffect(function () {
      var e,
        n,
        t = d();
      return t && !r && (e = t, n = m, Xe.has(e) || (Xe.set(e, new Set()), Qe.observe(e)), Xe.get(e).add(n)), function () {
        return function (e, n) {
          Xe.has(e) && (Xe.get(e).delete(n), Xe.get(e).size || (Qe.unobserve(e), Xe.delete(e)));
        }(t, m);
      };
    }, [o.current, r]), i.createElement(ln, {
      ref: u
    }, s ? i.cloneElement(l, {
      ref: v
    }) : l);
  }
  var sn = i.forwardRef(fn);
  "production" !== process.env.NODE_ENV && (sn.displayName = "SingleObserver");
  function pn(e, n) {
    var t = e.children,
      r = "function" == typeof t ? [t] : Ce(t);
    return "production" !== process.env.NODE_ENV && (r.length > 1 ? P(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : 0 === r.length && P(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), r.map(function (t, r) {
      var o = (null == t ? void 0 : t.key) || "".concat("rc-observer-key", "-").concat(r);
      return i.createElement(sn, c({}, e, {
        key: o,
        ref: 0 === r ? n : void 0
      }), t);
    });
  }
  var vn = i.forwardRef(pn);
  "production" !== process.env.NODE_ENV && (vn.displayName = "ResizeObserver"), vn.Collection = function (e) {
    var n = e.children,
      t = e.onBatchResize,
      r = i.useRef(0),
      o = i.useRef([]),
      u = i.useContext(ke),
      a = i.useCallback(function (e, n, i) {
        r.current += 1;
        var a = r.current;
        o.current.push({
          size: e,
          element: n,
          data: i
        }), Promise.resolve().then(function () {
          a === r.current && (null == t || t(o.current), o.current = []);
        }), null == u || u(e, n, i);
      }, [t, u]);
    return i.createElement(ke.Provider, {
      value: a
    }, n);
  };
  var dn = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"],
    hn = void 0;
  function mn(e, n) {
    var t = e.prefixCls,
      r = e.invalidate,
      o = e.item,
      u = e.renderItem,
      a = e.responsive,
      l = e.responsiveDisabled,
      f = e.registerSize,
      s = e.itemKey,
      p = e.className,
      v = e.style,
      d = e.children,
      h = e.display,
      g = e.order,
      y = e.component,
      b = void 0 === y ? "div" : y,
      w = m(e, dn),
      E = a && !h;
    function S(e) {
      f(s, e);
    }
    i.useEffect(function () {
      return function () {
        S(null);
      };
    }, []);
    var C,
      x = u && o !== hn ? u(o) : d;
    r || (C = {
      opacity: E ? 0 : 1,
      height: E ? 0 : hn,
      overflowY: E ? "hidden" : hn,
      order: a ? g : hn,
      pointerEvents: E ? "none" : hn,
      position: E ? "absolute" : hn
    });
    var O = {};
    E && (O["aria-hidden"] = !0);
    var k = i.createElement(b, c({
      className: F(!r && t, p),
      style: _(_({}, C), v)
    }, O, w, {
      ref: n
    }), x);
    return a && (k = i.createElement(vn, {
      onResize: function (e) {
        S(e.offsetWidth);
      },
      disabled: l
    }, k)), k;
  }
  var gn = i.forwardRef(mn);
  gn.displayName = "Item";
  var yn = function (e) {
      return +setTimeout(e, 16);
    },
    bn = function (e) {
      return clearTimeout(e);
    };
  "undefined" != typeof window && "requestAnimationFrame" in window && (yn = function (e) {
    return window.requestAnimationFrame(e);
  }, bn = function (e) {
    return window.cancelAnimationFrame(e);
  });
  var wn = 0,
    _n = new Map();
  function En(e) {
    _n.delete(e);
  }
  var Sn = function (e) {
    var n = wn += 1;
    return function t(r) {
      if (0 === r) En(n), e();else {
        var o = yn(function () {
          t(r - 1);
        });
        _n.set(n, o);
      }
    }(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1), n;
  };
  function Cn() {
    var e = i.useRef(null);
    return function (n) {
      e.current || (e.current = [], function (e) {
        if ("undefined" == typeof MessageChannel) Sn(e);else {
          var n = new MessageChannel();
          n.port1.onmessage = function () {
            return e();
          }, n.port2.postMessage(void 0);
        }
      }(function () {
        t.unstable_batchedUpdates(function () {
          e.current.forEach(function (e) {
            e();
          }), e.current = null;
        });
      })), e.current.push(n);
    };
  }
  function xn(e, n) {
    var t = h(i.useState(n), 2),
      r = t[0],
      o = t[1];
    return [r, E(function (n) {
      e(function () {
        o(n);
      });
    })];
  }
  Sn.cancel = function (e) {
    var n = _n.get(e);
    return En(e), bn(n);
  }, "production" !== process.env.NODE_ENV && (Sn.ids = function () {
    return _n;
  });
  var On = u.default.createContext(null),
    kn = ["component"],
    Nn = ["className"],
    Mn = ["className"],
    Rn = function (e, n) {
      var t = i.useContext(On);
      if (!t) {
        var r = e.component,
          o = void 0 === r ? "div" : r,
          u = m(e, kn);
        return i.createElement(o, c({}, u, {
          ref: n
        }));
      }
      var a = t.className,
        l = m(t, Nn),
        f = e.className,
        s = m(e, Mn);
      return i.createElement(On.Provider, {
        value: null
      }, i.createElement(gn, c({
        ref: n,
        className: F(a, f)
      }, l, s)));
    },
    An = i.forwardRef(Rn);
  An.displayName = "RawItem";
  var Pn = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"],
    In = "responsive",
    Dn = "invalidate";
  function Tn(e) {
    return "+ ".concat(e.length, " ...");
  }
  function Ln(e, t) {
    var r = e.prefixCls,
      o = void 0 === r ? "rc-overflow" : r,
      u = e.data,
      a = void 0 === u ? [] : u,
      l = e.renderItem,
      f = e.renderRawItem,
      s = e.itemKey,
      p = e.itemWidth,
      v = void 0 === p ? 10 : p,
      d = e.ssr,
      g = e.style,
      y = e.className,
      b = e.maxCount,
      w = e.renderRest,
      E = e.renderRawRest,
      S = e.suffix,
      C = e.component,
      O = void 0 === C ? "div" : C,
      k = e.itemComponent,
      N = e.onVisibleChange,
      M = m(e, Pn),
      R = "full" === d,
      A = Cn(),
      P = h(xn(A, null), 2),
      I = P[0],
      D = P[1],
      T = I || 0,
      L = h(xn(A, new Map()), 2),
      j = L[0],
      V = L[1],
      z = h(xn(A, 0), 2),
      W = z[0],
      H = z[1],
      U = h(xn(A, 0), 2),
      K = U[0],
      B = U[1],
      $ = h(xn(A, 0), 2),
      Y = $[0],
      q = $[1],
      G = h(n.useState(null), 2),
      X = G[0],
      Z = G[1],
      Q = h(n.useState(null), 2),
      J = Q[0],
      ee = Q[1],
      ne = i.useMemo(function () {
        return null === J && R ? Number.MAX_SAFE_INTEGER : J || 0;
      }, [J, I]),
      te = h(n.useState(!1), 2),
      re = te[0],
      oe = te[1],
      ie = "".concat(o, "-item"),
      ue = Math.max(W, K),
      ae = b === In,
      ce = a.length && ae,
      le = b === Dn,
      fe = ce || "number" == typeof b && a.length > b,
      se = n.useMemo(function () {
        var e = a;
        return ce ? e = null === I && R ? a : a.slice(0, Math.min(a.length, T / v)) : "number" == typeof b && (e = a.slice(0, b)), e;
      }, [a, v, I, b, ce]),
      pe = n.useMemo(function () {
        return ce ? a.slice(ne + 1) : a.slice(se.length);
      }, [a, se, ce, ne]),
      ve = n.useCallback(function (e, n) {
        var t;
        return "function" == typeof s ? s(e) : null !== (t = s && (null == e ? void 0 : e[s])) && void 0 !== t ? t : n;
      }, [s]),
      de = n.useCallback(l || function (e) {
        return e;
      }, [l]);
    function he(e, n, t) {
      (J !== e || void 0 !== n && n !== X) && (ee(e), t || (oe(e < a.length - 1), null == N || N(e)), void 0 !== n && Z(n));
    }
    function me(e, n) {
      V(function (t) {
        var r = new Map(t);
        return null === n ? r.delete(e) : r.set(e, n), r;
      });
    }
    function ge(e) {
      return j.get(ve(se[e], e));
    }
    x(function () {
      if (T && "number" == typeof ue && se) {
        var e = Y,
          n = se.length,
          t = n - 1;
        if (!n) return void he(0, null);
        for (var r = 0; r < n; r += 1) {
          var o = ge(r);
          if (R && (o = o || 0), void 0 === o) {
            he(r - 1, void 0, !0);
            break;
          }
          if (e += o, 0 === t && e <= T || r === t - 1 && e + ge(t) <= T) {
            he(t, null);
            break;
          }
          if (e + ue > T) {
            he(r - 1, e - o - Y + K);
            break;
          }
        }
        S && ge(0) + Y > T && Z(null);
      }
    }, [T, j, K, Y, ve, se]);
    var ye = re && !!pe.length,
      be = {};
    null !== X && ce && (be = {
      position: "absolute",
      left: X,
      top: 0
    });
    var we,
      _e = {
        prefixCls: ie,
        responsive: ce,
        component: k,
        invalidate: le
      },
      Ee = f ? function (e, n) {
        var t = ve(e, n);
        return i.createElement(On.Provider, {
          key: t,
          value: _(_({}, _e), {}, {
            order: n,
            item: e,
            itemKey: t,
            registerSize: me,
            display: n <= ne
          })
        }, f(e, n));
      } : function (e, n) {
        var t = ve(e, n);
        return i.createElement(gn, c({}, _e, {
          order: n,
          key: t,
          item: e,
          renderItem: de,
          itemKey: t,
          registerSize: me,
          display: n <= ne
        }));
      },
      Se = {
        order: ye ? ne : Number.MAX_SAFE_INTEGER,
        className: "".concat(ie, "-rest"),
        registerSize: function (e, n) {
          B(n), H(K);
        },
        display: ye
      };
    if (E) E && (we = i.createElement(On.Provider, {
      value: _(_({}, _e), Se)
    }, E(pe)));else {
      var Ce = w || Tn;
      we = i.createElement(gn, c({}, _e, Se), "function" == typeof Ce ? Ce(pe) : Ce);
    }
    var xe = i.createElement(O, c({
      className: F(!le && o, y),
      style: g,
      ref: t
    }, M), se.map(Ee), fe ? we : null, S && i.createElement(gn, c({}, _e, {
      responsive: ae,
      responsiveDisabled: !ce,
      order: ne,
      className: "".concat(ie, "-suffix"),
      registerSize: function (e, n) {
        q(n);
      },
      display: !0,
      style: be
    }), S));
    return ae && (xe = i.createElement(vn, {
      onResize: function (e, n) {
        D(n.clientWidth);
      },
      disabled: !ce
    }, xe)), xe;
  }
  var jn = i.forwardRef(Ln);
  jn.displayName = "Overflow", jn.Item = An, jn.RESPONSIVE = In, jn.INVALIDATE = Dn;
  var Vn = function (e) {
      var n,
        t = e.className,
        r = e.customizeIcon,
        o = e.customizeIconProps,
        u = e.onMouseDown,
        a = e.onClick,
        c = e.children;
      return n = "function" == typeof r ? r(o) : r, i.createElement("span", {
        className: t,
        onMouseDown: function (e) {
          e.preventDefault(), u && u(e);
        },
        style: {
          userSelect: "none",
          WebkitUserSelect: "none"
        },
        unselectable: "on",
        onClick: a,
        "aria-hidden": !0
      }, void 0 !== n ? n : i.createElement("span", {
        className: F(t.split(/\s+/).map(function (e) {
          return "".concat(e, "-icon");
        }))
      }, c));
    },
    zn = function (e, n) {
      var t,
        r,
        o = e.prefixCls,
        u = e.id,
        a = e.inputElement,
        c = e.disabled,
        l = e.tabIndex,
        f = e.autoFocus,
        s = e.autoComplete,
        p = e.editable,
        v = e.activeDescendantId,
        d = e.value,
        h = e.maxLength,
        m = e.onKeyDown,
        g = e.onMouseDown,
        y = e.onChange,
        b = e.onPaste,
        w = e.onCompositionStart,
        E = e.onCompositionEnd,
        S = e.open,
        C = e.attrs,
        x = a || i.createElement("input", null),
        O = x,
        k = O.ref,
        N = O.props,
        M = N.onKeyDown,
        R = N.onChange,
        A = N.onMouseDown,
        I = N.onCompositionStart,
        D = N.onCompositionEnd,
        T = N.style;
      return P(!("maxLength" in x.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled."), x = i.cloneElement(x, _(_(_({
        type: "search"
      }, N), {}, {
        id: u,
        ref: ve(n, k),
        disabled: c,
        tabIndex: l,
        autoComplete: s || "off",
        autoFocus: f,
        className: F("".concat(o, "-selection-search-input"), null === (t = x) || void 0 === t || null === (r = t.props) || void 0 === r ? void 0 : r.className),
        role: "combobox",
        "aria-expanded": S,
        "aria-haspopup": "listbox",
        "aria-owns": "".concat(u, "_list"),
        "aria-autocomplete": "list",
        "aria-controls": "".concat(u, "_list"),
        "aria-activedescendant": v
      }, C), {}, {
        value: p ? d : "",
        maxLength: h,
        readOnly: !p,
        unselectable: p ? null : "on",
        style: _(_({}, T), {}, {
          opacity: p ? null : 0
        }),
        onKeyDown: function (e) {
          m(e), M && M(e);
        },
        onMouseDown: function (e) {
          g(e), A && A(e);
        },
        onChange: function (e) {
          y(e), R && R(e);
        },
        onCompositionStart: function (e) {
          w(e), I && I(e);
        },
        onCompositionEnd: function (e) {
          E(e), D && D(e);
        },
        onPaste: b
      }));
    },
    Fn = i.forwardRef(zn);
  function Wn(e) {
    return Array.isArray(e) ? e : void 0 !== e ? [e] : [];
  }
  Fn.displayName = "Input";
  var Hn = "undefined" != typeof window && window.document && window.document.documentElement,
    Un = "test" !== process.env.NODE_ENV && Hn;
  function Kn(e) {
    return ["string", "number"].includes(g(e));
  }
  function Bn(e) {
    var n = void 0;
    return e && (Kn(e.title) ? n = e.title.toString() : Kn(e.label) && (n = e.label.toString())), n;
  }
  function $n(e) {
    var n;
    return null !== (n = e.key) && void 0 !== n ? n : e.value;
  }
  var Yn = function (e) {
      e.preventDefault(), e.stopPropagation();
    },
    qn = function (e) {
      var t,
        r,
        o = e.id,
        u = e.prefixCls,
        a = e.values,
        c = e.open,
        l = e.searchValue,
        f = e.autoClearSearchValue,
        s = e.inputRef,
        p = e.placeholder,
        v = e.disabled,
        d = e.mode,
        m = e.showSearch,
        g = e.autoFocus,
        y = e.autoComplete,
        w = e.activeDescendantId,
        _ = e.tabIndex,
        E = e.removeIcon,
        S = e.maxTagCount,
        C = e.maxTagTextLength,
        x = e.maxTagPlaceholder,
        O = void 0 === x ? function (e) {
          return "+ ".concat(e.length, " ...");
        } : x,
        k = e.tagRender,
        N = e.onToggleOpen,
        M = e.onRemove,
        R = e.onInputChange,
        A = e.onInputPaste,
        P = e.onInputKeyDown,
        I = e.onInputMouseDown,
        D = e.onInputCompositionStart,
        T = e.onInputCompositionEnd,
        L = i.useRef(null),
        j = h(n.useState(0), 2),
        V = j[0],
        z = j[1],
        W = h(n.useState(!1), 2),
        H = W[0],
        U = W[1],
        K = "".concat(u, "-selection"),
        B = c || "multiple" === d && !1 === f || "tags" === d ? l : "",
        $ = "tags" === d || "multiple" === d && !1 === f || m && (c || H);
      function Y(e, n, t, r, o) {
        return i.createElement("span", {
          className: F("".concat(K, "-item"), b({}, "".concat(K, "-item-disabled"), t)),
          title: Bn(e)
        }, i.createElement("span", {
          className: "".concat(K, "-item-content")
        }, n), r && i.createElement(Vn, {
          className: "".concat(K, "-item-remove"),
          onMouseDown: Yn,
          onClick: o,
          customizeIcon: E
        }, "×"));
      }
      t = function () {
        z(L.current.scrollWidth);
      }, r = [B], Un ? i.useLayoutEffect(t, r) : i.useEffect(t, r);
      var q = i.createElement("div", {
          className: "".concat(K, "-search"),
          style: {
            width: V
          },
          onFocus: function () {
            U(!0);
          },
          onBlur: function () {
            U(!1);
          }
        }, i.createElement(Fn, {
          ref: s,
          open: c,
          prefixCls: u,
          id: o,
          inputElement: null,
          disabled: v,
          autoFocus: g,
          autoComplete: y,
          editable: $,
          activeDescendantId: w,
          value: B,
          onKeyDown: P,
          onMouseDown: I,
          onChange: R,
          onPaste: A,
          onCompositionStart: D,
          onCompositionEnd: T,
          tabIndex: _,
          attrs: Se(e, !0)
        }), i.createElement("span", {
          ref: L,
          className: "".concat(K, "-search-mirror"),
          "aria-hidden": !0
        }, B, " ")),
        G = i.createElement(jn, {
          prefixCls: "".concat(K, "-overflow"),
          data: a,
          renderItem: function (e) {
            var n = e.disabled,
              t = e.label,
              r = e.value,
              o = !v && !n,
              u = t;
            if ("number" == typeof C && ("string" == typeof t || "number" == typeof t)) {
              var a = String(u);
              a.length > C && (u = "".concat(a.slice(0, C), "..."));
            }
            var l = function (n) {
              n && n.stopPropagation(), M(e);
            };
            return "function" == typeof k ? function (e, n, t, r, o) {
              return i.createElement("span", {
                onMouseDown: function (e) {
                  Yn(e), N(!c);
                }
              }, k({
                label: n,
                value: e,
                disabled: t,
                closable: r,
                onClose: o
              }));
            }(r, u, n, o, l) : Y(e, u, n, o, l);
          },
          renderRest: function (e) {
            var n = "function" == typeof O ? O(e) : O;
            return Y({
              title: n
            }, n, !1);
          },
          suffix: q,
          itemKey: $n,
          maxCount: S
        });
      return i.createElement(i.Fragment, null, G, !a.length && !B && i.createElement("span", {
        className: "".concat(K, "-placeholder")
      }, p));
    },
    Gn = function (e) {
      var n = e.inputElement,
        t = e.prefixCls,
        r = e.id,
        o = e.inputRef,
        u = e.disabled,
        a = e.autoFocus,
        c = e.autoComplete,
        l = e.activeDescendantId,
        f = e.mode,
        s = e.open,
        p = e.values,
        v = e.placeholder,
        d = e.tabIndex,
        m = e.showSearch,
        g = e.searchValue,
        y = e.activeValue,
        b = e.maxLength,
        w = e.onInputKeyDown,
        _ = e.onInputMouseDown,
        E = e.onInputChange,
        S = e.onInputPaste,
        C = e.onInputCompositionStart,
        x = e.onInputCompositionEnd,
        O = h(i.useState(!1), 2),
        k = O[0],
        N = O[1],
        M = "combobox" === f,
        R = M || m,
        A = p[0],
        P = g || "";
      M && y && !k && (P = y), i.useEffect(function () {
        M && N(!1);
      }, [M, y]);
      var I = !("combobox" !== f && !s && !m) && !!P,
        D = Bn(A);
      return i.createElement(i.Fragment, null, i.createElement("span", {
        className: "".concat(t, "-selection-search")
      }, i.createElement(Fn, {
        ref: o,
        prefixCls: t,
        id: r,
        open: s,
        inputElement: n,
        disabled: u,
        autoFocus: a,
        autoComplete: c,
        editable: R,
        activeDescendantId: l,
        value: P,
        onKeyDown: w,
        onMouseDown: _,
        onChange: function (e) {
          N(!0), E(e);
        },
        onPaste: S,
        onCompositionStart: C,
        onCompositionEnd: x,
        tabIndex: d,
        attrs: Se(e, !0),
        maxLength: M ? b : void 0
      })), !M && A && !I && i.createElement("span", {
        className: "".concat(t, "-selection-item"),
        title: D
      }, A.label), function () {
        if (A) return null;
        var e = I ? {
          visibility: "hidden"
        } : void 0;
        return i.createElement("span", {
          className: "".concat(t, "-selection-placeholder"),
          style: e
        }, v);
      }());
    };
  var Xn = function (e, t) {
      var r = n.useRef(null),
        o = n.useRef(!1),
        u = e.prefixCls,
        a = e.open,
        l = e.mode,
        f = e.showSearch,
        s = e.tokenWithEnter,
        p = e.autoClearSearchValue,
        v = e.onSearch,
        d = e.onSearchSubmit,
        m = e.onToggleOpen,
        g = e.onInputKeyDown,
        y = e.domRef;
      i.useImperativeHandle(t, function () {
        return {
          focus: function () {
            r.current.focus();
          },
          blur: function () {
            r.current.blur();
          }
        };
      });
      var b = h(we(0), 2),
        w = b[0],
        _ = b[1],
        E = n.useRef(null),
        S = function (e) {
          !1 !== v(e, !0, o.current) && m(!0);
        },
        C = {
          inputRef: r,
          onInputKeyDown: function (e) {
            var n,
              t = e.which;
            t !== H.UP && t !== H.DOWN || e.preventDefault(), g && g(e), t !== H.ENTER || "tags" !== l || o.current || a || null == d || d(e.target.value), n = t, [H.ESC, H.SHIFT, H.BACKSPACE, H.TAB, H.WIN_KEY, H.ALT, H.META, H.WIN_KEY_RIGHT, H.CTRL, H.SEMICOLON, H.EQUALS, H.CAPS_LOCK, H.CONTEXT_MENU, H.F1, H.F2, H.F3, H.F4, H.F5, H.F6, H.F7, H.F8, H.F9, H.F10, H.F11, H.F12].includes(n) || m(!0);
          },
          onInputMouseDown: function () {
            _(!0);
          },
          onInputChange: function (e) {
            var n = e.target.value;
            if (s && E.current && /[\r\n]/.test(E.current)) {
              var t = E.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
              n = n.replace(t, E.current);
            }
            E.current = null, S(n);
          },
          onInputPaste: function (e) {
            var n = e.clipboardData.getData("text");
            E.current = n;
          },
          onInputCompositionStart: function () {
            o.current = !0;
          },
          onInputCompositionEnd: function (e) {
            o.current = !1, "combobox" !== l && S(e.target.value);
          }
        },
        x = "multiple" === l || "tags" === l ? i.createElement(qn, c({}, e, C)) : i.createElement(Gn, c({}, e, C));
      return i.createElement("div", {
        ref: y,
        className: "".concat(u, "-selector"),
        onClick: function (e) {
          e.target !== r.current && (void 0 !== document.body.style.msTouchAction ? setTimeout(function () {
            r.current.focus();
          }) : r.current.focus());
        },
        onMouseDown: function (e) {
          var n = w();
          e.target === r.current || n || "combobox" === l || e.preventDefault(), ("combobox" === l || f && n) && a || (a && !1 !== p && v("", !0, !1), m());
        }
      }, x);
    },
    Zn = i.forwardRef(Xn);
  Zn.displayName = "Selector";
  var Qn = i.createContext(null),
    Jn = [];
  var et = "data-rc-order",
    nt = "data-rc-priority",
    tt = new Map();
  function rt() {
    var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).mark;
    return e ? e.startsWith("data-") ? e : "data-".concat(e) : "rc-util-key";
  }
  function ot(e) {
    return e.attachTo ? e.attachTo : document.querySelector("head") || document.body;
  }
  function it(e) {
    return Array.from((tt.get(e) || e).children).filter(function (e) {
      return "STYLE" === e.tagName;
    });
  }
  function ut(e) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    if (!S()) return null;
    var t = n.csp,
      r = n.prepend,
      o = n.priority,
      i = void 0 === o ? 0 : o,
      u = function (e) {
        return "queue" === e ? "prependQueue" : e ? "prepend" : "append";
      }(r),
      a = "prependQueue" === u,
      c = document.createElement("style");
    c.setAttribute(et, u), a && i && c.setAttribute(nt, "".concat(i)), null != t && t.nonce && (c.nonce = null == t ? void 0 : t.nonce), c.innerHTML = e;
    var l = ot(n),
      f = l.firstChild;
    if (r) {
      if (a) {
        var s = (n.styles || it(l)).filter(function (e) {
          if (!["prepend", "prependQueue"].includes(e.getAttribute(et))) return !1;
          var n = Number(e.getAttribute(nt) || 0);
          return i >= n;
        });
        if (s.length) return l.insertBefore(c, s[s.length - 1].nextSibling), c;
      }
      l.insertBefore(c, f);
    } else l.appendChild(c);
    return c;
  }
  function at(e) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      t = ot(n);
    return (n.styles || it(t)).find(function (t) {
      return t.getAttribute(rt(n)) === e;
    });
  }
  function ct(e) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      t = at(e, n);
    t && ot(n).removeChild(t);
  }
  function lt(e, n) {
    var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
      r = ot(t),
      o = it(r),
      i = _(_({}, t), {}, {
        styles: o
      });
    !function (e, n) {
      var t = tt.get(e);
      if (!t || !function (e, n) {
        if (!e) return !1;
        if (e.contains) return e.contains(n);
        for (var t = n; t;) {
          if (t === e) return !0;
          t = t.parentNode;
        }
        return !1;
      }(document, t)) {
        var r = ut("", n),
          o = r.parentNode;
        tt.set(e, o), e.removeChild(r);
      }
    }(r, i);
    var u = at(n, i);
    if (u) {
      var a, c, l;
      if (null !== (a = i.csp) && void 0 !== a && a.nonce && u.nonce !== (null === (c = i.csp) || void 0 === c ? void 0 : c.nonce)) u.nonce = null === (l = i.csp) || void 0 === l ? void 0 : l.nonce;
      return u.innerHTML !== e && (u.innerHTML = e), u;
    }
    var f = ut(e, i);
    return f.setAttribute(rt(i), n), f;
  }
  function ft(e) {
    return "undefined" != typeof document && e && e instanceof Element ? function (e) {
      var n = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7)),
        t = document.createElement("div");
      t.id = n;
      var r,
        o,
        i = t.style;
      if (i.position = "absolute", i.left = "0", i.top = "0", i.width = "100px", i.height = "100px", i.overflow = "scroll", e) {
        var u = getComputedStyle(e);
        i.scrollbarColor = u.scrollbarColor, i.scrollbarWidth = u.scrollbarWidth;
        var a = getComputedStyle(e, "::-webkit-scrollbar"),
          c = parseInt(a.width, 10),
          l = parseInt(a.height, 10);
        try {
          var f = c ? "width: ".concat(a.width, ";") : "",
            s = l ? "height: ".concat(a.height, ";") : "";
          lt("\n#".concat(n, "::-webkit-scrollbar {\n").concat(f, "\n").concat(s, "\n}"), n);
        } catch (e) {
          console.error(e), r = c, o = l;
        }
      }
      document.body.appendChild(t);
      var p = e && r && !isNaN(r) ? r : t.offsetWidth - t.clientWidth,
        v = e && o && !isNaN(o) ? o : t.offsetHeight - t.clientHeight;
      return document.body.removeChild(t), ct(n), {
        width: p,
        height: v
      };
    }(e) : {
      width: 0,
      height: 0
    };
  }
  var st = "rc-util-locker-".concat(Date.now()),
    pt = 0;
  function vt(e) {
    var n = !!e,
      t = h(i.useState(function () {
        return pt += 1, "".concat(st, "_").concat(pt);
      }), 1)[0];
    x(function () {
      if (n) {
        var e = ft(document.body).width,
          r = document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
        lt("\nhtml body {\n  overflow-y: hidden;\n  ".concat(r ? "width: calc(100% - ".concat(e, "px);") : "", "\n}"), t);
      } else ct(t);
      return function () {
        ct(t);
      };
    }, [n, t]);
  }
  var dt = !1;
  var ht = function (e) {
      return !1 !== e && (S() && e ? "string" == typeof e ? document.querySelector(e) : "function" == typeof e ? e() : e : null);
    },
    mt = i.forwardRef(function (e, n) {
      var r = e.open,
        o = e.autoLock,
        u = e.getContainer,
        a = e.debug,
        c = e.autoDestroy,
        l = void 0 === c || c,
        f = e.children,
        s = h(i.useState(r), 2),
        v = s[0],
        d = s[1],
        m = v || r;
      "production" !== process.env.NODE_ENV && T(S() || !r, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), i.useEffect(function () {
        (l || r) && d(r);
      }, [r, l]);
      var g = h(i.useState(function () {
          return ht(u);
        }), 2),
        y = g[0],
        b = g[1];
      i.useEffect(function () {
        var e = ht(u);
        b(null != e ? e : null);
      });
      var w = function (e, n) {
          var t = h(i.useState(function () {
              if (!S()) return null;
              var e = document.createElement("div");
              return "production" !== process.env.NODE_ENV && n && e.setAttribute("data-debug", n), e;
            }), 1)[0],
            r = i.useRef(!1),
            o = i.useContext(Qn),
            u = h(i.useState(Jn), 2),
            a = u[0],
            c = u[1],
            l = o || (r.current ? void 0 : function (e) {
              c(function (n) {
                return [e].concat(p(n));
              });
            });
          function f() {
            t.parentElement || document.body.appendChild(t), r.current = !0;
          }
          function s() {
            var e;
            null === (e = t.parentElement) || void 0 === e || e.removeChild(t), r.current = !1;
          }
          return x(function () {
            return e ? o ? o(f) : f() : s(), s;
          }, [e]), x(function () {
            a.length && (a.forEach(function (e) {
              return e();
            }), c(Jn));
          }, [a]), [t, l];
        }(m && !y, a),
        _ = h(w, 2),
        E = _[0],
        C = _[1],
        O = null != y ? y : E;
      vt(o && r && S() && (O === E || O === document.body));
      var k = null;
      f && he(f) && n && (k = f.ref);
      var N = de(k, n);
      if (!m || !S() || void 0 === y) return null;
      var M,
        R = !1 === O || ("boolean" == typeof M && (dt = M), dt),
        A = f;
      return n && (A = i.cloneElement(f, {
        ref: N
      })), i.createElement(Qn.Provider, {
        value: C
      }, R ? A : t.createPortal(A, O));
    });
  function gt(e) {
    var n;
    return null == e || null === (n = e.getRootNode) || void 0 === n ? void 0 : n.call(e);
  }
  function yt(e) {
    return function (e) {
      return gt(e) instanceof ShadowRoot;
    }(e) ? gt(e) : null;
  }
  "production" !== process.env.NODE_ENV && (mt.displayName = "Portal");
  var bt = 0,
    wt = _({}, i).useId,
    _t = wt ? function (e) {
      var n = wt();
      return e || ("test" === process.env.NODE_ENV ? "test-id" : n);
    } : function (e) {
      var n = h(i.useState("ssr-id"), 2),
        t = n[0],
        r = n[1];
      return i.useEffect(function () {
        var e = bt;
        bt += 1, r("rc_unique_".concat(e));
      }, []), e || ("test" === process.env.NODE_ENV ? "test-id" : t);
    },
    Et = i.createContext({}),
    St = function (e) {
      rn(t, e);
      var n = cn(t);
      function t() {
        return Je(this, t), n.apply(this, arguments);
      }
      return nn(t, [{
        key: "render",
        value: function () {
          return this.props.children;
        }
      }]), t;
    }(i.Component);
  var Ct = "none",
    xt = "appear",
    Ot = "enter",
    kt = "leave",
    Nt = "none",
    Mt = "prepare",
    Rt = "start",
    At = "active",
    Pt = "end",
    It = "prepared";
  function Dt(e, n) {
    var t = {};
    return t[e.toLowerCase()] = n.toLowerCase(), t["Webkit".concat(e)] = "webkit".concat(n), t["Moz".concat(e)] = "moz".concat(n), t["ms".concat(e)] = "MS".concat(n), t["O".concat(e)] = "o".concat(n.toLowerCase()), t;
  }
  var Tt,
    Lt,
    jt,
    Vt = (Tt = S(), Lt = "undefined" != typeof window ? window : {}, jt = {
      animationend: Dt("Animation", "AnimationEnd"),
      transitionend: Dt("Transition", "TransitionEnd")
    }, Tt && ("AnimationEvent" in Lt || delete jt.animationend.animation, "TransitionEvent" in Lt || delete jt.transitionend.transition), jt),
    zt = {};
  if (S()) {
    var Ft = document.createElement("div");
    zt = Ft.style;
  }
  var Wt = {};
  function Ht(e) {
    if (Wt[e]) return Wt[e];
    var n = Vt[e];
    if (n) for (var t = Object.keys(n), r = t.length, o = 0; o < r; o += 1) {
      var i = t[o];
      if (Object.prototype.hasOwnProperty.call(n, i) && i in zt) return Wt[e] = n[i], Wt[e];
    }
    return "";
  }
  var Ut = Ht("animationend"),
    Kt = Ht("transitionend"),
    Bt = !(!Ut || !Kt),
    $t = Ut || "animationend",
    Yt = Kt || "transitionend";
  function qt(e, n) {
    if (!e) return null;
    if ("object" === g(e)) {
      var t = n.replace(/-\w/g, function (e) {
        return e[1].toUpperCase();
      });
      return e[t];
    }
    return "".concat(e, "-").concat(n);
  }
  var Gt = S() ? n.useLayoutEffect : n.useEffect,
    Xt = [Mt, Rt, At, Pt],
    Zt = [Mt, It],
    Qt = !1;
  function Jt(e) {
    return e === At || e === Pt;
  }
  var er = function (e, n, t) {
    var r = h(k(Nt), 2),
      o = r[0],
      u = r[1],
      a = function () {
        var e = i.useRef(null);
        function n() {
          Sn.cancel(e.current);
        }
        return i.useEffect(function () {
          return function () {
            n();
          };
        }, []), [function t(r) {
          var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2;
          n();
          var i = Sn(function () {
            o <= 1 ? r({
              isCanceled: function () {
                return i !== e.current;
              }
            }) : t(r, o - 1);
          });
          e.current = i;
        }, n];
      }(),
      c = h(a, 2),
      l = c[0],
      f = c[1];
    var s = n ? Zt : Xt;
    return Gt(function () {
      if (o !== Nt && o !== Pt) {
        var e = s.indexOf(o),
          n = s[e + 1],
          r = t(o);
        r === Qt ? u(n, !0) : n && l(function (e) {
          function t() {
            e.isCanceled() || u(n, !0);
          }
          !0 === r ? t() : Promise.resolve(r).then(t);
        });
      }
    }, [e, o]), i.useEffect(function () {
      return function () {
        f();
      };
    }, []), [function () {
      u(Mt, !0);
    }, o];
  };
  function nr(e, t, r, o) {
    var u,
      a,
      c,
      l = o.motionEnter,
      f = void 0 === l || l,
      s = o.motionAppear,
      p = void 0 === s || s,
      v = o.motionLeave,
      d = void 0 === v || v,
      m = o.motionDeadline,
      g = o.motionLeaveImmediately,
      y = o.onAppearPrepare,
      w = o.onEnterPrepare,
      S = o.onLeavePrepare,
      C = o.onAppearStart,
      x = o.onEnterStart,
      O = o.onLeaveStart,
      N = o.onAppearActive,
      M = o.onEnterActive,
      R = o.onLeaveActive,
      A = o.onAppearEnd,
      P = o.onEnterEnd,
      I = o.onLeaveEnd,
      D = o.onVisibleChanged,
      T = h(k(), 2),
      L = T[0],
      j = T[1],
      V = (u = Ct, a = h(i.useReducer(function (e) {
        return e + 1;
      }, 0), 2)[1], c = i.useRef(u), [E(function () {
        return c.current;
      }), E(function (e) {
        c.current = "function" == typeof e ? e(c.current) : e, a();
      })]),
      z = h(V, 2),
      F = z[0],
      W = z[1],
      H = h(k(null), 2),
      U = H[0],
      K = H[1],
      B = F(),
      $ = n.useRef(!1),
      Y = n.useRef(null);
    function q() {
      return r();
    }
    var G = n.useRef(!1);
    function X() {
      W(Ct), K(null, !0);
    }
    var Z = E(function (e) {
        var n = F();
        if (n !== Ct) {
          var t = q();
          if (!e || e.deadline || e.target === t) {
            var r,
              o = G.current;
            n === xt && o ? r = null == A ? void 0 : A(t, e) : n === Ot && o ? r = null == P ? void 0 : P(t, e) : n === kt && o && (r = null == I ? void 0 : I(t, e)), o && !1 !== r && X();
          }
        }
      }),
      Q = function (e) {
        var t = n.useRef();
        function r(n) {
          n && (n.removeEventListener(Yt, e), n.removeEventListener($t, e));
        }
        return i.useEffect(function () {
          return function () {
            r(t.current);
          };
        }, []), [function (n) {
          t.current && t.current !== n && r(t.current), n && n !== t.current && (n.addEventListener(Yt, e), n.addEventListener($t, e), t.current = n);
        }, r];
      }(Z),
      J = h(Q, 1)[0],
      ee = function (e) {
        switch (e) {
          case xt:
            return b(b(b({}, Mt, y), Rt, C), At, N);
          case Ot:
            return b(b(b({}, Mt, w), Rt, x), At, M);
          case kt:
            return b(b(b({}, Mt, S), Rt, O), At, R);
          default:
            return {};
        }
      },
      ne = i.useMemo(function () {
        return ee(B);
      }, [B]),
      te = h(er(B, !e, function (e) {
        if (e === Mt) {
          var n = ne[Mt];
          return n ? n(q()) : Qt;
        }
        var t;
        oe in ne && K((null === (t = ne[oe]) || void 0 === t ? void 0 : t.call(ne, q(), null)) || null);
        return oe === At && B !== Ct && (J(q()), m > 0 && (clearTimeout(Y.current), Y.current = setTimeout(function () {
          Z({
            deadline: !0
          });
        }, m))), oe === It && X(), true;
      }), 2),
      re = te[0],
      oe = te[1],
      ie = Jt(oe);
    G.current = ie, Gt(function () {
      j(t);
      var n,
        r = $.current;
      $.current = !0, !r && t && p && (n = xt), r && t && f && (n = Ot), (r && !t && d || !r && g && !t && d) && (n = kt);
      var o = ee(n);
      n && (e || o[Mt]) ? (W(n), re()) : W(Ct);
    }, [t]), n.useEffect(function () {
      (B === xt && !p || B === Ot && !f || B === kt && !d) && W(Ct);
    }, [p, f, d]), n.useEffect(function () {
      return function () {
        $.current = !1, clearTimeout(Y.current);
      };
    }, []);
    var ue = i.useRef(!1);
    n.useEffect(function () {
      L && (ue.current = !0), void 0 !== L && B === Ct && ((ue.current || L) && (null == D || D(L)), ue.current = !0);
    }, [L, B]);
    var ae = U;
    return ne[Mt] && oe === Rt && (ae = _({
      transition: "none"
    }, ae)), [B, oe, ae, null != L ? L : t];
  }
  var tr = function (e) {
      var t = e;
      "object" === g(e) && (t = e.transitionSupport);
      var r = i.forwardRef(function (e, r) {
        var o = e.visible,
          u = void 0 === o || o,
          a = e.removeOnLeave,
          c = void 0 === a || a,
          l = e.forceRender,
          f = e.children,
          s = e.motionName,
          p = e.leavedClassName,
          v = e.eventProps,
          d = function (e, n) {
            return !(!e.motionName || !t || !1 === n);
          }(e, i.useContext(Et).motion),
          m = n.useRef(),
          g = n.useRef();
        var y = h(nr(d, u, function () {
            try {
              return m.current instanceof HTMLElement ? m.current : Oe(g.current);
            } catch (e) {
              return null;
            }
          }, e), 4),
          w = y[0],
          E = y[1],
          S = y[2],
          C = y[3],
          x = i.useRef(C);
        C && (x.current = !0);
        var O,
          k = i.useCallback(function (e) {
            m.current = e, pe(r, e);
          }, [r]),
          N = _(_({}, v), {}, {
            visible: u
          });
        if (f) {
          if (w === Ct) O = C ? f(_({}, N), k) : !c && x.current && p ? f(_(_({}, N), {}, {
            className: p
          }), k) : l || !c && !p ? f(_(_({}, N), {}, {
            style: {
              display: "none"
            }
          }), k) : null;else {
            var M;
            E === Mt ? M = "prepare" : Jt(E) ? M = "active" : E === Rt && (M = "start");
            var R = qt(s, "".concat(w, "-").concat(M));
            O = f(_(_({}, N), {}, {
              className: F(qt(s, w), b(b({}, R, R && M), s, "string" == typeof s)),
              style: S
            }), k);
          }
        } else O = null;
        i.isValidElement(O) && he(O) && (ge(O) || (O = i.cloneElement(O, {
          ref: k
        })));
        return i.createElement(St, {
          ref: g
        }, O);
      });
      return r.displayName = "CSSMotion", r;
    }(Bt),
    rr = "add",
    or = "keep",
    ir = "remove",
    ur = "removed";
  function ar(e) {
    var n;
    return _(_({}, n = e && "object" === g(e) && "key" in e ? e : {
      key: e
    }), {}, {
      key: String(n.key)
    });
  }
  function cr() {
    return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).map(ar);
  }
  var lr = ["component", "children", "onVisibleChanged", "onAllRemoved"],
    fr = ["status"],
    sr = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
  function pr(e) {
    var n = e.prefixCls,
      t = e.align,
      r = e.arrow,
      o = e.arrowPos,
      u = r || {},
      a = u.className,
      c = u.content,
      l = o.x,
      f = void 0 === l ? 0 : l,
      s = o.y,
      p = void 0 === s ? 0 : s,
      v = i.useRef();
    if (!t || !t.points) return null;
    var d = {
      position: "absolute"
    };
    if (!1 !== t.autoArrow) {
      var h = t.points[0],
        m = t.points[1],
        g = h[0],
        y = h[1],
        b = m[0],
        w = m[1];
      g !== b && ["t", "b"].includes(g) ? "t" === g ? d.top = 0 : d.bottom = 0 : d.top = p, y !== w && ["l", "r"].includes(y) ? "l" === y ? d.left = 0 : d.right = 0 : d.left = f;
    }
    return i.createElement("div", {
      ref: v,
      className: F("".concat(n, "-arrow"), a),
      style: d
    }, c);
  }
  function vr(e) {
    var n = e.prefixCls,
      t = e.open,
      r = e.zIndex,
      o = e.mask,
      u = e.motion;
    return o ? i.createElement(tr, c({}, u, {
      motionAppear: !0,
      visible: t,
      removeOnLeave: !0
    }), function (e) {
      var t = e.className;
      return i.createElement("div", {
        style: {
          zIndex: r
        },
        className: F("".concat(n, "-mask"), t)
      });
    }) : null;
  }
  !function () {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : tr,
      n = function (n) {
        rn(r, n);
        var t = cn(r);
        function r() {
          var e;
          Je(this, r);
          for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++) o[i] = arguments[i];
          return b(an(e = t.call.apply(t, [this].concat(o))), "state", {
            keyEntities: []
          }), b(an(e), "removeKey", function (n) {
            e.setState(function (e) {
              return {
                keyEntities: e.keyEntities.map(function (e) {
                  return e.key !== n ? e : _(_({}, e), {}, {
                    status: ur
                  });
                })
              };
            }, function () {
              0 === e.state.keyEntities.filter(function (e) {
                return e.status !== ur;
              }).length && e.props.onAllRemoved && e.props.onAllRemoved();
            });
          }), e;
        }
        return nn(r, [{
          key: "render",
          value: function () {
            var n = this,
              t = this.state.keyEntities,
              r = this.props,
              o = r.component,
              u = r.children,
              a = r.onVisibleChanged;
            r.onAllRemoved;
            var l = m(r, lr),
              f = o || i.Fragment,
              s = {};
            return sr.forEach(function (e) {
              s[e] = l[e], delete l[e];
            }), delete l.keys, i.createElement(f, l, t.map(function (t, r) {
              var o = t.status,
                l = m(t, fr),
                f = o === rr || o === or;
              return i.createElement(e, c({}, s, {
                key: l.key,
                visible: f,
                eventProps: l,
                onVisibleChanged: function (e) {
                  null == a || a(e, {
                    key: l.key
                  }), e || n.removeKey(l.key);
                }
              }), function (e, n) {
                return u(_(_({}, e), {}, {
                  index: r
                }), n);
              });
            }));
          }
        }], [{
          key: "getDerivedStateFromProps",
          value: function (e, n) {
            var t = e.keys,
              r = n.keyEntities,
              o = cr(t),
              i = function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                  n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
                  t = [],
                  r = 0,
                  o = n.length,
                  i = cr(e),
                  u = cr(n);
                i.forEach(function (e) {
                  for (var n = !1, i = r; i < o; i += 1) {
                    var a = u[i];
                    if (a.key === e.key) {
                      r < i && (t = t.concat(u.slice(r, i).map(function (e) {
                        return _(_({}, e), {}, {
                          status: rr
                        });
                      })), r = i), t.push(_(_({}, a), {}, {
                        status: or
                      })), r += 1, n = !0;
                      break;
                    }
                  }
                  n || t.push(_(_({}, e), {}, {
                    status: ir
                  }));
                }), r < o && (t = t.concat(u.slice(r).map(function (e) {
                  return _(_({}, e), {}, {
                    status: rr
                  });
                })));
                var a = {};
                return t.forEach(function (e) {
                  var n = e.key;
                  a[n] = (a[n] || 0) + 1;
                }), Object.keys(a).filter(function (e) {
                  return a[e] > 1;
                }).forEach(function (e) {
                  (t = t.filter(function (n) {
                    var t = n.key,
                      r = n.status;
                    return t !== e || r !== ir;
                  })).forEach(function (n) {
                    n.key === e && (n.status = or);
                  });
                }), t;
              }(r, o);
            return {
              keyEntities: i.filter(function (e) {
                var n = r.find(function (n) {
                  var t = n.key;
                  return e.key === t;
                });
                return !n || n.status !== ur || e.status !== ir;
              })
            };
          }
        }]), r;
      }(i.Component);
    b(n, "defaultProps", {
      component: "div"
    });
  }(Bt);
  var dr = i.memo(function (e) {
    return e.children;
  }, function (e, n) {
    return n.cache;
  });
  "production" !== process.env.NODE_ENV && (dr.displayName = "PopupContent");
  var hr = i.forwardRef(function (e, n) {
    var t = e.popup,
      r = e.className,
      o = e.prefixCls,
      u = e.style,
      a = e.target,
      l = e.onVisibleChanged,
      f = e.open,
      s = e.keepDom,
      p = e.fresh,
      v = e.onClick,
      d = e.mask,
      m = e.arrow,
      g = e.arrowPos,
      y = e.align,
      b = e.motion,
      w = e.maskMotion,
      E = e.forceRender,
      S = e.getPopupContainer,
      C = e.autoDestroy,
      O = e.portal,
      k = e.zIndex,
      N = e.onMouseEnter,
      M = e.onMouseLeave,
      R = e.onPointerEnter,
      A = e.ready,
      P = e.offsetX,
      I = e.offsetY,
      D = e.offsetR,
      T = e.offsetB,
      L = e.onAlign,
      j = e.onPrepare,
      V = e.stretch,
      z = e.targetWidth,
      W = e.targetHeight,
      H = "function" == typeof t ? t() : t,
      U = f || s,
      K = (null == S ? void 0 : S.length) > 0,
      B = h(i.useState(!S || !K), 2),
      $ = B[0],
      Y = B[1];
    if (x(function () {
      !$ && K && a && Y(!0);
    }, [$, K, a]), !$) return null;
    var q = "auto",
      G = {
        left: "-1000vw",
        top: "-1000vh",
        right: q,
        bottom: q
      };
    if (A || !f) {
      var X,
        Z = y.points,
        Q = y.dynamicInset || (null === (X = y._experimental) || void 0 === X ? void 0 : X.dynamicInset),
        J = Q && "r" === Z[0][1],
        ee = Q && "b" === Z[0][0];
      J ? (G.right = D, G.left = q) : (G.left = P, G.right = q), ee ? (G.bottom = T, G.top = q) : (G.top = I, G.bottom = q);
    }
    var ne = {};
    return V && (V.includes("height") && W ? ne.height = W : V.includes("minHeight") && W && (ne.minHeight = W), V.includes("width") && z ? ne.width = z : V.includes("minWidth") && z && (ne.minWidth = z)), f || (ne.pointerEvents = "none"), i.createElement(O, {
      open: E || U,
      getContainer: S && function () {
        return S(a);
      },
      autoDestroy: C
    }, i.createElement(vr, {
      prefixCls: o,
      open: f,
      zIndex: k,
      mask: d,
      motion: w
    }), i.createElement(vn, {
      onResize: L,
      disabled: !f
    }, function (e) {
      return i.createElement(tr, c({
        motionAppear: !0,
        motionEnter: !0,
        motionLeave: !0,
        removeOnLeave: !1,
        forceRender: E,
        leavedClassName: "".concat(o, "-hidden")
      }, b, {
        onAppearPrepare: j,
        onEnterPrepare: j,
        visible: f,
        onVisibleChanged: function (e) {
          var n;
          null == b || null === (n = b.onVisibleChanged) || void 0 === n || n.call(b, e), l(e);
        }
      }), function (t, a) {
        var c = t.className,
          l = t.style,
          s = F(o, c, r);
        return i.createElement("div", {
          ref: ve(e, n, a),
          className: s,
          style: _(_(_(_({
            "--arrow-x": "".concat(g.x || 0, "px"),
            "--arrow-y": "".concat(g.y || 0, "px")
          }, G), ne), l), {}, {
            boxSizing: "border-box",
            zIndex: k
          }, u),
          onMouseEnter: N,
          onMouseLeave: M,
          onPointerEnter: R,
          onClick: v
        }, m && i.createElement(pr, {
          prefixCls: o,
          arrow: m,
          arrowPos: g,
          align: y
        }), i.createElement(dr, {
          cache: !f && !p
        }, H));
      });
    }));
  });
  "production" !== process.env.NODE_ENV && (hr.displayName = "Popup");
  var mr = i.forwardRef(function (e, n) {
    var t = e.children,
      r = e.getTriggerDOMNode,
      o = he(t),
      u = i.useCallback(function (e) {
        pe(n, r ? r(e) : e);
      }, [r]),
      a = de(u, t.ref);
    return o ? i.cloneElement(t, {
      ref: a
    }) : t;
  });
  "production" !== process.env.NODE_ENV && (mr.displayName = "TriggerWrapper");
  var gr = i.createContext(null);
  function yr(e) {
    return e ? Array.isArray(e) ? e : [e] : [];
  }
  function br() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
      n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
    return (arguments.length > 2 ? arguments[2] : void 0) ? e[0] === n[0] : e[0] === n[0] && e[1] === n[1];
  }
  function wr(e, n, t, r) {
    return n || (t ? {
      motionName: "".concat(e, "-").concat(t)
    } : r ? {
      motionName: r
    } : null);
  }
  function _r(e) {
    return e.ownerDocument.defaultView;
  }
  function Er(e) {
    for (var n = [], t = null == e ? void 0 : e.parentElement, r = ["hidden", "scroll", "clip", "auto"]; t;) {
      var o = _r(t).getComputedStyle(t);
      [o.overflowX, o.overflowY, o.overflow].some(function (e) {
        return r.includes(e);
      }) && n.push(t), t = t.parentElement;
    }
    return n;
  }
  function Sr(e) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
    return Number.isNaN(e) ? n : e;
  }
  function Cr(e) {
    return Sr(parseFloat(e), 0);
  }
  function xr(e, n) {
    var t = _({}, e);
    return (n || []).forEach(function (e) {
      if (!(e instanceof HTMLBodyElement || e instanceof HTMLHtmlElement)) {
        var n = _r(e).getComputedStyle(e),
          r = n.overflow,
          o = n.overflowClipMargin,
          i = n.borderTopWidth,
          u = n.borderBottomWidth,
          a = n.borderLeftWidth,
          c = n.borderRightWidth,
          l = e.getBoundingClientRect(),
          f = e.offsetHeight,
          s = e.clientHeight,
          p = e.offsetWidth,
          v = e.clientWidth,
          d = Cr(i),
          h = Cr(u),
          m = Cr(a),
          g = Cr(c),
          y = Sr(Math.round(l.width / p * 1e3) / 1e3),
          b = Sr(Math.round(l.height / f * 1e3) / 1e3),
          w = (p - v - m - g) * y,
          _ = (f - s - d - h) * b,
          E = d * b,
          S = h * b,
          C = m * y,
          x = g * y,
          O = 0,
          k = 0;
        if ("clip" === r) {
          var N = Cr(o);
          O = N * y, k = N * b;
        }
        var M = l.x + C - O,
          R = l.y + E - k,
          A = M + l.width + 2 * O - C - x - w,
          P = R + l.height + 2 * k - E - S - _;
        t.left = Math.max(t.left, M), t.top = Math.max(t.top, R), t.right = Math.min(t.right, A), t.bottom = Math.min(t.bottom, P);
      }
    }), t;
  }
  function Or(e) {
    var n = "".concat(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0),
      t = n.match(/^(.*)\%$/);
    return t ? e * (parseFloat(t[1]) / 100) : parseFloat(n);
  }
  function kr(e, n) {
    var t = h(n || [], 2),
      r = t[0],
      o = t[1];
    return [Or(e.width, r), Or(e.height, o)];
  }
  function Nr() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
    return [e[0], e[1]];
  }
  function Mr(e, n) {
    var t,
      r = n[0],
      o = n[1];
    return t = "t" === r ? e.y : "b" === r ? e.y + e.height : e.y + e.height / 2, {
      x: "l" === o ? e.x : "r" === o ? e.x + e.width : e.x + e.width / 2,
      y: t
    };
  }
  function Rr(e, n) {
    var t = {
      t: "b",
      b: "t",
      l: "r",
      r: "l"
    };
    return e.map(function (e, r) {
      return r === n ? t[e] || "c" : e;
    }).join("");
  }
  function Ar(e, n, t, r, o, u, a) {
    var c = h(i.useState({
        ready: !1,
        offsetX: 0,
        offsetY: 0,
        offsetR: 0,
        offsetB: 0,
        arrowX: 0,
        arrowY: 0,
        scaleX: 1,
        scaleY: 1,
        align: o[r] || {}
      }), 2),
      l = c[0],
      f = c[1],
      s = i.useRef(0),
      p = i.useMemo(function () {
        return n ? Er(n) : [];
      }, [n]),
      v = i.useRef({});
    e || (v.current = {});
    var d = E(function () {
        if (n && t && e) {
          var i,
            c,
            l,
            s = n,
            d = s.ownerDocument,
            m = _r(s).getComputedStyle(s),
            g = m.width,
            y = m.height,
            b = m.position,
            w = s.style.left,
            E = s.style.top,
            S = s.style.right,
            C = s.style.bottom,
            x = s.style.overflow,
            O = _(_({}, o[r]), u),
            k = d.createElement("div");
          if (null === (i = s.parentElement) || void 0 === i || i.appendChild(k), k.style.left = "".concat(s.offsetLeft, "px"), k.style.top = "".concat(s.offsetTop, "px"), k.style.position = b, k.style.height = "".concat(s.offsetHeight, "px"), k.style.width = "".concat(s.offsetWidth, "px"), s.style.left = "0", s.style.top = "0", s.style.right = "auto", s.style.bottom = "auto", s.style.overflow = "hidden", Array.isArray(t)) l = {
            x: t[0],
            y: t[1],
            width: 0,
            height: 0
          };else {
            var N = t.getBoundingClientRect();
            l = {
              x: N.x,
              y: N.y,
              width: N.width,
              height: N.height
            };
          }
          var M = s.getBoundingClientRect(),
            R = d.documentElement,
            A = R.clientWidth,
            P = R.clientHeight,
            I = R.scrollWidth,
            D = R.scrollHeight,
            T = R.scrollTop,
            L = R.scrollLeft,
            j = M.height,
            V = M.width,
            z = l.height,
            F = l.width,
            W = {
              left: 0,
              top: 0,
              right: A,
              bottom: P
            },
            H = {
              left: -L,
              top: -T,
              right: I - L,
              bottom: D - T
            },
            U = O.htmlRegion,
            K = "visible",
            B = "visibleFirst";
          "scroll" !== U && U !== B && (U = K);
          var $ = U === B,
            Y = xr(H, p),
            q = xr(W, p),
            G = U === K ? q : Y,
            X = $ ? q : G;
          s.style.left = "auto", s.style.top = "auto", s.style.right = "0", s.style.bottom = "0";
          var Z = s.getBoundingClientRect();
          s.style.left = w, s.style.top = E, s.style.right = S, s.style.bottom = C, s.style.overflow = x, null === (c = s.parentElement) || void 0 === c || c.removeChild(k);
          var Q = Sr(Math.round(V / parseFloat(g) * 1e3) / 1e3),
            J = Sr(Math.round(j / parseFloat(y) * 1e3) / 1e3);
          if (0 === Q || 0 === J || xe(t) && !function (e) {
            if (!e) return !1;
            if (e instanceof Element) {
              if (e.offsetParent) return !0;
              if (e.getBBox) {
                var n = e.getBBox(),
                  t = n.width,
                  r = n.height;
                if (t || r) return !0;
              }
              if (e.getBoundingClientRect) {
                var o = e.getBoundingClientRect(),
                  i = o.width,
                  u = o.height;
                if (i || u) return !0;
              }
            }
            return !1;
          }(t)) return;
          var ee = O.offset,
            ne = O.targetOffset,
            te = h(kr(M, ee), 2),
            re = te[0],
            oe = te[1],
            ie = h(kr(l, ne), 2),
            ue = ie[0],
            ae = ie[1];
          l.x -= ue, l.y -= ae;
          var ce = h(O.points || [], 2),
            le = ce[0],
            fe = Nr(ce[1]),
            se = Nr(le),
            pe = Mr(l, fe),
            ve = Mr(M, se),
            de = _({}, O),
            he = pe.x - ve.x + re,
            me = pe.y - ve.y + oe;
          function sn(e, n) {
            var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : G,
              r = M.x + e,
              o = M.y + n,
              i = r + V,
              u = o + j,
              a = Math.max(r, t.left),
              c = Math.max(o, t.top),
              l = Math.min(i, t.right),
              f = Math.min(u, t.bottom);
            return Math.max(0, (l - a) * (f - c));
          }
          var ge,
            ye,
            be,
            we,
            _e = sn(he, me),
            Ee = sn(he, me, q),
            Se = Mr(l, ["t", "l"]),
            Ce = Mr(M, ["t", "l"]),
            Oe = Mr(l, ["b", "r"]),
            ke = Mr(M, ["b", "r"]),
            Ne = O.overflow || {},
            Me = Ne.adjustX,
            Re = Ne.adjustY,
            Ae = Ne.shiftX,
            Pe = Ne.shiftY,
            Ie = function (e) {
              return "boolean" == typeof e ? e : e >= 0;
            };
          function pn() {
            ge = M.y + me, ye = ge + j, be = M.x + he, we = be + V;
          }
          pn();
          var De = Ie(Re),
            Te = se[0] === fe[0];
          if (De && "t" === se[0] && (ye > X.bottom || v.current.bt)) {
            var Le = me;
            Te ? Le -= j - z : Le = Se.y - ke.y - oe;
            var je = sn(he, Le),
              Ve = sn(he, Le, q);
            je > _e || je === _e && (!$ || Ve >= Ee) ? (v.current.bt = !0, me = Le, oe = -oe, de.points = [Rr(se, 0), Rr(fe, 0)]) : v.current.bt = !1;
          }
          if (De && "b" === se[0] && (ge < X.top || v.current.tb)) {
            var ze = me;
            Te ? ze += j - z : ze = Oe.y - Ce.y - oe;
            var Fe = sn(he, ze),
              We = sn(he, ze, q);
            Fe > _e || Fe === _e && (!$ || We >= Ee) ? (v.current.tb = !0, me = ze, oe = -oe, de.points = [Rr(se, 0), Rr(fe, 0)]) : v.current.tb = !1;
          }
          var He = Ie(Me),
            Ue = se[1] === fe[1];
          if (He && "l" === se[1] && (we > X.right || v.current.rl)) {
            var Ke = he;
            Ue ? Ke -= V - F : Ke = Se.x - ke.x - re;
            var Be = sn(Ke, me),
              $e = sn(Ke, me, q);
            Be > _e || Be === _e && (!$ || $e >= Ee) ? (v.current.rl = !0, he = Ke, re = -re, de.points = [Rr(se, 1), Rr(fe, 1)]) : v.current.rl = !1;
          }
          if (He && "r" === se[1] && (be < X.left || v.current.lr)) {
            var Ye = he;
            Ue ? Ye += V - F : Ye = Oe.x - Ce.x - re;
            var qe = sn(Ye, me),
              Ge = sn(Ye, me, q);
            qe > _e || qe === _e && (!$ || Ge >= Ee) ? (v.current.lr = !0, he = Ye, re = -re, de.points = [Rr(se, 1), Rr(fe, 1)]) : v.current.lr = !1;
          }
          pn();
          var Xe = !0 === Ae ? 0 : Ae;
          "number" == typeof Xe && (be < q.left && (he -= be - q.left - re, l.x + F < q.left + Xe && (he += l.x - q.left + F - Xe)), we > q.right && (he -= we - q.right - re, l.x > q.right - Xe && (he += l.x - q.right + Xe)));
          var Ze = !0 === Pe ? 0 : Pe;
          "number" == typeof Ze && (ge < q.top && (me -= ge - q.top - oe, l.y + z < q.top + Ze && (me += l.y - q.top + z - Ze)), ye > q.bottom && (me -= ye - q.bottom - oe, l.y > q.bottom - Ze && (me += l.y - q.bottom + Ze)));
          var Qe = M.x + he,
            Je = Qe + V,
            en = M.y + me,
            nn = en + j,
            tn = l.x,
            rn = tn + F,
            on = l.y,
            un = on + z,
            an = (Math.max(Qe, tn) + Math.min(Je, rn)) / 2 - Qe,
            cn = (Math.max(en, on) + Math.min(nn, un)) / 2 - en;
          null == a || a(n, de);
          var ln = Z.right - M.x - (he + M.width),
            fn = Z.bottom - M.y - (me + M.height);
          f({
            ready: !0,
            offsetX: he / Q,
            offsetY: me / J,
            offsetR: ln / Q,
            offsetB: fn / J,
            arrowX: an / Q,
            arrowY: cn / J,
            scaleX: Q,
            scaleY: J,
            align: de
          });
        }
      }),
      m = function () {
        f(function (e) {
          return _(_({}, e), {}, {
            ready: !1
          });
        });
      };
    return x(m, [r]), x(function () {
      e || m();
    }, [e]), [l.ready, l.offsetX, l.offsetY, l.offsetR, l.offsetB, l.arrowX, l.arrowY, l.scaleX, l.scaleY, l.align, function () {
      s.current += 1;
      var e = s.current;
      Promise.resolve().then(function () {
        s.current === e && d();
      });
    }];
  }
  var Pr = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
  var Ir = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : mt,
        n = i.forwardRef(function (n, t) {
          var r = n.prefixCls,
            o = void 0 === r ? "rc-trigger-popup" : r,
            u = n.children,
            a = n.action,
            c = void 0 === a ? "hover" : a,
            l = n.showAction,
            f = n.hideAction,
            s = n.popupVisible,
            v = n.defaultPopupVisible,
            d = n.onPopupVisibleChange,
            g = n.afterPopupVisibleChange,
            y = n.mouseEnterDelay,
            b = n.mouseLeaveDelay,
            w = void 0 === b ? .1 : b,
            S = n.focusDelay,
            C = n.blurDelay,
            O = n.mask,
            k = n.maskClosable,
            N = void 0 === k || k,
            M = n.getPopupContainer,
            R = n.forceRender,
            A = n.autoDestroy,
            I = n.destroyPopupOnHide,
            D = n.popup,
            T = n.popupClassName,
            L = n.popupStyle,
            j = n.popupPlacement,
            V = n.builtinPlacements,
            z = void 0 === V ? {} : V,
            H = n.popupAlign,
            U = n.zIndex,
            K = n.stretch,
            B = n.getPopupClassNameFromAlign,
            $ = n.fresh,
            Y = n.alignPoint,
            q = n.onPopupClick,
            G = n.onPopupAlign,
            X = n.arrow,
            Z = n.popupMotion,
            Q = n.maskMotion,
            J = n.popupTransitionName,
            ee = n.popupAnimation,
            ne = n.maskTransitionName,
            te = n.maskAnimation,
            re = n.className,
            oe = n.getTriggerDOMNode,
            ie = m(n, Pr),
            ue = A || I || !1,
            ae = h(i.useState(!1), 2),
            ce = ae[0],
            le = ae[1];
          x(function () {
            le(W());
          }, []);
          var fe = i.useRef({}),
            se = i.useContext(gr),
            pe = i.useMemo(function () {
              return {
                registerSubPopup: function (e, n) {
                  fe.current[e] = n, null == se || se.registerSubPopup(e, n);
                }
              };
            }, [se]),
            ve = _t(),
            de = h(i.useState(null), 2),
            he = de[0],
            me = de[1],
            ge = E(function (e) {
              xe(e) && he !== e && me(e), null == se || se.registerSubPopup(ve, e);
            }),
            ye = h(i.useState(null), 2),
            be = ye[0],
            we = ye[1],
            _e = i.useRef(null),
            Ee = E(function (e) {
              xe(e) && be !== e && (we(e), _e.current = e);
            }),
            Se = i.Children.only(u),
            Ce = (null == Se ? void 0 : Se.props) || {},
            Oe = {},
            ke = E(function (e) {
              var n,
                t,
                r = be;
              return (null == r ? void 0 : r.contains(e)) || (null === (n = yt(r)) || void 0 === n ? void 0 : n.host) === e || e === r || (null == he ? void 0 : he.contains(e)) || (null === (t = yt(he)) || void 0 === t ? void 0 : t.host) === e || e === he || Object.values(fe.current).some(function (n) {
                return (null == n ? void 0 : n.contains(e)) || e === n;
              });
            }),
            Ne = wr(o, Z, ee, J),
            Me = wr(o, Q, te, ne),
            Re = h(i.useState(v || !1), 2),
            Ae = Re[0],
            Pe = Re[1],
            Ie = null != s ? s : Ae,
            De = E(function (e) {
              void 0 === s && Pe(e);
            });
          x(function () {
            Pe(s || !1);
          }, [s]);
          var Te = i.useRef(Ie);
          Te.current = Ie;
          var Le = i.useRef([]);
          Le.current = [];
          var je = E(function (e) {
              var n;
              De(e), (null !== (n = Le.current[Le.current.length - 1]) && void 0 !== n ? n : Ie) !== e && (Le.current.push(e), null == d || d(e));
            }),
            Ve = i.useRef(),
            ze = function () {
              clearTimeout(Ve.current);
            },
            Fe = function (e) {
              var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
              ze(), 0 === n ? je(e) : Ve.current = setTimeout(function () {
                je(e);
              }, 1e3 * n);
            };
          i.useEffect(function () {
            return ze;
          }, []);
          var We = h(i.useState(!1), 2),
            He = We[0],
            Ue = We[1];
          x(function (e) {
            e && !Ie || Ue(!0);
          }, [Ie]);
          var Ke = h(i.useState(null), 2),
            Be = Ke[0],
            $e = Ke[1],
            Ye = h(i.useState([0, 0]), 2),
            qe = Ye[0],
            Ge = Ye[1],
            Xe = function (e) {
              Ge([e.clientX, e.clientY]);
            },
            Ze = h(Ar(Ie, he, Y ? qe : be, j, z, H, G), 11),
            Qe = Ze[0],
            Je = Ze[1],
            en = Ze[2],
            nn = Ze[3],
            tn = Ze[4],
            rn = Ze[5],
            on = Ze[6],
            un = Ze[7],
            an = Ze[8],
            cn = Ze[9],
            ln = Ze[10],
            fn = function (e, n, t, r) {
              return i.useMemo(function () {
                var o = yr(null != t ? t : n),
                  i = yr(null != r ? r : n),
                  u = new Set(o),
                  a = new Set(i);
                return e && (u.has("hover") && (u.delete("hover"), u.add("click")), a.has("hover") && (a.delete("hover"), a.add("click"))), [u, a];
              }, [e, n, t, r]);
            }(ce, c, l, f),
            sn = h(fn, 2),
            pn = sn[0],
            dn = sn[1],
            hn = pn.has("click"),
            mn = dn.has("click") || dn.has("contextMenu"),
            gn = E(function () {
              He || ln();
            });
          !function (e, n, t, r, o) {
            x(function () {
              if (e && n && t) {
                var i = t,
                  u = Er(n),
                  a = Er(i),
                  c = _r(i),
                  l = new Set([c].concat(p(u), p(a)));
                function f() {
                  r(), o();
                }
                return l.forEach(function (e) {
                  e.addEventListener("scroll", f, {
                    passive: !0
                  });
                }), c.addEventListener("resize", f, {
                  passive: !0
                }), r(), function () {
                  l.forEach(function (e) {
                    e.removeEventListener("scroll", f), c.removeEventListener("resize", f);
                  });
                };
              }
            }, [e, n, t]);
          }(Ie, be, he, gn, function () {
            Te.current && Y && mn && Fe(!1);
          }), x(function () {
            gn();
          }, [qe, j]), x(function () {
            !Ie || null != z && z[j] || gn();
          }, [JSON.stringify(H)]);
          var yn = i.useMemo(function () {
            var e = function (e, n, t, r) {
              for (var o = t.points, i = Object.keys(e), u = 0; u < i.length; u += 1) {
                var a,
                  c = i[u];
                if (br(null === (a = e[c]) || void 0 === a ? void 0 : a.points, o, r)) return "".concat(n, "-placement-").concat(c);
              }
              return "";
            }(z, o, cn, Y);
            return F(e, null == B ? void 0 : B(cn));
          }, [cn, B, z, o, Y]);
          i.useImperativeHandle(t, function () {
            return {
              nativeElement: _e.current,
              forceAlign: gn
            };
          });
          var bn = h(i.useState(0), 2),
            wn = bn[0],
            _n = bn[1],
            En = h(i.useState(0), 2),
            Cn = En[0],
            xn = En[1],
            On = function () {
              if (K && be) {
                var e = be.getBoundingClientRect();
                _n(e.width), xn(e.height);
              }
            };
          function kn(e, n, t, r) {
            Oe[e] = function (o) {
              var i;
              null == r || r(o), Fe(n, t);
              for (var u = arguments.length, a = new Array(u > 1 ? u - 1 : 0), c = 1; c < u; c++) a[c - 1] = arguments[c];
              null === (i = Ce[e]) || void 0 === i || i.call.apply(i, [Ce, o].concat(a));
            };
          }
          x(function () {
            Be && (ln(), Be(), $e(null));
          }, [Be]), (hn || mn) && (Oe.onClick = function (e) {
            var n;
            Te.current && mn ? Fe(!1) : !Te.current && hn && (Xe(e), Fe(!0));
            for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) r[o - 1] = arguments[o];
            null === (n = Ce.onClick) || void 0 === n || n.call.apply(n, [Ce, e].concat(r));
          }), function (e, n, t, r, o, u, a, c) {
            var l = i.useRef(e),
              f = i.useRef(!1);
            l.current !== e && (f.current = !0, l.current = e), i.useEffect(function () {
              var e = Sn(function () {
                f.current = !1;
              });
              return function () {
                Sn.cancel(e);
              };
            }, [e]), i.useEffect(function () {
              if (n && r && (!o || u)) {
                var e = function () {
                    var e = !1;
                    return [function (n) {
                      var t = n.target;
                      e = a(t);
                    }, function (n) {
                      var t = n.target;
                      f.current || !l.current || e || a(t) || c(!1);
                    }];
                  },
                  i = h(e(), 2),
                  s = i[0],
                  p = i[1],
                  v = h(e(), 2),
                  d = v[0],
                  m = v[1],
                  g = _r(r);
                g.addEventListener("mousedown", s, !0), g.addEventListener("click", p, !0), g.addEventListener("contextmenu", p, !0);
                var y,
                  b,
                  w = yt(t);
                return w && (w.addEventListener("mousedown", d, !0), w.addEventListener("click", m, !0), w.addEventListener("contextmenu", m, !0)), "production" !== process.env.NODE_ENV && P((null == t || null === (y = t.getRootNode) || void 0 === y ? void 0 : y.call(t)) === (null === (b = r.getRootNode) || void 0 === b ? void 0 : b.call(r)), "trigger element and popup element should in same shadow root."), function () {
                  g.removeEventListener("mousedown", s, !0), g.removeEventListener("click", p, !0), g.removeEventListener("contextmenu", p, !0), w && (w.removeEventListener("mousedown", d, !0), w.removeEventListener("click", m, !0), w.removeEventListener("contextmenu", m, !0));
                };
              }
            }, [n, t, r, o, u]);
          }(Ie, mn, be, he, O, N, ke, Fe);
          var Nn,
            Mn,
            Rn = pn.has("hover"),
            An = dn.has("hover");
          Rn && (kn("onMouseEnter", !0, y, function (e) {
            Xe(e);
          }), kn("onPointerEnter", !0, y, function (e) {
            Xe(e);
          }), Nn = function (e) {
            (Ie || He) && null != he && he.contains(e.target) && Fe(!0, y);
          }, Y && (Oe.onMouseMove = function (e) {
            var n;
            null === (n = Ce.onMouseMove) || void 0 === n || n.call(Ce, e);
          })), An && (kn("onMouseLeave", !1, w), kn("onPointerLeave", !1, w), Mn = function () {
            Fe(!1, w);
          }), pn.has("focus") && kn("onFocus", !0, S), dn.has("focus") && kn("onBlur", !1, C), pn.has("contextMenu") && (Oe.onContextMenu = function (e) {
            var n;
            Te.current && dn.has("contextMenu") ? Fe(!1) : (Xe(e), Fe(!0)), e.preventDefault();
            for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) r[o - 1] = arguments[o];
            null === (n = Ce.onContextMenu) || void 0 === n || n.call.apply(n, [Ce, e].concat(r));
          }), re && (Oe.className = F(Ce.className, re));
          var Pn = _(_({}, Ce), Oe),
            In = {};
          ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"].forEach(function (e) {
            ie[e] && (In[e] = function () {
              for (var n, t = arguments.length, r = new Array(t), o = 0; o < t; o++) r[o] = arguments[o];
              null === (n = Pn[e]) || void 0 === n || n.call.apply(n, [Pn].concat(r)), ie[e].apply(ie, r);
            });
          });
          var Dn = i.cloneElement(Se, _(_({}, Pn), In)),
            Tn = {
              x: rn,
              y: on
            },
            Ln = X ? _({}, !0 !== X ? X : {}) : null;
          return i.createElement(i.Fragment, null, i.createElement(vn, {
            disabled: !Ie,
            ref: Ee,
            onResize: function () {
              On(), gn();
            }
          }, i.createElement(mr, {
            getTriggerDOMNode: oe
          }, Dn)), i.createElement(gr.Provider, {
            value: pe
          }, i.createElement(hr, {
            portal: e,
            ref: ge,
            prefixCls: o,
            popup: D,
            className: F(T, yn),
            style: L,
            target: be,
            onMouseEnter: Nn,
            onMouseLeave: Mn,
            onPointerEnter: Nn,
            zIndex: U,
            open: Ie,
            keepDom: He,
            fresh: $,
            onClick: q,
            mask: O,
            motion: Ne,
            maskMotion: Me,
            onVisibleChanged: function (e) {
              Ue(!1), ln(), null == g || g(e);
            },
            onPrepare: function () {
              return new Promise(function (e) {
                On(), $e(function () {
                  return e;
                });
              });
            },
            forceRender: R,
            autoDestroy: ue,
            getPopupContainer: M,
            align: cn,
            arrow: Ln,
            arrowPos: Tn,
            ready: Qe,
            offsetX: Je,
            offsetY: en,
            offsetR: nn,
            offsetB: tn,
            onAlign: gn,
            stretch: K,
            targetWidth: wn / un,
            targetHeight: Cn / an
          })));
        });
      return "production" !== process.env.NODE_ENV && (n.displayName = "Trigger"), n;
    }(mt),
    Dr = ["prefixCls", "disabled", "visible", "children", "popupElement", "containerWidth", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"],
    Tr = function (e, n) {
      var t = e.prefixCls;
      e.disabled;
      var r = e.visible,
        o = e.children,
        u = e.popupElement,
        a = e.containerWidth,
        l = e.animation,
        f = e.transitionName,
        s = e.dropdownStyle,
        p = e.dropdownClassName,
        v = e.direction,
        d = void 0 === v ? "ltr" : v,
        h = e.placement,
        g = e.dropdownMatchSelectWidth,
        y = e.dropdownRender,
        w = e.dropdownAlign,
        E = e.getPopupContainer,
        S = e.empty,
        C = e.getTriggerDOMNode,
        x = e.onPopupVisibleChange,
        O = e.onPopupMouseEnter,
        k = m(e, Dr),
        N = "".concat(t, "-dropdown"),
        M = u;
      y && (M = y(u));
      var R = i.useMemo(function () {
          return function (e) {
            var n = !0 === e ? 0 : 1;
            return {
              bottomLeft: {
                points: ["tl", "bl"],
                offset: [0, 4],
                overflow: {
                  adjustX: n,
                  adjustY: 1
                },
                htmlRegion: "scroll"
              },
              bottomRight: {
                points: ["tr", "br"],
                offset: [0, 4],
                overflow: {
                  adjustX: n,
                  adjustY: 1
                },
                htmlRegion: "scroll"
              },
              topLeft: {
                points: ["bl", "tl"],
                offset: [0, -4],
                overflow: {
                  adjustX: n,
                  adjustY: 1
                },
                htmlRegion: "scroll"
              },
              topRight: {
                points: ["br", "tr"],
                offset: [0, -4],
                overflow: {
                  adjustX: n,
                  adjustY: 1
                },
                htmlRegion: "scroll"
              }
            };
          }(g);
        }, [g]),
        A = l ? "".concat(N, "-").concat(l) : f,
        P = i.useRef(null);
      i.useImperativeHandle(n, function () {
        return {
          getPopupElement: function () {
            return P.current;
          }
        };
      });
      var I = _({
        minWidth: a
      }, s);
      return "number" == typeof g ? I.width = g : g && (I.width = a), i.createElement(Ir, c({}, k, {
        showAction: x ? ["click"] : [],
        hideAction: x ? ["click"] : [],
        popupPlacement: h || ("rtl" === d ? "bottomRight" : "bottomLeft"),
        builtinPlacements: R,
        prefixCls: N,
        popupTransitionName: A,
        popup: i.createElement("div", {
          ref: P,
          onMouseEnter: O
        }, M),
        popupAlign: w,
        popupVisible: r,
        getPopupContainer: E,
        popupClassName: F(p, b({}, "".concat(N, "-empty"), S)),
        popupStyle: I,
        getTriggerDOMNode: C,
        onPopupVisibleChange: x
      }), o);
    },
    Lr = i.forwardRef(Tr);
  function jr(e, n) {
    var t,
      r = e.key;
    return "value" in e && (t = e.value), null != r ? r : void 0 !== t ? t : "rc-index-key-".concat(n);
  }
  function Vr(e, n) {
    var t = e || {};
    return {
      label: t.label || (n ? "children" : "label"),
      value: t.value || "value",
      options: t.options || "options"
    };
  }
  function zr(e) {
    var n = _({}, e);
    return "props" in n || Object.defineProperty(n, "props", {
      get: function () {
        return T(!1, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`."), n;
      }
    }), n;
  }
  function Fr(e, n) {
    if (!n || !n.length) return null;
    var t = !1;
    var r = function e(n, r) {
      var o,
        i = v(o = r) || f(o) || s(o) || d(),
        u = i[0],
        a = i.slice(1);
      if (!u) return [n];
      var c = n.split(u);
      return t = t || c.length > 1, c.reduce(function (n, t) {
        return [].concat(p(n), p(e(t, a)));
      }, []).filter(function (e) {
        return e;
      });
    }(e, n);
    return t ? r : null;
  }
  Lr.displayName = "SelectTrigger";
  var Wr = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "showArrow", "inputIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"],
    Hr = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"];
  function Ur(e) {
    return "tags" === e || "multiple" === e;
  }
  var Kr = i.forwardRef(function (e, n) {
    var t,
      r,
      o = e.id,
      u = e.prefixCls,
      a = e.className,
      l = e.showSearch,
      f = e.tagRender,
      s = e.direction,
      v = e.omitDomProps,
      d = e.displayValues,
      y = e.onDisplayValuesChange,
      w = e.emptyOptions,
      E = e.notFoundContent,
      S = void 0 === E ? "Not Found" : E,
      C = e.onClear,
      O = e.mode,
      k = e.disabled,
      N = e.loading,
      R = e.getInputElement,
      A = e.getRawInputElement,
      P = e.open,
      I = e.defaultOpen,
      D = e.onDropdownVisibleChange,
      T = e.activeValue,
      L = e.onActiveValueChange,
      j = e.activeDescendantId,
      V = e.searchValue,
      z = e.autoClearSearchValue,
      U = e.onSearch,
      K = e.onSearchSplit,
      B = e.tokenSeparators,
      $ = e.allowClear,
      Y = e.showArrow,
      q = e.inputIcon,
      G = e.clearIcon,
      X = e.OptionList,
      Z = e.animation,
      Q = e.transitionName,
      J = e.dropdownStyle,
      ee = e.dropdownClassName,
      ne = e.dropdownMatchSelectWidth,
      te = e.dropdownRender,
      re = e.dropdownAlign,
      oe = e.placement,
      ie = e.getPopupContainer,
      ue = e.showAction,
      ae = void 0 === ue ? [] : ue,
      ce = e.onFocus,
      le = e.onBlur,
      fe = e.onKeyUp,
      se = e.onKeyDown,
      pe = e.onMouseDown,
      ve = m(e, Wr),
      he = Ur(O),
      me = (void 0 !== l ? l : he) || "combobox" === O,
      ge = _({}, ve);
    Hr.forEach(function (e) {
      delete ge[e];
    }), null == v || v.forEach(function (e) {
      delete ge[e];
    });
    var be = h(i.useState(!1), 2),
      _e = be[0],
      Ee = be[1];
    i.useEffect(function () {
      Ee(W());
    }, []);
    var Se = i.useRef(null),
      Ce = i.useRef(null),
      xe = i.useRef(null),
      Oe = i.useRef(null),
      ke = i.useRef(null),
      Ne = function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 10,
          n = h(i.useState(!1), 2),
          t = n[0],
          r = n[1],
          o = i.useRef(null),
          u = function () {
            window.clearTimeout(o.current);
          };
        return i.useEffect(function () {
          return u;
        }, []), [t, function (n, t) {
          u(), o.current = window.setTimeout(function () {
            r(n), t && t();
          }, e);
        }, u];
      }(),
      Me = h(Ne, 3),
      Re = Me[0],
      Ae = Me[1],
      Pe = Me[2];
    i.useImperativeHandle(n, function () {
      var e, n;
      return {
        focus: null === (e = Oe.current) || void 0 === e ? void 0 : e.focus,
        blur: null === (n = Oe.current) || void 0 === n ? void 0 : n.blur,
        scrollTo: function (e) {
          var n;
          return null === (n = ke.current) || void 0 === n ? void 0 : n.scrollTo(e);
        }
      };
    });
    var Ie = i.useMemo(function () {
        var e;
        if ("combobox" !== O) return V;
        var n = null === (e = d[0]) || void 0 === e ? void 0 : e.value;
        return "string" == typeof n || "number" == typeof n ? String(n) : "";
      }, [V, O, d]),
      De = "combobox" === O && "function" == typeof R && R() || null,
      Te = "function" == typeof A && A(),
      Le = de(Ce, null == Te || null === (t = Te.props) || void 0 === t ? void 0 : t.ref),
      je = h(M(void 0, {
        defaultValue: I,
        value: P
      }), 2),
      Ve = je[0],
      ze = je[1],
      Fe = Ve,
      We = !S && w;
    (k || We && Fe && "combobox" === O) && (Fe = !1);
    var He = !We && Fe,
      Ue = i.useCallback(function (e) {
        var n = void 0 !== e ? e : !Fe;
        k || (ze(n), Fe !== n && (null == D || D(n)));
      }, [k, Fe, ze, D]),
      Ke = i.useMemo(function () {
        return (B || []).some(function (e) {
          return ["\n", "\r\n"].includes(e);
        });
      }, [B]),
      Be = function (e, n, t) {
        var r = !0,
          o = e;
        null == L || L(null);
        var i = t ? null : Fr(e, B);
        return "combobox" !== O && i && (o = "", null == K || K(i), Ue(!1), r = !1), U && Ie !== o && U(o, {
          source: n ? "typing" : "effect"
        }), r;
      };
    i.useEffect(function () {
      Fe || he || "combobox" === O || Be("", !1, !1);
    }, [Fe]), i.useEffect(function () {
      Ve && k && ze(!1), k && Ae(!1);
    }, [k]);
    var $e = h(we(), 2),
      Ye = $e[0],
      qe = $e[1],
      Ge = i.useRef(!1),
      Xe = [];
    i.useEffect(function () {
      return function () {
        Xe.forEach(function (e) {
          return clearTimeout(e);
        }), Xe.splice(0, Xe.length);
      };
    }, []);
    var Ze,
      Qe = h(i.useState(null), 2),
      Je = Qe[0],
      en = Qe[1],
      nn = h(i.useState({}), 2)[1];
    x(function () {
      if (He) {
        var e,
          n = Math.ceil(null === (e = Se.current) || void 0 === e ? void 0 : e.offsetWidth);
        Je === n || Number.isNaN(n) || en(n);
      }
    }, [He]), Te && (Ze = function (e) {
      Ue(e);
    }), function (e, n, t, r) {
      var o = i.useRef(null);
      o.current = {
        open: n,
        triggerOpen: t,
        customizedTrigger: r
      }, i.useEffect(function () {
        function n(n) {
          var t;
          if (null === (t = o.current) || void 0 === t || !t.customizedTrigger) {
            var r = n.target;
            r.shadowRoot && n.composed && (r = n.composedPath()[0] || r), o.current.open && e().filter(function (e) {
              return e;
            }).every(function (e) {
              return !e.contains(r) && e !== r;
            }) && o.current.triggerOpen(!1);
          }
        }
        return window.addEventListener("mousedown", n), function () {
          return window.removeEventListener("mousedown", n);
        };
      }, []);
    }(function () {
      var e;
      return [Se.current, null === (e = xe.current) || void 0 === e ? void 0 : e.getPopupElement()];
    }, He, Ue, !!Te);
    var tn,
      rn,
      on = i.useMemo(function () {
        return _(_({}, e), {}, {
          notFoundContent: S,
          open: Fe,
          triggerOpen: He,
          id: o,
          showSearch: me,
          multiple: he,
          toggleOpen: Ue
        });
      }, [e, S, He, Fe, o, me, he, Ue]),
      un = void 0 !== Y ? Y : N || !he && "combobox" !== O;
    un && (tn = i.createElement(Vn, {
      className: F("".concat(u, "-arrow"), b({}, "".concat(u, "-arrow-loading"), N)),
      customizeIcon: q,
      customizeIconProps: {
        loading: N,
        searchValue: Ie,
        open: Fe,
        focused: Re,
        showSearch: me
      }
    }));
    k || !$ || !d.length && !Ie || "combobox" === O && "" === Ie || (rn = i.createElement(Vn, {
      className: "".concat(u, "-clear"),
      onMouseDown: function () {
        var e;
        null == C || C(), null === (e = Oe.current) || void 0 === e || e.focus(), y([], {
          type: "clear",
          values: d
        }), Be("", !1, !1);
      },
      customizeIcon: G
    }, "×"));
    var an,
      cn = i.createElement(X, {
        ref: ke
      }),
      ln = F(u, a, (b(r = {}, "".concat(u, "-focused"), Re), b(r, "".concat(u, "-multiple"), he), b(r, "".concat(u, "-single"), !he), b(r, "".concat(u, "-allow-clear"), $), b(r, "".concat(u, "-show-arrow"), un), b(r, "".concat(u, "-disabled"), k), b(r, "".concat(u, "-loading"), N), b(r, "".concat(u, "-open"), Fe), b(r, "".concat(u, "-customize-input"), De), b(r, "".concat(u, "-show-search"), me), r)),
      fn = i.createElement(Lr, {
        ref: xe,
        disabled: k,
        prefixCls: u,
        visible: He,
        popupElement: cn,
        containerWidth: Je,
        animation: Z,
        transitionName: Q,
        dropdownStyle: J,
        dropdownClassName: ee,
        direction: s,
        dropdownMatchSelectWidth: ne,
        dropdownRender: te,
        dropdownAlign: re,
        placement: oe,
        getPopupContainer: ie,
        empty: w,
        getTriggerDOMNode: function () {
          return Ce.current;
        },
        onPopupVisibleChange: Ze,
        onPopupMouseEnter: function () {
          nn({});
        }
      }, Te ? i.cloneElement(Te, {
        ref: Le
      }) : i.createElement(Zn, c({}, e, {
        domRef: Ce,
        prefixCls: u,
        inputElement: De,
        ref: Oe,
        id: o,
        showSearch: me,
        autoClearSearchValue: z,
        mode: O,
        activeDescendantId: j,
        tagRender: f,
        values: d,
        open: Fe,
        onToggleOpen: Ue,
        activeValue: T,
        searchValue: Ie,
        onSearch: Be,
        onSearchSubmit: function (e) {
          e && e.trim() && U(e, {
            source: "submit"
          });
        },
        onRemove: function (e) {
          var n = d.filter(function (n) {
            return n !== e;
          });
          y(n, {
            type: "remove",
            values: [e]
          });
        },
        tokenWithEnter: Ke
      })));
    return an = Te ? fn : i.createElement("div", c({
      className: ln
    }, ge, {
      ref: Se,
      onMouseDown: function (e) {
        var n,
          t = e.target,
          r = null === (n = xe.current) || void 0 === n ? void 0 : n.getPopupElement();
        if (r && r.contains(t)) {
          var o = setTimeout(function () {
            var e,
              n = Xe.indexOf(o);
            -1 !== n && Xe.splice(n, 1), Pe(), _e || r.contains(document.activeElement) || null === (e = Oe.current) || void 0 === e || e.focus();
          });
          Xe.push(o);
        }
        for (var i = arguments.length, u = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) u[a - 1] = arguments[a];
        null == pe || pe.apply(void 0, [e].concat(u));
      },
      onKeyDown: function (e) {
        var n,
          t = Ye(),
          r = e.which;
        if (r === H.ENTER && ("combobox" !== O && e.preventDefault(), Fe || Ue(!0)), qe(!!Ie), r === H.BACKSPACE && !t && he && !Ie && d.length) {
          for (var o = p(d), i = null, u = o.length - 1; u >= 0; u -= 1) {
            var a = o[u];
            if (!a.disabled) {
              o.splice(u, 1), i = a;
              break;
            }
          }
          i && y(o, {
            type: "remove",
            values: [i]
          });
        }
        for (var c = arguments.length, l = new Array(c > 1 ? c - 1 : 0), f = 1; f < c; f++) l[f - 1] = arguments[f];
        Fe && ke.current && (n = ke.current).onKeyDown.apply(n, [e].concat(l)), null == se || se.apply(void 0, [e].concat(l));
      },
      onKeyUp: function (e) {
        for (var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++) t[r - 1] = arguments[r];
        var o;
        Fe && ke.current && (o = ke.current).onKeyUp.apply(o, [e].concat(t)), null == fe || fe.apply(void 0, [e].concat(t));
      },
      onFocus: function () {
        Ae(!0), k || (ce && !Ge.current && ce.apply(void 0, arguments), ae.includes("focus") && Ue(!0)), Ge.current = !0;
      },
      onBlur: function () {
        Ae(!1, function () {
          Ge.current = !1, Ue(!1);
        }), k || (Ie && ("tags" === O ? U(Ie, {
          source: "submit"
        }) : "multiple" === O && U("", {
          source: "blur"
        })), le && le.apply(void 0, arguments));
      }
    }), Re && !Fe && i.createElement("span", {
      style: {
        width: 0,
        height: 0,
        position: "absolute",
        overflow: "hidden",
        opacity: 0
      },
      "aria-live": "polite"
    }, "".concat(d.map(function (e) {
      var n = e.label,
        t = e.value;
      return ["number", "string"].includes(g(n)) ? n : t;
    }).join(", "))), fn, tn, rn), i.createElement(ye.Provider, {
      value: on
    }, an);
  });
  "production" !== process.env.NODE_ENV && (Kr.displayName = "BaseSelect");
  function Br(e, n) {
    return Wn(e).join("").toUpperCase().includes(n);
  }
  var $r = 0,
    Yr = "test" !== process.env.NODE_ENV && S();
  function qr(e) {
    var n = h(i.useState(), 2),
      t = n[0],
      r = n[1];
    return i.useEffect(function () {
      var e;
      r("rc_select_".concat((Yr ? (e = $r, $r += 1) : e = "TEST_OR_SSR", e)));
    }, []), e || t;
  }
  var Gr = ["children", "value"],
    Xr = ["children"];
  function Zr(e) {
    var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return Ce(e).map(function (e, t) {
      if (!i.isValidElement(e) || !e.type) return null;
      var r = e,
        o = r.type.isSelectOptGroup,
        u = r.key,
        a = r.props,
        c = a.children,
        l = m(a, Xr);
      return n || !o ? function (e) {
        var n = e,
          t = n.key,
          r = n.props,
          o = r.children,
          i = r.value;
        return _({
          key: t,
          value: void 0 !== i ? i : t,
          children: o
        }, m(r, Gr));
      }(e) : _(_({
        key: "__RC_SELECT_GRP__".concat(null === u ? t : u, "__"),
        label: u
      }, l), {}, {
        options: Zr(c)
      });
    }).filter(function (e) {
      return e;
    });
  }
  function Qr(e) {
    var n = i.useRef();
    n.current = e;
    var t = i.useCallback(function () {
      return n.current.apply(n, arguments);
    }, []);
    return t;
  }
  var Jr = function () {
    return null;
  };
  Jr.isSelectOptGroup = !0;
  var eo = function () {
    return null;
  };
  eo.isSelectOption = !0;
  var no = i.forwardRef(function (e, n) {
    var t = e.height,
      r = e.offsetY,
      o = e.offsetX,
      u = e.children,
      a = e.prefixCls,
      l = e.onInnerResize,
      f = e.innerProps,
      s = e.rtl,
      p = e.extra,
      v = {},
      d = {
        display: "flex",
        flexDirection: "column"
      };
    return void 0 !== r && (v = {
      height: t,
      position: "relative",
      overflow: "hidden"
    }, d = _(_({}, d), {}, b(b(b(b(b({
      transform: "translateY(".concat(r, "px)")
    }, s ? "marginRight" : "marginLeft", -o), "position", "absolute"), "left", 0), "right", 0), "top", 0))), i.createElement("div", {
      style: v
    }, i.createElement(vn, {
      onResize: function (e) {
        e.offsetHeight && l && l();
      }
    }, i.createElement("div", c({
      style: d,
      className: F(b({}, "".concat(a, "-holder-inner"), a)),
      ref: n
    }, f), u, p)));
  });
  function to(e) {
    var n = e.children,
      t = e.setRef,
      r = i.useCallback(function (e) {
        t(e);
      }, []);
    return i.cloneElement(n, {
      ref: r
    });
  }
  function ro(e, n, t) {
    var r = h(i.useState(e), 2),
      o = r[0],
      u = r[1],
      a = h(i.useState(null), 2),
      c = a[0],
      l = a[1];
    return i.useEffect(function () {
      var r = function (e, n, t) {
        var r,
          o,
          i = e.length,
          u = n.length;
        if (0 === i && 0 === u) return null;
        i < u ? (r = e, o = n) : (r = n, o = e);
        var a = {
          __EMPTY_ITEM__: !0
        };
        function c(e) {
          return void 0 !== e ? t(e) : a;
        }
        for (var l = null, f = 1 !== Math.abs(i - u), s = 0; s < o.length; s += 1) {
          var p = c(r[s]);
          if (p !== c(o[s])) {
            l = s, f = f || p !== c(o[s + 1]);
            break;
          }
        }
        return null === l ? null : {
          index: l,
          multiple: f
        };
      }(o || [], e || [], n);
      void 0 !== (null == r ? void 0 : r.index) && (null == t || t(r.index), l(e[r.index])), u(e);
    }, [e]), [c];
  }
  no.displayName = "Filler";
  var oo = "object" === ("undefined" == typeof navigator ? "undefined" : g(navigator)) && /Firefox/i.test(navigator.userAgent),
    io = function (e, t, r, o) {
      var i = n.useRef(!1),
        u = n.useRef(null);
      var a = n.useRef({
        top: e,
        bottom: t,
        left: r,
        right: o
      });
      return a.current.top = e, a.current.bottom = t, a.current.left = r, a.current.right = o, function (e, n) {
        var t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          r = e ? n < 0 && a.current.left || n > 0 && a.current.right : n < 0 && a.current.top || n > 0 && a.current.bottom;
        return t && r ? (clearTimeout(u.current), i.current = !1) : r && !i.current || (clearTimeout(u.current), i.current = !0, u.current = setTimeout(function () {
          i.current = !1;
        }, 50)), !i.current && r;
      };
    };
  function uo(e, t, r, o, i, u, a) {
    var c = n.useRef(0),
      l = n.useRef(null),
      f = n.useRef(null),
      s = n.useRef(!1),
      p = io(t, r, o, i);
    var v = n.useRef(null),
      d = n.useRef(null);
    return [function (n) {
      if (e) {
        Sn.cancel(d.current), d.current = Sn(function () {
          v.current = null;
        }, 2);
        var t = n.deltaX,
          r = n.deltaY,
          o = n.shiftKey,
          i = t,
          h = r;
        ("sx" === v.current || !v.current && o && r && !t) && (i = r, h = 0, v.current = "sx");
        var m = Math.abs(i),
          g = Math.abs(h);
        null === v.current && (v.current = u && m > g ? "x" : "y"), "y" === v.current ? function (e, n) {
          if (Sn.cancel(l.current), !p(!1, n)) {
            var t = e;
            t._virtualHandled || (t._virtualHandled = !0, c.current += n, f.current = n, oo || t.preventDefault(), l.current = Sn(function () {
              var e = s.current ? 10 : 1;
              a(c.current * e, !1), c.current = 0;
            }));
          }
        }(n, h) : function (e, n) {
          a(n, !0), oo || e.preventDefault();
        }(n, i);
      }
    }, function (n) {
      e && (s.current = n.detail === f.current);
    }];
  }
  var ao = function () {
    function e() {
      Je(this, e), b(this, "maps", void 0), b(this, "id", 0), this.maps = Object.create(null);
    }
    return nn(e, [{
      key: "set",
      value: function (e, n) {
        this.maps[e] = n, this.id += 1;
      }
    }, {
      key: "get",
      value: function (e) {
        return this.maps[e];
      }
    }]), e;
  }();
  function co(e) {
    var n = parseFloat(e);
    return isNaN(n) ? 0 : n;
  }
  var lo = 14 / 15;
  function fo(e) {
    return Math.floor(Math.pow(e, .5));
  }
  function so(e, n) {
    return ("touches" in e ? e.touches[0] : e)[n ? "pageX" : "pageY"] - window[n ? "scrollX" : "scrollY"];
  }
  var po = i.forwardRef(function (e, n) {
    var t = e.prefixCls,
      r = e.rtl,
      o = e.scrollOffset,
      u = e.scrollRange,
      a = e.onStartMove,
      c = e.onStopMove,
      l = e.onScroll,
      f = e.horizontal,
      s = e.spinSize,
      p = e.containerSize,
      v = e.style,
      d = e.thumbStyle,
      m = h(i.useState(!1), 2),
      g = m[0],
      y = m[1],
      w = h(i.useState(null), 2),
      E = w[0],
      S = w[1],
      C = h(i.useState(null), 2),
      x = C[0],
      O = C[1],
      k = !r,
      N = i.useRef(),
      M = i.useRef(),
      R = h(i.useState(!1), 2),
      A = R[0],
      P = R[1],
      I = i.useRef(),
      D = function () {
        clearTimeout(I.current), P(!0), I.current = setTimeout(function () {
          P(!1);
        }, 3e3);
      },
      T = u - p || 0,
      L = p - s || 0,
      j = i.useMemo(function () {
        return 0 === o || 0 === T ? 0 : o / T * L;
      }, [o, T, L]),
      V = i.useRef({
        top: j,
        dragging: g,
        pageY: E,
        startTop: x
      });
    V.current = {
      top: j,
      dragging: g,
      pageY: E,
      startTop: x
    };
    var z = function (e) {
      y(!0), S(so(e, f)), O(V.current.top), a(), e.stopPropagation(), e.preventDefault();
    };
    i.useEffect(function () {
      var e = function (e) {
          e.preventDefault();
        },
        n = N.current,
        t = M.current;
      return n.addEventListener("touchstart", e, {
        passive: !1
      }), t.addEventListener("touchstart", z, {
        passive: !1
      }), function () {
        n.removeEventListener("touchstart", e), t.removeEventListener("touchstart", z);
      };
    }, []);
    var W = i.useRef();
    W.current = T;
    var H = i.useRef();
    H.current = L, i.useEffect(function () {
      if (g) {
        var e,
          n = function (n) {
            var t = V.current,
              r = t.dragging,
              o = t.pageY,
              i = t.startTop;
            Sn.cancel(e);
            var u = N.current.getBoundingClientRect(),
              a = p / (f ? u.width : u.height);
            if (r) {
              var c = (so(n, f) - o) * a,
                s = i;
              !k && f ? s -= c : s += c;
              var v = W.current,
                d = H.current,
                h = d ? s / d : 0,
                m = Math.ceil(h * v);
              m = Math.max(m, 0), m = Math.min(m, v), e = Sn(function () {
                l(m, f);
              });
            }
          },
          t = function () {
            y(!1), c();
          };
        return window.addEventListener("mousemove", n, {
          passive: !0
        }), window.addEventListener("touchmove", n, {
          passive: !0
        }), window.addEventListener("mouseup", t, {
          passive: !0
        }), window.addEventListener("touchend", t, {
          passive: !0
        }), function () {
          window.removeEventListener("mousemove", n), window.removeEventListener("touchmove", n), window.removeEventListener("mouseup", t), window.removeEventListener("touchend", t), Sn.cancel(e);
        };
      }
    }, [g]), i.useEffect(function () {
      return D(), function () {
        clearTimeout(I.current);
      };
    }, [o]), i.useImperativeHandle(n, function () {
      return {
        delayHidden: D
      };
    });
    var U = "".concat(t, "-scrollbar"),
      K = {
        position: "absolute",
        visibility: A ? null : "hidden"
      },
      B = {
        position: "absolute",
        background: "rgba(0, 0, 0, 0.5)",
        borderRadius: 99,
        cursor: "pointer",
        userSelect: "none"
      };
    return f ? (K.height = 8, K.left = 0, K.right = 0, K.bottom = 0, B.height = "100%", B.width = s, k ? B.left = j : B.right = j) : (K.width = 8, K.top = 0, K.bottom = 0, k ? K.right = 0 : K.left = 0, B.width = "100%", B.height = s, B.top = j), i.createElement("div", {
      ref: N,
      className: F(U, b(b(b({}, "".concat(U, "-horizontal"), f), "".concat(U, "-vertical"), !f), "".concat(U, "-visible"), A)),
      style: _(_({}, K), v),
      onMouseDown: function (e) {
        e.stopPropagation(), e.preventDefault();
      },
      onMouseMove: D
    }, i.createElement("div", {
      ref: M,
      className: F("".concat(U, "-thumb"), b({}, "".concat(U, "-thumb-moving"), g)),
      style: _(_({}, B), d),
      onMouseDown: z
    }));
  });
  "production" !== process.env.NODE_ENV && (po.displayName = "ScrollBar");
  function vo() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
      n = e / (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0) * e;
    return isNaN(n) && (n = 0), n = Math.max(n, 20), Math.floor(n);
  }
  var ho = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles"],
    mo = [],
    go = {
      overflowY: "auto",
      overflowAnchor: "none"
    };
  function yo(e, r) {
    var o = e.prefixCls,
      u = void 0 === o ? "rc-virtual-list" : o,
      a = e.className,
      l = e.height,
      f = e.itemHeight,
      s = e.fullHeight,
      p = void 0 === s || s,
      v = e.style,
      d = e.data,
      y = e.children,
      w = e.itemKey,
      S = e.virtual,
      C = e.direction,
      O = e.scrollWidth,
      k = e.component,
      N = void 0 === k ? "div" : k,
      M = e.onScroll,
      R = e.onVirtualScroll,
      A = e.onVisibleChange,
      P = e.innerProps,
      I = e.extraRender,
      D = e.styles,
      L = m(e, ho),
      j = i.useCallback(function (e) {
        return "function" == typeof w ? w(e) : null == e ? void 0 : e[w];
      }, [w]),
      V = function (e, t, r) {
        var o = h(i.useState(0), 2),
          u = o[0],
          a = o[1],
          c = n.useRef(new Map()),
          l = n.useRef(new ao()),
          f = n.useRef();
        function s() {
          Sn.cancel(f.current);
        }
        function p() {
          var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          s();
          var n = function () {
            c.current.forEach(function (e, n) {
              if (e && e.offsetParent) {
                var t = Oe(e),
                  r = t.offsetHeight,
                  o = getComputedStyle(t),
                  i = o.marginTop,
                  u = o.marginBottom,
                  a = r + co(i) + co(u);
                l.current.get(n) !== a && l.current.set(n, a);
              }
            }), a(function (e) {
              return e + 1;
            });
          };
          e ? n() : f.current = Sn(n);
        }
        return n.useEffect(function () {
          return s;
        }, []), [function (n, o) {
          var i = e(n),
            u = c.current.get(i);
          o ? (c.current.set(i, o), p()) : c.current.delete(i), !u != !o && (o ? null == t || t(n) : null == r || r(n));
        }, p, l.current, u];
      }(j, null, null),
      z = h(V, 4),
      W = z[0],
      H = z[1],
      U = z[2],
      K = z[3],
      B = !(!1 === S || !l || !f),
      $ = i.useMemo(function () {
        return Object.values(U.maps).reduce(function (e, n) {
          return e + n;
        }, 0);
      }, [U.id, U.maps]),
      Y = B && d && (Math.max(f * d.length, $) > l || !!O),
      q = "rtl" === C,
      G = F(u, b({}, "".concat(u, "-rtl"), q), a),
      X = d || mo,
      Z = n.useRef(),
      Q = n.useRef(),
      J = n.useRef(),
      ee = h(n.useState(0), 2),
      ne = ee[0],
      te = ee[1],
      re = h(n.useState(0), 2),
      oe = re[0],
      ie = re[1],
      ue = h(n.useState(!1), 2),
      ae = ue[0],
      ce = ue[1],
      le = function () {
        ce(!0);
      },
      fe = function () {
        ce(!1);
      },
      se = {
        getKey: j
      };
    function pe(e) {
      te(function (n) {
        var t = function (e) {
          var n = e;
          Number.isNaN(Re.current) || (n = Math.min(n, Re.current));
          return n = Math.max(n, 0), n;
        }("function" == typeof e ? e(n) : e);
        return Z.current.scrollTop = t, t;
      });
    }
    var ve = n.useRef({
        start: 0,
        end: X.length
      }),
      de = n.useRef(),
      he = h(ro(X, j), 1)[0];
    de.current = he;
    var me = i.useMemo(function () {
        if (!B) return {
          scrollHeight: void 0,
          start: 0,
          end: X.length - 1,
          offset: void 0
        };
        var e;
        if (!Y) return {
          scrollHeight: (null === (e = Q.current) || void 0 === e ? void 0 : e.offsetHeight) || 0,
          start: 0,
          end: X.length - 1,
          offset: void 0
        };
        for (var n, t, r, o = 0, i = X.length, u = 0; u < i; u += 1) {
          var a = X[u],
            c = j(a),
            s = U.get(c),
            p = o + (void 0 === s ? f : s);
          p >= ne && void 0 === n && (n = u, t = o), p > ne + l && void 0 === r && (r = u), o = p;
        }
        return void 0 === n && (n = 0, t = 0, r = Math.ceil(l / f)), void 0 === r && (r = X.length - 1), {
          scrollHeight: o,
          start: n,
          end: r = Math.min(r + 1, X.length - 1),
          offset: t
        };
      }, [Y, B, ne, X, K, l]),
      ge = me.scrollHeight,
      ye = me.start,
      be = me.end,
      we = me.offset;
    ve.current.start = ye, ve.current.end = be;
    var _e = h(i.useState({
        width: 0,
        height: l
      }), 2),
      Ee = _e[0],
      Se = _e[1],
      Ce = n.useRef(),
      xe = n.useRef(),
      ke = i.useMemo(function () {
        return vo(Ee.width, O);
      }, [Ee.width, O]),
      Ne = i.useMemo(function () {
        return vo(Ee.height, ge);
      }, [Ee.height, ge]),
      Me = ge - l,
      Re = n.useRef(Me);
    Re.current = Me;
    var Ae = ne <= 0,
      Pe = ne >= Me,
      Ie = oe <= 0,
      De = oe >= O,
      Te = io(Ae, Pe, Ie, De),
      Le = function () {
        return {
          x: q ? -oe : oe,
          y: ne
        };
      },
      je = n.useRef(Le()),
      Ve = E(function (e) {
        if (R) {
          var n = _(_({}, Le()), e);
          je.current.x === n.x && je.current.y === n.y || (R(n), je.current = n);
        }
      });
    function ze(e, n) {
      var r = e;
      n ? (t.flushSync(function () {
        ie(r);
      }), Ve()) : pe(r);
    }
    var Fe = function (e) {
        var n = e,
          t = O ? O - Ee.width : 0;
        return n = Math.max(n, 0), n = Math.min(n, t);
      },
      We = E(function (e, n) {
        n ? (t.flushSync(function () {
          ie(function (n) {
            return Fe(n + (q ? -e : e));
          });
        }), Ve()) : pe(function (n) {
          return n + e;
        });
      }),
      He = h(uo(B, Ae, Pe, Ie, De, !!O, We), 2),
      Ue = He[0],
      Ke = He[1];
    !function (e, t, r) {
      var o,
        i = n.useRef(!1),
        u = n.useRef(0),
        a = n.useRef(0),
        c = n.useRef(null),
        l = n.useRef(null),
        f = function (e) {
          if (i.current) {
            var n = Math.ceil(e.touches[0].pageX),
              t = Math.ceil(e.touches[0].pageY),
              o = u.current - n,
              c = a.current - t,
              f = Math.abs(o) > Math.abs(c);
            f ? u.current = n : a.current = t;
            var s = r(f, f ? o : c, !1, e);
            s && e.preventDefault(), clearInterval(l.current), s && (l.current = setInterval(function () {
              f ? o *= lo : c *= lo;
              var e = Math.floor(f ? o : c);
              (!r(f, e, !0) || Math.abs(e) <= .1) && clearInterval(l.current);
            }, 16));
          }
        },
        s = function () {
          i.current = !1, o();
        },
        p = function (e) {
          o(), 1 !== e.touches.length || i.current || (i.current = !0, u.current = Math.ceil(e.touches[0].pageX), a.current = Math.ceil(e.touches[0].pageY), c.current = e.target, c.current.addEventListener("touchmove", f, {
            passive: !1
          }), c.current.addEventListener("touchend", s, {
            passive: !0
          }));
        };
      o = function () {
        c.current && (c.current.removeEventListener("touchmove", f), c.current.removeEventListener("touchend", s));
      }, x(function () {
        return e && t.current.addEventListener("touchstart", p, {
          passive: !0
        }), function () {
          var e;
          null === (e = t.current) || void 0 === e || e.removeEventListener("touchstart", p), o(), clearInterval(l.current);
        };
      }, [e]);
    }(B, Z, function (e, n, t, r) {
      var o = r;
      return !Te(e, n, t) && (!o || !o._virtualHandled) && (o && (o._virtualHandled = !0), Ue({
        preventDefault: function () {},
        deltaX: e ? n : 0,
        deltaY: e ? 0 : n
      }), !0);
    }), function (e, n, t) {
      i.useEffect(function () {
        var r = n.current;
        if (e && r) {
          var o,
            i,
            u = !1,
            a = function () {
              Sn.cancel(o);
            },
            c = function e() {
              a(), o = Sn(function () {
                t(i), e();
              });
            },
            l = function (e) {
              var n = e;
              n._virtualHandled || (n._virtualHandled = !0, u = !0);
            },
            f = function () {
              u = !1, a();
            },
            s = function (e) {
              if (u) {
                var n = so(e, !1),
                  t = r.getBoundingClientRect(),
                  o = t.top,
                  l = t.bottom;
                n <= o ? (i = -fo(o - n), c()) : n >= l ? (i = fo(n - l), c()) : a();
              }
            };
          return r.addEventListener("mousedown", l), r.ownerDocument.addEventListener("mouseup", f), r.ownerDocument.addEventListener("mousemove", s), function () {
            r.removeEventListener("mousedown", l), r.ownerDocument.removeEventListener("mouseup", f), r.ownerDocument.removeEventListener("mousemove", s), a();
          };
        }
      }, [e]);
    }(Y, Z, function (e) {
      pe(function (n) {
        return n + e;
      });
    }), x(function () {
      function e(e) {
        var n = Ae && e.detail < 0,
          t = Pe && e.detail > 0;
        !B || n || t || e.preventDefault();
      }
      var n = Z.current;
      return n.addEventListener("wheel", Ue, {
        passive: !1
      }), n.addEventListener("DOMMouseScroll", Ke, {
        passive: !0
      }), n.addEventListener("MozMousePixelScroll", e, {
        passive: !1
      }), function () {
        n.removeEventListener("wheel", Ue), n.removeEventListener("DOMMouseScroll", Ke), n.removeEventListener("MozMousePixelScroll", e);
      };
    }, [B, Ae, Pe]), x(function () {
      if (O) {
        var e = Fe(oe);
        ie(e), Ve({
          x: e
        });
      }
    }, [Ee.width, O]);
    var Be = function () {
        var e, n;
        null === (e = Ce.current) || void 0 === e || e.delayHidden(), null === (n = xe.current) || void 0 === n || n.delayHidden();
      },
      $e = function (e, n, t, r, o, u, a, c) {
        var l = i.useRef(),
          f = h(i.useState(null), 2),
          s = f[0],
          p = f[1];
        return x(function () {
          if (s && s.times < 10) {
            if (!e.current) return void p(function (e) {
              return _({}, e);
            });
            u();
            var i = s.targetAlign,
              c = s.originAlign,
              l = s.index,
              f = s.offset,
              v = e.current.clientHeight,
              d = !1,
              h = i,
              m = null;
            if (v) {
              for (var g = i || c, y = 0, b = 0, w = 0, E = Math.min(n.length - 1, l), S = 0; S <= E; S += 1) {
                var C = o(n[S]);
                b = y;
                var x = t.get(C);
                y = w = b + (void 0 === x ? r : x);
              }
              for (var O = "top" === g ? f : v - f, k = E; k >= 0; k -= 1) {
                var N = o(n[k]),
                  M = t.get(N);
                if (void 0 === M) {
                  d = !0;
                  break;
                }
                if ((O -= M) <= 0) break;
              }
              switch (g) {
                case "top":
                  m = b - f;
                  break;
                case "bottom":
                  m = w - v + f;
                  break;
                default:
                  var R = e.current.scrollTop;
                  b < R ? h = "top" : w > R + v && (h = "bottom");
              }
              null !== m && a(m), m !== s.lastTop && (d = !0);
            }
            d && p(_(_({}, s), {}, {
              times: s.times + 1,
              targetAlign: h,
              lastTop: m
            }));
          } else "production" !== process.env.NODE_ENV && 10 === (null == s ? void 0 : s.times) && T(!1, "Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.");
        }, [s, e.current]), function (e) {
          if (null != e) {
            if (Sn.cancel(l.current), "number" == typeof e) a(e);else if (e && "object" === g(e)) {
              var t,
                r = e.align;
              t = "index" in e ? e.index : n.findIndex(function (n) {
                return o(n) === e.key;
              });
              var i = e.offset;
              p({
                times: 0,
                index: t,
                offset: void 0 === i ? 0 : i,
                originAlign: r
              });
            }
          } else c();
        };
      }(Z, X, U, f, j, function () {
        return H(!0);
      }, pe, Be);
    i.useImperativeHandle(r, function () {
      return {
        nativeElement: J.current,
        getScrollInfo: Le,
        scrollTo: function (e) {
          var n;
          (n = e) && "object" === g(n) && ("left" in n || "top" in n) ? (void 0 !== e.left && ie(Fe(e.left)), $e(e.top)) : $e(e);
        }
      };
    }), x(function () {
      if (A) {
        var e = X.slice(ye, be + 1);
        A(e, X);
      }
    }, [ye, be, X]);
    var Ye = function (e, n, t, r) {
        var o = h(i.useMemo(function () {
            return [new Map(), []];
          }, [e, t.id, r]), 2),
          u = o[0],
          a = o[1];
        return function (o) {
          var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o,
            c = u.get(o),
            l = u.get(i);
          if (void 0 === c || void 0 === l) for (var f = e.length, s = a.length; s < f; s += 1) {
            var p,
              v = e[s],
              d = n(v);
            u.set(d, s);
            var h = null !== (p = t.get(d)) && void 0 !== p ? p : r;
            if (a[s] = (a[s - 1] || 0) + h, d === o && (c = s), d === i && (l = s), void 0 !== c && void 0 !== l) break;
          }
          return {
            top: a[c - 1] || 0,
            bottom: a[l]
          };
        };
      }(X, j, U, f),
      qe = null == I ? void 0 : I({
        start: ye,
        end: be,
        virtual: Y,
        offsetX: oe,
        offsetY: we,
        rtl: q,
        getSize: Ye
      }),
      Ge = function (e, n, t, r, o, u, a, c) {
        var l = c.getKey;
        return e.slice(n, t + 1).map(function (e, t) {
          var c = a(e, n + t, {
              style: {
                width: r
              },
              offsetX: o
            }),
            f = l(e);
          return i.createElement(to, {
            key: f,
            setRef: function (n) {
              return u(e, n);
            }
          }, c);
        });
      }(X, ye, be, O, oe, W, y, se),
      Xe = null;
    l && (Xe = _(b({}, p ? "height" : "maxHeight", l), go), B && (Xe.overflowY = "hidden", O && (Xe.overflowX = "hidden"), ae && (Xe.pointerEvents = "none")));
    var Ze = {};
    return q && (Ze.dir = "rtl"), i.createElement("div", c({
      ref: J,
      style: _(_({}, v), {}, {
        position: "relative"
      }),
      className: G
    }, Ze, L), i.createElement(vn, {
      onResize: function (e) {
        Se({
          width: e.offsetWidth,
          height: e.offsetHeight
        });
      }
    }, i.createElement(N, {
      className: "".concat(u, "-holder"),
      style: Xe,
      ref: Z,
      onScroll: function (e) {
        var n = e.currentTarget.scrollTop;
        n !== ne && pe(n), null == M || M(e), Ve();
      },
      onMouseEnter: Be
    }, i.createElement(no, {
      prefixCls: u,
      height: ge,
      offsetX: oe,
      offsetY: we,
      scrollWidth: O,
      onInnerResize: H,
      ref: Q,
      innerProps: P,
      rtl: q,
      extra: qe
    }, Ge))), Y && ge > l && i.createElement(po, {
      ref: Ce,
      prefixCls: u,
      scrollOffset: ne,
      scrollRange: ge,
      rtl: q,
      onScroll: ze,
      onStartMove: le,
      onStopMove: fe,
      spinSize: Ne,
      containerSize: Ee.height,
      style: null == D ? void 0 : D.verticalScrollBar,
      thumbStyle: null == D ? void 0 : D.verticalScrollBarThumb
    }), Y && O > Ee.width && i.createElement(po, {
      ref: xe,
      prefixCls: u,
      scrollOffset: oe,
      scrollRange: O,
      rtl: q,
      onScroll: ze,
      onStartMove: le,
      onStopMove: fe,
      spinSize: ke,
      containerSize: Ee.width,
      horizontal: !0,
      style: null == D ? void 0 : D.horizontalScrollBar,
      thumbStyle: null == D ? void 0 : D.horizontalScrollBarThumb
    }));
  }
  var bo = i.forwardRef(yo);
  bo.displayName = "List";
  var wo = i.createContext(null);
  var _o = ["disabled", "title", "children", "style", "className"];
  function Eo(e) {
    return "string" == typeof e || "number" == typeof e;
  }
  var So = function (e, t) {
      var r = be(),
        o = r.prefixCls,
        u = r.id,
        a = r.open,
        l = r.multiple,
        f = r.mode,
        s = r.searchValue,
        v = r.toggleOpen,
        d = r.notFoundContent,
        g = r.onPopupScroll,
        y = i.useContext(wo),
        w = y.flattenOptions,
        _ = y.onActiveValue,
        E = y.defaultActiveFirstOption,
        S = y.onSelect,
        C = y.menuItemSelectedIcon,
        x = y.rawValues,
        O = y.fieldNames,
        k = y.virtual,
        N = y.listHeight,
        M = y.listItemHeight,
        R = "".concat(o, "-item"),
        A = ae(function () {
          return w;
        }, [a, w], function (e, n) {
          return n[0] && e[1] !== n[1];
        }),
        P = i.useRef(null),
        I = function (e) {
          e.preventDefault();
        },
        D = function (e) {
          P.current && P.current.scrollTo("number" == typeof e ? {
            index: e
          } : e);
        },
        T = function (e) {
          for (var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, t = A.length, r = 0; r < t; r += 1) {
            var o = (e + r * n + t) % t,
              i = A[o],
              u = i.group,
              a = i.data;
            if (!u && !a.disabled) return o;
          }
          return -1;
        },
        L = h(i.useState(function () {
          return T(0);
        }), 2),
        j = L[0],
        V = L[1],
        z = function (e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          V(e);
          var t = {
              source: n ? "keyboard" : "mouse"
            },
            r = A[e];
          r ? _(r.value, e, t) : _(null, -1, t);
        };
      n.useEffect(function () {
        z(!1 !== E ? T(0) : -1);
      }, [A.length, s]);
      var W = i.useCallback(function (e) {
        return x.has(e) && "combobox" !== f;
      }, [f, p(x).toString(), x.size]);
      n.useEffect(function () {
        var e,
          n = setTimeout(function () {
            if (!l && a && 1 === x.size) {
              var e = Array.from(x)[0],
                n = A.findIndex(function (n) {
                  return n.data.value === e;
                });
              -1 !== n && (z(n), D(n));
            }
          });
        a && (null === (e = P.current) || void 0 === e || e.scrollTo(void 0));
        return function () {
          return clearTimeout(n);
        };
      }, [a, s, w.length]);
      var U = function (e) {
        void 0 !== e && S(e, {
          selected: !x.has(e)
        }), l || v(!1);
      };
      if (i.useImperativeHandle(t, function () {
        return {
          onKeyDown: function (e) {
            var n = e.which,
              t = e.ctrlKey;
            switch (n) {
              case H.N:
              case H.P:
              case H.UP:
              case H.DOWN:
                var r = 0;
                if (n === H.UP ? r = -1 : n === H.DOWN ? r = 1 : /(mac\sos|macintosh)/i.test(navigator.appVersion) && t && (n === H.N ? r = 1 : n === H.P && (r = -1)), 0 !== r) {
                  var o = T(j + r, r);
                  D(o), z(o, !0);
                }
                break;
              case H.ENTER:
                var i = A[j];
                i && !i.data.disabled ? U(i.value) : U(void 0), a && e.preventDefault();
                break;
              case H.ESC:
                v(!1), a && e.stopPropagation();
            }
          },
          onKeyUp: function () {},
          scrollTo: function (e) {
            D(e);
          }
        };
      }), 0 === A.length) return i.createElement("div", {
        role: "listbox",
        id: "".concat(u, "_list"),
        className: "".concat(R, "-empty"),
        onMouseDown: I
      }, d);
      var K = Object.keys(O).map(function (e) {
          return O[e];
        }),
        B = function (e) {
          return e.label;
        };
      function $(e, n) {
        return {
          role: e.group ? "presentation" : "option",
          id: "".concat(u, "_list_").concat(n)
        };
      }
      var Y = function (e) {
          var n = A[e];
          if (!n) return null;
          var t = n.data || {},
            r = t.value,
            o = n.group,
            u = Se(t, !0),
            a = B(n);
          return n ? i.createElement("div", c({
            "aria-label": "string" != typeof a || o ? null : a
          }, u, {
            key: e
          }, $(n, e), {
            "aria-selected": W(r)
          }), r) : null;
        },
        q = {
          role: "listbox",
          id: "".concat(u, "_list")
        };
      return i.createElement(i.Fragment, null, k && i.createElement("div", c({}, q, {
        style: {
          height: 0,
          width: 0,
          overflow: "hidden"
        }
      }), Y(j - 1), Y(j), Y(j + 1)), i.createElement(bo, {
        itemKey: "key",
        ref: P,
        data: A,
        height: N,
        itemHeight: M,
        fullHeight: !1,
        onMouseDown: I,
        onScroll: g,
        virtual: k,
        innerProps: k ? null : q
      }, function (e, n) {
        var t,
          r = e.group,
          o = e.groupOption,
          u = e.data,
          a = e.label,
          l = e.value,
          f = u.key;
        if (r) {
          var s,
            p = null !== (s = u.title) && void 0 !== s ? s : Eo(a) ? a.toString() : void 0;
          return i.createElement("div", {
            className: F(R, "".concat(R, "-group")),
            title: p
          }, void 0 !== a ? a : f);
        }
        var v = u.disabled,
          d = u.title;
        u.children;
        var h,
          g,
          y,
          w = u.style,
          _ = u.className,
          E = m(u, _o),
          S = (h = E, g = K, y = Object.assign({}, h), Array.isArray(g) && g.forEach(function (e) {
            delete y[e];
          }), y),
          x = W(l),
          O = "".concat(R, "-option"),
          N = F(R, O, _, (b(t = {}, "".concat(O, "-grouped"), o), b(t, "".concat(O, "-active"), j === n && !v), b(t, "".concat(O, "-disabled"), v), b(t, "".concat(O, "-selected"), x), t)),
          M = B(e),
          A = !C || "function" == typeof C || x,
          P = "number" == typeof M ? M : M || l,
          I = Eo(P) ? P.toString() : void 0;
        return void 0 !== d && (I = d), i.createElement("div", c({}, Se(S), k ? {} : $(e, n), {
          "aria-selected": x,
          className: N,
          title: I,
          onMouseMove: function () {
            j === n || v || z(n);
          },
          onClick: function () {
            v || U(l);
          },
          style: w
        }), i.createElement("div", {
          className: "".concat(O, "-content")
        }, P), i.isValidElement(C) || x, A && i.createElement(Vn, {
          className: "".concat(R, "-option-state"),
          customizeIcon: C,
          customizeIconProps: {
            isSelected: x
          }
        }, x ? "✓" : null));
      }));
    },
    Co = i.forwardRef(So);
  Co.displayName = "OptionList";
  var xo = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "listHeight", "listItemHeight", "value", "defaultValue", "labelInValue", "onChange"],
    Oo = ["inputValue"];
  var ko = i.forwardRef(function (e, n) {
    var t = e.id,
      r = e.mode,
      o = e.prefixCls,
      u = void 0 === o ? "rc-select" : o,
      a = e.backfill,
      l = e.fieldNames,
      f = e.inputValue,
      s = e.searchValue,
      v = e.onSearch,
      d = e.autoClearSearchValue,
      y = void 0 === d || d,
      w = e.onSelect,
      E = e.onDeselect,
      S = e.dropdownMatchSelectWidth,
      C = void 0 === S || S,
      x = e.filterOption,
      O = e.filterSort,
      k = e.optionFilterProp,
      N = e.optionLabelProp,
      R = e.options,
      A = e.children,
      P = e.defaultActiveFirstOption,
      I = e.menuItemSelectedIcon,
      D = e.virtual,
      j = e.listHeight,
      V = void 0 === j ? 200 : j,
      z = e.listItemHeight,
      F = void 0 === z ? 20 : z,
      W = e.value,
      H = e.defaultValue,
      U = e.labelInValue,
      K = e.onChange,
      B = m(e, xo),
      $ = qr(t),
      Y = Ur(r),
      q = !(R || !A),
      G = i.useMemo(function () {
        return (void 0 !== x || "combobox" !== r) && x;
      }, [x, r]),
      X = i.useMemo(function () {
        return Vr(l, q);
      }, [JSON.stringify(l), q]),
      Z = h(M("", {
        value: void 0 !== s ? s : f,
        postState: function (e) {
          return e || "";
        }
      }), 2),
      Q = Z[0],
      J = Z[1],
      ee = function (e, n, t, r, o) {
        return i.useMemo(function () {
          var i = e;
          !e && (i = Zr(n));
          var u = new Map(),
            a = new Map(),
            c = function (e, n, t) {
              t && "string" == typeof t && e.set(n[t], n);
            };
          return function e(n) {
            for (var i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], l = 0; l < n.length; l += 1) {
              var f = n[l];
              !f[t.options] || i ? (u.set(f[t.value], f), c(a, f, t.label), c(a, f, r), c(a, f, o)) : e(f[t.options], !0);
            }
          }(i), {
            options: i,
            valueOptions: u,
            labelOptions: a
          };
        }, [e, n, t, r, o]);
      }(R, A, X, k, N),
      ne = ee.valueOptions,
      te = ee.labelOptions,
      re = ee.options,
      oe = i.useCallback(function (e) {
        return Wn(e).map(function (e) {
          var n, t, r, o, i, u;
          (function (e) {
            return !e || "object" !== g(e);
          })(e) ? n = e : (r = e.key, t = e.label, n = null !== (u = e.value) && void 0 !== u ? u : r);
          var a,
            c = ne.get(n);
          if (c && (void 0 === t && (t = null == c ? void 0 : c[N || X.label]), void 0 === r && (r = null !== (a = null == c ? void 0 : c.key) && void 0 !== a ? a : n), o = null == c ? void 0 : c.disabled, i = null == c ? void 0 : c.title, "production" !== process.env.NODE_ENV && !N)) {
            var l = null == c ? void 0 : c[X.label];
            void 0 !== l && l !== t && T(!1, "`label` of `value` is not same as `label` in Select options.");
          }
          return {
            label: t,
            value: n,
            key: r,
            disabled: o,
            title: i
          };
        });
      }, [X, N, ne]),
      ie = h(M(H, {
        value: W
      }), 2),
      ue = ie[0],
      ae = ie[1],
      ce = function (e, n) {
        var t = i.useRef({
          values: new Map(),
          options: new Map()
        });
        return [i.useMemo(function () {
          var r = t.current,
            o = r.values,
            i = r.options,
            u = e.map(function (e) {
              var n;
              return void 0 === e.label ? _(_({}, e), {}, {
                label: null === (n = o.get(e.value)) || void 0 === n ? void 0 : n.label
              }) : e;
            }),
            a = new Map(),
            c = new Map();
          return u.forEach(function (e) {
            a.set(e.value, e), c.set(e.value, n.get(e.value) || i.get(e.value));
          }), t.current.values = a, t.current.options = c, u;
        }, [e, n]), i.useCallback(function (e) {
          return n.get(e) || t.current.options.get(e);
        }, [n])];
      }(i.useMemo(function () {
        var e,
          n = oe(ue);
        return "combobox" !== r || null !== (e = n[0]) && void 0 !== e && e.value ? n : [];
      }, [ue, oe, r]), ne),
      le = h(ce, 2),
      fe = le[0],
      se = le[1],
      pe = i.useMemo(function () {
        if (!r && 1 === fe.length) {
          var e = fe[0];
          if (null === e.value && (null === e.label || void 0 === e.label)) return [];
        }
        return fe.map(function (e) {
          var n;
          return _(_({}, e), {}, {
            label: null !== (n = e.label) && void 0 !== n ? n : e.value
          });
        });
      }, [r, fe]),
      ve = i.useMemo(function () {
        return new Set(fe.map(function (e) {
          return e.value;
        }));
      }, [fe]);
    i.useEffect(function () {
      if ("combobox" === r) {
        var e,
          n = null === (e = fe[0]) || void 0 === e ? void 0 : e.value;
        J(function (e) {
          return null != e;
        }(n) ? String(n) : "");
      }
    }, [fe]);
    var de = Qr(function (e, n) {
        var t,
          r = null != n ? n : e;
        return b(t = {}, X.value, e), b(t, X.label, r), t;
      }),
      he = i.useMemo(function () {
        if ("tags" !== r) return re;
        var e = p(re);
        return p(fe).sort(function (e, n) {
          return e.value < n.value ? -1 : 1;
        }).forEach(function (n) {
          var t = n.value;
          (function (e) {
            return ne.has(e);
          })(t) || e.push(de(t, n.label));
        }), e;
      }, [de, re, ne, fe, r]),
      me = function (e, n, t, r, o) {
        return i.useMemo(function () {
          if (!t || !1 === r) return e;
          var i = n.options,
            u = n.label,
            a = n.value,
            c = [],
            l = "function" == typeof r,
            f = t.toUpperCase(),
            s = l ? r : function (e, n) {
              return o ? Br(n[o], f) : n[i] ? Br(n["children" !== u ? u : "label"], f) : Br(n[a], f);
            },
            p = l ? function (e) {
              return zr(e);
            } : function (e) {
              return e;
            };
          return e.forEach(function (e) {
            if (e[i]) {
              if (s(t, p(e))) c.push(e);else {
                var n = e[i].filter(function (e) {
                  return s(t, p(e));
                });
                n.length && c.push(_(_({}, e), {}, b({}, i, n)));
              }
            } else s(t, p(e)) && c.push(e);
          }), c;
        }, [e, r, o, t, n]);
      }(he, X, Q, G, k),
      ge = i.useMemo(function () {
        return "tags" !== r || !Q || me.some(function (e) {
          return e[k || "value"] === Q;
        }) ? me : [de(Q)].concat(p(me));
      }, [de, k, r, me, Q]),
      ye = i.useMemo(function () {
        return O ? p(ge).sort(function (e, n) {
          return O(e, n);
        }) : ge;
      }, [ge, O]),
      be = i.useMemo(function () {
        return function (e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            t = n.fieldNames,
            r = n.childrenAsData,
            o = [],
            i = Vr(t, !1),
            u = i.label,
            a = i.value,
            c = i.options;
          return function e(n, t) {
            n.forEach(function (n) {
              var i = n[u];
              if (t || !(c in n)) {
                var l = n[a];
                o.push({
                  key: jr(n, o.length),
                  groupOption: t,
                  data: n,
                  label: i,
                  value: l
                });
              } else {
                var f = i;
                void 0 === f && r && (f = n.label), o.push({
                  key: jr(n, o.length),
                  group: !0,
                  data: n,
                  label: f
                }), e(n[c], !0);
              }
            });
          }(e, !1), o;
        }(ye, {
          fieldNames: X,
          childrenAsData: q
        });
      }, [ye, X, q]),
      we = function (e) {
        var n = oe(e);
        if (ae(n), K && (n.length !== fe.length || n.some(function (e, n) {
          var t;
          return (null === (t = fe[n]) || void 0 === t ? void 0 : t.value) !== (null == e ? void 0 : e.value);
        }))) {
          var t = U ? n : n.map(function (e) {
              return e.value;
            }),
            r = n.map(function (e) {
              return zr(se(e.value));
            });
          K(Y ? t : t[0], Y ? r : r[0]);
        }
      },
      _e = h(i.useState(null), 2),
      Ee = _e[0],
      Se = _e[1],
      xe = h(i.useState(0), 2),
      Oe = xe[0],
      ke = xe[1],
      Ne = void 0 !== P ? P : "combobox" !== r,
      Me = i.useCallback(function (e, n) {
        var t = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).source,
          o = void 0 === t ? "keyboard" : t;
        ke(n), a && "combobox" === r && null !== e && "keyboard" === o && Se(String(e));
      }, [a, r]),
      Re = function (e, n, t) {
        var r = function () {
          var n,
            t = se(e);
          return [U ? {
            label: null == t ? void 0 : t[X.label],
            value: e,
            key: null !== (n = null == t ? void 0 : t.key) && void 0 !== n ? n : e
          } : e, zr(t)];
        };
        if (n && w) {
          var o = h(r(), 2),
            i = o[0],
            u = o[1];
          w(i, u);
        } else if (!n && E && "clear" !== t) {
          var a = h(r(), 2),
            c = a[0],
            l = a[1];
          E(c, l);
        }
      },
      Ae = Qr(function (e, n) {
        var t,
          o = !Y || n.selected;
        t = o ? Y ? [].concat(p(fe), [e]) : [e] : fe.filter(function (n) {
          return n.value !== e;
        }), we(t), Re(e, o), "combobox" === r ? Se("") : Ur && !y || (J(""), Se(""));
      }),
      Pe = i.useMemo(function () {
        var e = !1 !== D && !1 !== C;
        return _(_({}, ee), {}, {
          flattenOptions: be,
          onActiveValue: Me,
          defaultActiveFirstOption: Ne,
          onSelect: Ae,
          menuItemSelectedIcon: I,
          rawValues: ve,
          fieldNames: X,
          virtual: e,
          listHeight: V,
          listItemHeight: F,
          childrenAsData: q
        });
      }, [ee, be, Me, Ne, Ae, I, ve, X, D, C, V, F, q]);
    return "production" !== process.env.NODE_ENV && (function (e) {
      var n = e.mode,
        t = e.options,
        r = e.children,
        o = e.backfill,
        u = e.allowClear,
        a = e.placeholder,
        c = e.getInputElement,
        l = e.showSearch,
        f = e.onSearch,
        s = e.defaultOpen,
        p = e.autoFocus,
        v = e.labelInValue,
        d = e.value,
        h = e.inputValue,
        m = e.optionLabelProp,
        y = Ur(n),
        b = void 0 !== l ? l : y || "combobox" === n,
        w = t || Zr(r);
      if (T("tags" !== n || w.every(function (e) {
        return !e.disabled;
      }), "Please avoid setting option to disabled in tags mode since user can always type text as tag."), ("tags" === n || "combobox" === n) && T(!w.some(function (e) {
        return e.options ? e.options.some(function (e) {
          return "number" == typeof ("value" in e ? e.value : e.key);
        }) : "number" == typeof ("value" in e ? e.value : e.key);
      }), "`value` of Option should not use number type when `mode` is `tags` or `combobox`."), T("combobox" !== n || !m, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly."), T("combobox" === n || !o, "`backfill` only works with `combobox` mode."), T("combobox" === n || !c, "`getInputElement` only work with `combobox` mode."), L("combobox" !== n || !c || !u || !a, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`."), f && !b && "combobox" !== n && "tags" !== n && T(!1, "`onSearch` should work with `showSearch` instead of use alone."), L(!s || p, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed."), null != d) {
        var _ = Wn(d);
        T(!v || _.every(function (e) {
          return "object" === g(e) && ("key" in e || "value" in e);
        }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`"), T(!y || Array.isArray(d), "`value` should be array when `mode` is `multiple` or `tags`");
      }
      if (r) {
        var E = null;
        Ce(r).some(function (e) {
          if (!i.isValidElement(e) || !e.type) return !1;
          var n = e.type;
          return !n.isSelectOption && (n.isSelectOptGroup ? !Ce(e.props.children).every(function (n) {
            return !(i.isValidElement(n) && e.type && !n.type.isSelectOption && (E = n.type, 1));
          }) : (E = n, !0));
        }), E && T(!1, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(E.displayName || E.name || E, "`.")), T(void 0 === h, "`inputValue` is deprecated, please use `searchValue` instead.");
      }
    }(e), function (e, n) {
      e && function e(t) {
        for (var r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], o = 0; o < t.length; o++) {
          var i = t[o];
          if (null === i[null == n ? void 0 : n.value]) return T(!1, "`value` in Select options should not be `null`."), !0;
          if (!r && Array.isArray(i[null == n ? void 0 : n.options]) && e(i[null == n ? void 0 : n.options], !0)) break;
        }
      }(e);
    }(re, X)), i.createElement(wo.Provider, {
      value: Pe
    }, i.createElement(Kr, c({}, B, {
      id: $,
      prefixCls: u,
      ref: n,
      omitDomProps: Oo,
      mode: r,
      displayValues: pe,
      onDisplayValuesChange: function (e, n) {
        we(e);
        var t = n.type,
          r = n.values;
        "remove" !== t && "clear" !== t || r.forEach(function (e) {
          Re(e.value, !1, t);
        });
      },
      searchValue: Q,
      onSearch: function (e, n) {
        if (J(e), Se(null), "submit" !== n.source) "blur" !== n.source && ("combobox" === r && we(e), null == v || v(e));else {
          var t = (e || "").trim();
          if (t) {
            var o = Array.from(new Set([].concat(p(ve), [t])));
            we(o), Re(t, !0), J("");
          }
        }
      },
      autoClearSearchValue: y,
      onSearchSplit: function (e) {
        var n = e;
        "tags" !== r && (n = e.map(function (e) {
          var n = te.get(e);
          return null == n ? void 0 : n.value;
        }).filter(function (e) {
          return void 0 !== e;
        }));
        var t = Array.from(new Set([].concat(p(ve), p(n))));
        we(t), t.forEach(function (e) {
          Re(e, !0);
        });
      },
      dropdownMatchSelectWidth: C,
      OptionList: Co,
      emptyOptions: !be.length,
      activeValue: Ee,
      activeDescendantId: "".concat($, "_list_").concat(Oe)
    })));
  });
  "production" !== process.env.NODE_ENV && (ko.displayName = "Select");
  var No = ko;
  function Mo(e, n) {
    var t = new Set();
    return e.forEach(function (e) {
      n.has(e) || t.add(e);
    }), t;
  }
  function Ro(e) {
    var n = e || {},
      t = n.disabled,
      r = n.disableCheckbox,
      o = n.checkable;
    return !(!t && !r) || !1 === o;
  }
  function Ao(e, n, t, r) {
    var o,
      i = [];
    o = r || Ro;
    var u,
      a = new Set(e.filter(function (e) {
        var n = !!function (e, n) {
          return e[n];
        }(t, e);
        return n || i.push(e), n;
      })),
      c = new Map(),
      l = 0;
    return Object.keys(t).forEach(function (e) {
      var n = t[e],
        r = n.level,
        o = c.get(r);
      o || (o = new Set(), c.set(r, o)), o.add(n), l = Math.max(l, r);
    }), T(!i.length, "Tree missing follow keys: ".concat(i.slice(0, 100).map(function (e) {
      return "'".concat(e, "'");
    }).join(", "))), u = !0 === n ? function (e, n, t, r) {
      for (var o = new Set(e), i = new Set(), u = 0; u <= t; u += 1) (n.get(u) || new Set()).forEach(function (e) {
        var n = e.key,
          t = e.node,
          i = e.children,
          u = void 0 === i ? [] : i;
        o.has(n) && !r(t) && u.filter(function (e) {
          return !r(e.node);
        }).forEach(function (e) {
          o.add(e.key);
        });
      });
      for (var a = new Set(), c = t; c >= 0; c -= 1) (n.get(c) || new Set()).forEach(function (e) {
        var n = e.parent,
          t = e.node;
        if (!r(t) && e.parent && !a.has(e.parent.key)) if (r(e.parent.node)) a.add(n.key);else {
          var u = !0,
            c = !1;
          (n.children || []).filter(function (e) {
            return !r(e.node);
          }).forEach(function (e) {
            var n = e.key,
              t = o.has(n);
            u && !t && (u = !1), c || !t && !i.has(n) || (c = !0);
          }), u && o.add(n.key), c && i.add(n.key), a.add(n.key);
        }
      });
      return {
        checkedKeys: Array.from(o),
        halfCheckedKeys: Array.from(Mo(i, o))
      };
    }(a, c, l, o) : function (e, n, t, r, o) {
      for (var i = new Set(e), u = new Set(n), a = 0; a <= r; a += 1) (t.get(a) || new Set()).forEach(function (e) {
        var n = e.key,
          t = e.node,
          r = e.children,
          a = void 0 === r ? [] : r;
        i.has(n) || u.has(n) || o(t) || a.filter(function (e) {
          return !o(e.node);
        }).forEach(function (e) {
          i.delete(e.key);
        });
      });
      u = new Set();
      for (var c = new Set(), l = r; l >= 0; l -= 1) (t.get(l) || new Set()).forEach(function (e) {
        var n = e.parent,
          t = e.node;
        if (!o(t) && e.parent && !c.has(e.parent.key)) if (o(e.parent.node)) c.add(n.key);else {
          var r = !0,
            a = !1;
          (n.children || []).filter(function (e) {
            return !o(e.node);
          }).forEach(function (e) {
            var n = e.key,
              t = i.has(n);
            r && !t && (r = !1), a || !t && !u.has(n) || (a = !0);
          }), r || i.delete(n.key), a && u.add(n.key), c.add(n.key);
        }
      });
      return {
        checkedKeys: Array.from(i),
        halfCheckedKeys: Array.from(Mo(u, i))
      };
    }(a, n.halfCheckedKeys, c, l, o), u;
  }
  No.Option = eo, No.OptGroup = Jr;
  var Po = i.createContext(null),
    Io = "__rc_cascader_search_mark__",
    Do = function (e, n, t) {
      var r = t.label;
      return n.some(function (n) {
        return String(n[r]).toLowerCase().includes(e.toLowerCase());
      });
    },
    To = function (e, n, t, r) {
      return n.map(function (e) {
        return e[r.label];
      }).join(" / ");
    },
    Lo = "__RC_CASCADER_SPLIT__",
    jo = "SHOW_PARENT",
    Vo = "SHOW_CHILD";
  function zo(e) {
    return e.join(Lo);
  }
  function Fo(e) {
    return e.map(zo);
  }
  function Wo(e, n) {
    var t, r;
    return null !== (t = e.isLeaf) && void 0 !== t ? t : !(null !== (r = e[n.children]) && void 0 !== r && r.length);
  }
  function Ho(e) {
    var n = e.parentElement;
    if (n) {
      var t = e.offsetTop - n.offsetTop;
      t - n.scrollTop < 0 ? n.scrollTo({
        top: t
      }) : t + e.offsetHeight - n.scrollTop > n.offsetHeight && n.scrollTo({
        top: t + e.offsetHeight - n.offsetHeight
      });
    }
  }
  function Uo(e, n) {
    return e.map(function (e) {
      var t;
      return null === (t = e[Io]) || void 0 === t ? void 0 : t.map(function (e) {
        return e[n.value];
      });
    });
  }
  function Ko(e, n, t) {
    var r = new Set(e),
      o = n();
    return e.filter(function (e) {
      var n = o[e],
        i = n ? n.parent : null,
        u = n ? n.children : null;
      return t === Vo ? !(u && u.some(function (e) {
        return e.key && r.has(e.key);
      })) : !(i && !i.node.disabled && r.has(i.key));
    });
  }
  function Bo(e, n, t) {
    for (var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], o = n, i = [], u = function () {
        var n,
          u,
          c,
          l = e[a],
          f = null === (n = o) || void 0 === n ? void 0 : n.findIndex(function (e) {
            var n = e[t.value];
            return r ? String(n) === String(l) : n === l;
          }),
          s = -1 !== f ? null === (u = o) || void 0 === u ? void 0 : u[f] : null;
        i.push({
          value: null !== (c = null == s ? void 0 : s[t.value]) && void 0 !== c ? c : l,
          index: f,
          option: s
        }), o = null == s ? void 0 : s[t.children];
      }, a = 0; a < e.length; a += 1) u();
    return i;
  }
  function $o(e, n) {
    return null != e ? e : n;
  }
  function Yo(e) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      t = n.initWrapper,
      r = n.processEntity,
      o = n.onProcessFinished,
      i = n.externalGetKey,
      u = n.childrenPropName,
      a = n.fieldNames,
      c = i || (arguments.length > 2 ? arguments[2] : void 0),
      l = {},
      f = {},
      s = {
        posEntities: l,
        keyEntities: f
      };
    return t && (s = t(s) || s), function (e, n, t) {
      var r,
        o = ("object" === g(t) ? t : {
          externalGetKey: t
        }) || {},
        i = o.childrenPropName,
        u = o.externalGetKey,
        a = function (e) {
          var n = e || {},
            t = n.title || "title";
          return {
            title: t,
            _title: n._title || [t],
            key: n.key || "key",
            children: n.children || "children"
          };
        }(o.fieldNames),
        c = a.key,
        l = a.children,
        f = i || l;
      u ? "string" == typeof u ? r = function (e) {
        return e[u];
      } : "function" == typeof u && (r = function (e) {
        return u(e);
      }) : r = function (e, n) {
        return $o(e[c], n);
      }, function t(o, i, u, a) {
        var c = o ? o[f] : e,
          l = o ? function (e, n) {
            return "".concat(e, "-").concat(n);
          }(u.pos, i) : "0",
          s = o ? [].concat(p(a), [o]) : [];
        if (o) {
          var v = r(o, l),
            d = {
              node: o,
              index: i,
              pos: l,
              key: v,
              parentPos: u.node ? u.pos : null,
              level: u.level + 1,
              nodes: s
            };
          n(d);
        }
        c && c.forEach(function (e, n) {
          t(e, n, {
            node: o,
            pos: l,
            level: u ? u.level + 1 : -1
          }, s);
        });
      }(null);
    }(e, function (e) {
      var n = e.node,
        t = e.index,
        o = e.pos,
        i = e.key,
        u = e.parentPos,
        a = e.level,
        c = {
          node: n,
          nodes: e.nodes,
          index: t,
          key: i,
          pos: o,
          level: a
        },
        p = $o(i, o);
      l[o] = c, f[p] = c, c.parent = l[u], c.parent && (c.parent.children = c.parent.children || [], c.parent.children.push(c)), r && r(c, s);
    }, {
      externalGetKey: c,
      childrenPropName: u,
      fieldNames: a
    }), o && o(s), s;
  }
  function qo(e) {
    var n = i.useRef();
    n.current = e;
    var t = i.useCallback(function () {
      return n.current.apply(n, arguments);
    }, []);
    return t;
  }
  function Go(e) {
    var n,
      t = e.prefixCls,
      r = e.checked,
      o = e.halfChecked,
      u = e.disabled,
      a = e.onClick,
      c = i.useContext(Po).checkable,
      l = "boolean" != typeof c ? c : null;
    return i.createElement("span", {
      className: F("".concat(t), (n = {}, b(n, "".concat(t, "-checked"), r), b(n, "".concat(t, "-indeterminate"), !r && o), b(n, "".concat(t, "-disabled"), u), n)),
      onClick: a
    }, l);
  }
  var Xo = "__cascader_fix_label__";
  function Zo(e) {
    var n = e.prefixCls,
      t = e.multiple,
      r = e.options,
      o = e.activeValue,
      u = e.prevValuePath,
      a = e.onToggleOpen,
      c = e.onSelect,
      l = e.onActive,
      f = e.checkedSet,
      s = e.halfCheckedSet,
      v = e.loadingKeys,
      d = e.isSelectable,
      h = "".concat(n, "-menu"),
      m = "".concat(n, "-menu-item"),
      g = i.useContext(Po),
      y = g.fieldNames,
      w = g.changeOnSelect,
      _ = g.expandTrigger,
      E = g.expandIcon,
      S = g.loadingIcon,
      C = g.dropdownMenuColumnStyle,
      x = "hover" === _,
      O = i.useMemo(function () {
        return r.map(function (e) {
          var n,
            t = e.disabled,
            r = e[Io],
            o = null !== (n = e[Xo]) && void 0 !== n ? n : e[y.label],
            i = e[y.value],
            a = Wo(e, y),
            c = r ? r.map(function (e) {
              return e[y.value];
            }) : [].concat(p(u), [i]),
            l = zo(c);
          return {
            disabled: t,
            label: o,
            value: i,
            isLeaf: a,
            isLoading: v.includes(l),
            checked: f.has(l),
            halfChecked: s.has(l),
            option: e,
            fullPath: c,
            fullPathKey: l
          };
        });
      }, [r, f, y, s, v, u]);
    return i.createElement("ul", {
      className: h,
      role: "menu"
    }, O.map(function (e) {
      var r,
        u,
        f = e.disabled,
        s = e.label,
        v = e.value,
        h = e.isLeaf,
        g = e.isLoading,
        y = e.checked,
        _ = e.halfChecked,
        O = e.option,
        k = e.fullPath,
        N = e.fullPathKey,
        M = function () {
          if (!f) {
            var e = p(k);
            x && h && e.pop(), l(e);
          }
        },
        R = function () {
          d(O) && c(k, h);
        };
      return "string" == typeof O.title ? u = O.title : "string" == typeof s && (u = s), i.createElement("li", {
        key: N,
        className: F(m, (r = {}, b(r, "".concat(m, "-expand"), !h), b(r, "".concat(m, "-active"), o === v || o === N), b(r, "".concat(m, "-disabled"), f), b(r, "".concat(m, "-loading"), g), r)),
        style: C,
        role: "menuitemcheckbox",
        title: u,
        "aria-checked": y,
        "data-path-key": N,
        onClick: function () {
          M(), t && !h || R();
        },
        onDoubleClick: function () {
          w && a(!1);
        },
        onMouseEnter: function () {
          x && M();
        },
        onMouseDown: function (e) {
          e.preventDefault();
        }
      }, t && i.createElement(Go, {
        prefixCls: "".concat(n, "-checkbox"),
        checked: y,
        halfChecked: _,
        disabled: f,
        onClick: function (e) {
          e.stopPropagation(), R();
        }
      }), i.createElement("div", {
        className: "".concat(m, "-content")
      }, s), !g && E && !h && i.createElement("div", {
        className: "".concat(m, "-expand-icon")
      }, E), g && S && i.createElement("div", {
        className: "".concat(m, "-loading-icon")
      }, S));
    }));
  }
  var Qo = function (e, n, t, r, o, u) {
      var a = be(),
        c = a.direction,
        l = a.searchValue,
        f = a.toggleOpen,
        s = a.open,
        v = "rtl" === c,
        d = i.useMemo(function () {
          for (var e = -1, o = n, i = [], u = [], a = r.length, c = Uo(n, t), l = function (n) {
              var a = o.findIndex(function (e, o) {
                return (c[o] ? zo(c[o]) : e[t.value]) === r[n];
              });
              if (-1 === a) return "break";
              e = a, i.push(e), u.push(r[n]), o = o[e][t.children];
            }, f = 0; f < a && o; f += 1) {
            if ("break" === l(f)) break;
          }
          for (var s = n, p = 0; p < i.length - 1; p += 1) s = s[i[p]][t.children];
          return [u, e, s, c];
        }, [r, t, n]),
        m = h(d, 4),
        g = m[0],
        y = m[1],
        b = m[2],
        w = m[3],
        _ = function (e) {
          o(e);
        },
        E = function () {
          if (g.length > 1) {
            var e = g.slice(0, -1);
            _(e);
          } else f(!1);
        },
        S = function () {
          var e,
            n = ((null === (e = b[y]) || void 0 === e ? void 0 : e[t.children]) || []).find(function (e) {
              return !e.disabled;
            });
          if (n) {
            var r = [].concat(p(g), [n[t.value]]);
            _(r);
          }
        };
      i.useImperativeHandle(e, function () {
        return {
          onKeyDown: function (e) {
            var n = e.which;
            switch (n) {
              case H.UP:
              case H.DOWN:
                var r = 0;
                n === H.UP ? r = -1 : n === H.DOWN && (r = 1), 0 !== r && function (e) {
                  var n = b.length,
                    r = y;
                  -1 === r && e < 0 && (r = n);
                  for (var o = 0; o < n; o += 1) {
                    var i = b[r = (r + e + n) % n];
                    if (i && !i.disabled) {
                      var u = g.slice(0, -1).concat(w[r] ? zo(w[r]) : i[t.value]);
                      return void _(u);
                    }
                  }
                }(r);
                break;
              case H.LEFT:
                v ? S() : E();
                break;
              case H.RIGHT:
                v ? E() : S();
                break;
              case H.BACKSPACE:
                l || E();
                break;
              case H.ENTER:
                if (g.length) {
                  var o = b[y],
                    i = (null == o ? void 0 : o[Io]) || [];
                  i.length ? u(i.map(function (e) {
                    return e[t.value];
                  }), i[i.length - 1]) : u(g, b[y]);
                }
                break;
              case H.ESC:
                f(!1), s && e.stopPropagation();
            }
          },
          onKeyUp: function () {}
        };
      });
    },
    Jo = i.forwardRef(function (e, n) {
      var t,
        r,
        o,
        u,
        a = be(),
        l = a.prefixCls,
        f = a.multiple,
        s = a.searchValue,
        v = a.toggleOpen,
        d = a.notFoundContent,
        m = a.direction,
        g = i.useRef(),
        y = "rtl" === m,
        w = i.useContext(Po),
        E = w.options,
        S = w.values,
        C = w.halfValues,
        x = w.fieldNames,
        O = w.changeOnSelect,
        k = w.onSelect,
        N = w.searchOptions,
        M = w.dropdownPrefixCls,
        R = w.loadData,
        A = w.expandTrigger,
        P = M || l,
        I = h(i.useState([]), 2),
        D = I[0],
        T = I[1];
      i.useEffect(function () {
        D.length && D.forEach(function (e) {
          var n = Bo(e.split(Lo), E, x, !0).map(function (e) {
              return e.option;
            }),
            t = n[n.length - 1];
          (!t || t[x.children] || Wo(t, x)) && T(function (n) {
            return n.filter(function (n) {
              return n !== e;
            });
          });
        });
      }, [E, D, x]);
      var L = i.useMemo(function () {
          return new Set(Fo(S));
        }, [S]),
        j = i.useMemo(function () {
          return new Set(Fo(C));
        }, [C]),
        V = function () {
          var e = be(),
            n = e.multiple,
            t = e.open,
            r = i.useContext(Po).values,
            o = h(i.useState([]), 2),
            u = o[0],
            a = o[1];
          return i.useEffect(function () {
            if (t && !n) {
              var e = r[0];
              a(e || []);
            }
          }, [t]), [u, a];
        }(),
        z = h(V, 2),
        W = z[0],
        H = z[1],
        U = function (e) {
          H(e), function (e) {
            if (R && !s) {
              var n = Bo(e, E, x).map(function (e) {
                  return e.option;
                }),
                t = n[n.length - 1];
              if (t && !Wo(t, x)) {
                var r = zo(e);
                T(function (e) {
                  return [].concat(p(e), [r]);
                }), R(n);
              }
            }
          }(e);
        },
        K = function (e) {
          var n = e.disabled,
            t = Wo(e, x);
          return !n && (t || O || f);
        },
        B = function (e, n) {
          var t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          k(e), !f && (n || O && ("hover" === A || t)) && v(!1);
        },
        $ = i.useMemo(function () {
          return s ? N : E;
        }, [s, N, E]),
        Y = i.useMemo(function () {
          for (var e = [{
              options: $
            }], n = $, t = Uo(n, x), r = function () {
              var r = W[o],
                i = n.find(function (e, n) {
                  return (t[n] ? zo(t[n]) : e[x.value]) === r;
                }),
                u = null == i ? void 0 : i[x.children];
              if (null == u || !u.length) return "break";
              n = u, e.push({
                options: u
              });
            }, o = 0; o < W.length; o += 1) {
            if ("break" === r()) break;
          }
          return e;
        }, [$, W, x]);
      Qo(n, $, x, W, U, function (e, n) {
        K(n) && B(e, Wo(n, x), !0);
      }), i.useEffect(function () {
        for (var e = 0; e < W.length; e += 1) {
          var n,
            t = zo(W.slice(0, e + 1)),
            r = null === (n = g.current) || void 0 === n ? void 0 : n.querySelector('li[data-path-key="'.concat(t.replace(/\\{0,2}"/g, '\\"'), '"]'));
          r && Ho(r);
        }
      }, [W]);
      var q = !(null !== (t = Y[0]) && void 0 !== t && null !== (r = t.options) && void 0 !== r && r.length),
        G = [(o = {}, b(o, x.value, "__EMPTY__"), b(o, Xo, d), b(o, "disabled", !0), o)],
        X = _(_({}, e), {}, {
          multiple: !q && f,
          onSelect: B,
          onActive: U,
          onToggleOpen: v,
          checkedSet: L,
          halfCheckedSet: j,
          loadingKeys: D,
          isSelectable: K
        }),
        Z = (q ? [{
          options: G
        }] : Y).map(function (e, n) {
          var t = W.slice(0, n),
            r = W[n];
          return i.createElement(Zo, c({
            key: n
          }, X, {
            prefixCls: P,
            options: e.options,
            prevValuePath: t,
            activeValue: r
          }));
        });
      return i.createElement("div", {
        className: F("".concat(P, "-menus"), (u = {}, b(u, "".concat(P, "-menu-empty"), q), b(u, "".concat(P, "-rtl"), y), u)),
        ref: g
      }, Z);
    });
  var ei = ["id", "prefixCls", "fieldNames", "defaultValue", "value", "changeOnSelect", "onChange", "displayRender", "checkable", "searchValue", "onSearch", "showSearch", "expandTrigger", "options", "dropdownPrefixCls", "loadData", "popupVisible", "open", "popupClassName", "dropdownClassName", "dropdownMenuColumnStyle", "popupPlacement", "placement", "onDropdownVisibleChange", "onPopupVisibleChange", "expandIcon", "loadingIcon", "children", "dropdownMatchSelectWidth", "showCheckedStrategy"];
  function ni(e) {
    return e ? function (e) {
      return Array.isArray(e) && Array.isArray(e[0]);
    }(e) ? e : (0 === e.length ? [] : [e]).map(function (e) {
      return Array.isArray(e) ? e : [e];
    }) : [];
  }
  var ti = i.forwardRef(function (e, n) {
    var t = e.id,
      r = e.prefixCls,
      o = void 0 === r ? "rc-cascader" : r,
      u = e.fieldNames,
      a = e.defaultValue,
      l = e.value,
      f = e.changeOnSelect,
      s = e.onChange,
      v = e.displayRender,
      d = e.checkable,
      y = e.searchValue,
      w = e.onSearch,
      E = e.showSearch,
      S = e.expandTrigger,
      C = e.options,
      x = e.dropdownPrefixCls,
      O = e.loadData,
      k = e.popupVisible,
      N = e.open,
      R = e.popupClassName,
      A = e.dropdownClassName,
      P = e.dropdownMenuColumnStyle,
      I = e.popupPlacement,
      D = e.placement,
      L = e.onDropdownVisibleChange,
      j = e.onPopupVisibleChange,
      V = e.expandIcon,
      z = void 0 === V ? ">" : V,
      F = e.loadingIcon,
      W = e.children,
      H = e.dropdownMatchSelectWidth,
      U = void 0 !== H && H,
      K = e.showCheckedStrategy,
      B = void 0 === K ? jo : K,
      $ = m(e, ei),
      Y = qr(t),
      q = !!d,
      G = h(M(a, {
        value: l,
        postState: ni
      }), 2),
      X = G[0],
      Z = G[1],
      Q = i.useMemo(function () {
        return function (e) {
          var n = e || {},
            t = n.label,
            r = n.value || "value";
          return {
            label: t || "label",
            value: r,
            key: r,
            children: n.children || "children"
          };
        }(u);
      }, [JSON.stringify(u)]),
      J = i.useMemo(function () {
        return C || [];
      }, [C]),
      ee = function (e, n) {
        var t = i.useRef({
          options: null,
          info: null
        });
        return i.useCallback(function () {
          return t.current.options !== e && (t.current.options = e, t.current.info = Yo(e, {
            fieldNames: n,
            initWrapper: function (e) {
              return _(_({}, e), {}, {
                pathKeyEntities: {}
              });
            },
            processEntity: function (e, t) {
              var r = e.nodes.map(function (e) {
                return e[n.value];
              }).join(Lo);
              t.pathKeyEntities[r] = e, e.key = r;
            }
          })), t.current.info.pathKeyEntities;
        }, [n, e]);
      }(J, Q),
      ne = i.useCallback(function (e) {
        var n = ee();
        return e.map(function (e) {
          return n[e].nodes.map(function (e) {
            return e[Q.value];
          });
        });
      }, [ee, Q]),
      te = h(M("", {
        value: y,
        postState: function (e) {
          return e || "";
        }
      }), 2),
      re = te[0],
      oe = te[1],
      ie = function (e) {
        return i.useMemo(function () {
          if (!e) return [!1, {}];
          var n = {
            matchInputWidth: !0,
            limit: 50
          };
          return e && "object" === g(e) && (n = _(_({}, n), e)), n.limit <= 0 && (delete n.limit, "production" !== process.env.NODE_ENV && T(!1, "'limit' of showSearch should be positive number or false.")), [!0, n];
        }, [e]);
      }(E),
      ue = h(ie, 2),
      ae = ue[0],
      ce = ue[1],
      le = function (e, n, t, r, o, u) {
        var a = o.filter,
          c = void 0 === a ? Do : a,
          l = o.render,
          f = void 0 === l ? To : l,
          s = o.limit,
          v = void 0 === s ? 50 : s,
          d = o.sort;
        return i.useMemo(function () {
          var o = [];
          return e ? (function n(i, a) {
            i.forEach(function (i) {
              if (!(!d && v > 0 && o.length >= v)) {
                var l,
                  s = [].concat(p(a), [i]),
                  h = i[t.children];
                h && 0 !== h.length && !u || c(e, s, {
                  label: t.label
                }) && o.push(_(_({}, i), {}, (b(l = {}, t.label, f(e, s, r, t)), b(l, Io, s), l))), h && n(i[t.children], s);
              }
            });
          }(n, []), d && o.sort(function (n, r) {
            return d(n[Io], r[Io], e, t);
          }), v > 0 ? o.slice(0, v) : o) : [];
        }, [e, n, t, r, f, u, c, d, v]);
      }(re, J, Q, x || o, ce, f),
      fe = function (e, n) {
        return i.useCallback(function (t) {
          var r = [],
            o = [];
          return t.forEach(function (t) {
            Bo(t, e, n).every(function (e) {
              return e.option;
            }) ? o.push(t) : r.push(t);
          }), [o, r];
        }, [e, n]);
      }(J, Q),
      se = i.useMemo(function () {
        var e = h(fe(X), 2),
          n = e[0],
          t = e[1];
        if (!q || !X.length) return [n, [], t];
        var r = Ao(Fo(n), !0, ee()),
          o = r.checkedKeys,
          i = r.halfCheckedKeys;
        return [ne(o), ne(i), t];
      }, [q, X, ee, ne, fe]),
      pe = h(se, 3),
      ve = pe[0],
      de = pe[1],
      he = pe[2],
      me = function (e, n, t, r, o) {
        return i.useMemo(function () {
          var u = o || function (e) {
            var n = r ? e.slice(-1) : e;
            return n.every(function (e) {
              return ["string", "number"].includes(g(e));
            }) ? n.join(" / ") : n.reduce(function (e, n, t) {
              var r = i.isValidElement(n) ? i.cloneElement(n, {
                key: t
              }) : n;
              return 0 === t ? [r] : [].concat(p(e), [" / ", r]);
            }, []);
          };
          return e.map(function (e) {
            var r,
              o,
              i = Bo(e, n, t),
              a = u(i.map(function (e) {
                var n,
                  r = e.option,
                  o = e.value;
                return null !== (n = null == r ? void 0 : r[t.label]) && void 0 !== n ? n : o;
              }), i.map(function (e) {
                return e.option;
              })),
              c = zo(e);
            return {
              label: a,
              value: c,
              key: c,
              valueCells: e,
              disabled: null === (r = i[i.length - 1]) || void 0 === r || null === (o = r.option) || void 0 === o ? void 0 : o.disabled
            };
          });
        }, [e, n, t, o, r]);
      }(i.useMemo(function () {
        var e = Ko(Fo(ve), ee, B);
        return [].concat(p(he), p(ne(e)));
      }, [ve, ee, ne, he, B]), J, Q, q, v),
      ge = qo(function (e) {
        if (Z(e), s) {
          var n = ni(e),
            t = n.map(function (e) {
              return Bo(e, J, Q).map(function (e) {
                return e.option;
              });
            }),
            r = q ? n : n[0],
            o = q ? t : t[0];
          s(r, o);
        }
      }),
      ye = qo(function (e) {
        if (oe(""), q) {
          var n = zo(e),
            t = Fo(ve),
            r = Fo(de),
            o = t.includes(n),
            i = he.some(function (e) {
              return zo(e) === n;
            }),
            u = ve,
            a = he;
          if (i && !o) a = he.filter(function (e) {
            return zo(e) !== n;
          });else {
            var c,
              l = o ? t.filter(function (e) {
                return e !== n;
              }) : [].concat(p(t), [n]),
              f = ee();
            if (o) c = Ao(l, {
              checked: !1,
              halfCheckedKeys: r
            }, f).checkedKeys;else c = Ao(l, !0, f).checkedKeys;
            var s = Ko(c, ee, B);
            u = ne(s);
          }
          ge([].concat(p(a), p(u)));
        } else ge(e);
      }),
      be = void 0 !== N ? N : k,
      we = A || R,
      _e = D || I;
    "production" !== process.env.NODE_ENV && (function (e) {
      var n = e.onPopupVisibleChange,
        t = e.popupVisible,
        r = e.popupClassName,
        o = e.popupPlacement;
      T(!n, "`onPopupVisibleChange` is deprecated. Please use `onDropdownVisibleChange` instead."), T(void 0 === t, "`popupVisible` is deprecated. Please use `open` instead."), T(void 0 === r, "`popupClassName` is deprecated. Please use `dropdownClassName` instead."), T(void 0 === o, "`popupPlacement` is deprecated. Please use `placement` instead.");
    }(e), function (e, n) {
      e && function e(t) {
        for (var r = 0; r < t.length; r++) {
          var o = t[r];
          if (null === o[null == n ? void 0 : n.value]) return T(!1, "`value` in Cascader options should not be `null`."), !0;
          if (Array.isArray(o[null == n ? void 0 : n.children]) && e(o[null == n ? void 0 : n.children])) return !0;
        }
      }(e);
    }(J, Q));
    var Ee = i.useMemo(function () {
        return {
          options: J,
          fieldNames: Q,
          values: ve,
          halfValues: de,
          changeOnSelect: f,
          onSelect: ye,
          checkable: d,
          searchOptions: le,
          dropdownPrefixCls: x,
          loadData: O,
          expandTrigger: S,
          expandIcon: z,
          loadingIcon: F,
          dropdownMenuColumnStyle: P
        };
      }, [J, Q, ve, de, f, ye, d, le, x, O, S, z, F, P]),
      Se = !(re ? le : J).length,
      Ce = re && ce.matchInputWidth || Se ? {} : {
        minWidth: "auto"
      };
    return i.createElement(Po.Provider, {
      value: Ee
    }, i.createElement(Kr, c({}, $, {
      ref: n,
      id: Y,
      prefixCls: o,
      dropdownMatchSelectWidth: U,
      dropdownStyle: Ce,
      displayValues: me,
      onDisplayValuesChange: function (e, n) {
        if ("clear" !== n.type) {
          var t = n.values[0].valueCells;
          ye(t);
        } else ge([]);
      },
      mode: q ? "multiple" : void 0,
      searchValue: re,
      onSearch: function (e, n) {
        oe(e), "blur" !== n.source && w && w(e);
      },
      showSearch: ae,
      OptionList: Jo,
      emptyOptions: Se,
      open: be,
      dropdownClassName: we,
      placement: _e,
      onDropdownVisibleChange: function (e) {
        null == L || L(e), null == j || j(e);
      },
      getRawInputElement: function () {
        return W;
      }
    })));
  });
  "production" !== process.env.NODE_ENV && (ti.displayName = "Cascader"), ti.SHOW_PARENT = jo, ti.SHOW_CHILD = Vo;
  /**
     * @license
     * Lodash <https://lodash.com/>
     * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
     * Released under MIT license <https://lodash.com/license>
     * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
     * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
     */
  var ri,
    oi,
    ii = V(function (e, n) {
      (function () {
        var t,
          r = "Expected a function",
          o = "__lodash_hash_undefined__",
          i = "__lodash_placeholder__",
          u = 16,
          a = 32,
          c = 64,
          l = 128,
          f = 256,
          s = 1 / 0,
          p = 9007199254740991,
          v = NaN,
          d = 4294967295,
          h = [["ary", l], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", u], ["flip", 512], ["partial", a], ["partialRight", c], ["rearg", f]],
          m = "[object Arguments]",
          g = "[object Array]",
          y = "[object Boolean]",
          b = "[object Date]",
          w = "[object Error]",
          _ = "[object Function]",
          E = "[object GeneratorFunction]",
          S = "[object Map]",
          C = "[object Number]",
          x = "[object Object]",
          O = "[object Promise]",
          k = "[object RegExp]",
          N = "[object Set]",
          M = "[object String]",
          R = "[object Symbol]",
          A = "[object WeakMap]",
          P = "[object ArrayBuffer]",
          I = "[object DataView]",
          D = "[object Float32Array]",
          T = "[object Float64Array]",
          L = "[object Int8Array]",
          V = "[object Int16Array]",
          z = "[object Int32Array]",
          F = "[object Uint8Array]",
          W = "[object Uint8ClampedArray]",
          H = "[object Uint16Array]",
          U = "[object Uint32Array]",
          K = /\b__p \+= '';/g,
          B = /\b(__p \+=) '' \+/g,
          $ = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
          Y = /&(?:amp|lt|gt|quot|#39);/g,
          q = /[&<>"']/g,
          G = RegExp(Y.source),
          X = RegExp(q.source),
          Z = /<%-([\s\S]+?)%>/g,
          Q = /<%([\s\S]+?)%>/g,
          J = /<%=([\s\S]+?)%>/g,
          ee = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
          ne = /^\w*$/,
          te = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
          re = /[\\^$.*+?()[\]{}|]/g,
          oe = RegExp(re.source),
          ie = /^\s+/,
          ue = /\s/,
          ae = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
          ce = /\{\n\/\* \[wrapped with (.+)\] \*/,
          le = /,? & /,
          fe = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
          se = /[()=,{}\[\]\/\s]/,
          pe = /\\(\\)?/g,
          ve = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
          de = /\w*$/,
          he = /^[-+]0x[0-9a-f]+$/i,
          me = /^0b[01]+$/i,
          ge = /^\[object .+?Constructor\]$/,
          ye = /^0o[0-7]+$/i,
          be = /^(?:0|[1-9]\d*)$/,
          we = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
          _e = /($^)/,
          Ee = /['\n\r\u2028\u2029\\]/g,
          Se = "\\ud800-\\udfff",
          Ce = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",
          xe = "\\u2700-\\u27bf",
          Oe = "a-z\\xdf-\\xf6\\xf8-\\xff",
          ke = "A-Z\\xc0-\\xd6\\xd8-\\xde",
          Ne = "\\ufe0e\\ufe0f",
          Me = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
          Re = "['’]",
          Ae = "[" + Se + "]",
          Pe = "[" + Me + "]",
          Ie = "[" + Ce + "]",
          De = "\\d+",
          Te = "[" + xe + "]",
          Le = "[" + Oe + "]",
          je = "[^" + Se + Me + De + xe + Oe + ke + "]",
          Ve = "\\ud83c[\\udffb-\\udfff]",
          ze = "[^" + Se + "]",
          Fe = "(?:\\ud83c[\\udde6-\\uddff]){2}",
          We = "[\\ud800-\\udbff][\\udc00-\\udfff]",
          He = "[" + ke + "]",
          Ue = "\\u200d",
          Ke = "(?:" + Le + "|" + je + ")",
          Be = "(?:" + He + "|" + je + ")",
          $e = "(?:['’](?:d|ll|m|re|s|t|ve))?",
          Ye = "(?:['’](?:D|LL|M|RE|S|T|VE))?",
          qe = "(?:" + Ie + "|" + Ve + ")" + "?",
          Ge = "[" + Ne + "]?",
          Xe = Ge + qe + ("(?:" + Ue + "(?:" + [ze, Fe, We].join("|") + ")" + Ge + qe + ")*"),
          Ze = "(?:" + [Te, Fe, We].join("|") + ")" + Xe,
          Qe = "(?:" + [ze + Ie + "?", Ie, Fe, We, Ae].join("|") + ")",
          Je = RegExp(Re, "g"),
          en = RegExp(Ie, "g"),
          nn = RegExp(Ve + "(?=" + Ve + ")|" + Qe + Xe, "g"),
          tn = RegExp([He + "?" + Le + "+" + $e + "(?=" + [Pe, He, "$"].join("|") + ")", Be + "+" + Ye + "(?=" + [Pe, He + Ke, "$"].join("|") + ")", He + "?" + Ke + "+" + $e, He + "+" + Ye, "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", De, Ze].join("|"), "g"),
          rn = RegExp("[" + Ue + Se + Ce + Ne + "]"),
          on = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
          un = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"],
          an = -1,
          cn = {};
        cn[D] = cn[T] = cn[L] = cn[V] = cn[z] = cn[F] = cn[W] = cn[H] = cn[U] = !0, cn[m] = cn[g] = cn[P] = cn[y] = cn[I] = cn[b] = cn[w] = cn[_] = cn[S] = cn[C] = cn[x] = cn[k] = cn[N] = cn[M] = cn[A] = !1;
        var ln = {};
        ln[m] = ln[g] = ln[P] = ln[I] = ln[y] = ln[b] = ln[D] = ln[T] = ln[L] = ln[V] = ln[z] = ln[S] = ln[C] = ln[x] = ln[k] = ln[N] = ln[M] = ln[R] = ln[F] = ln[W] = ln[H] = ln[U] = !0, ln[w] = ln[_] = ln[A] = !1;
        var fn = {
            "\\": "\\",
            "'": "'",
            "\n": "n",
            "\r": "r",
            "\u2028": "u2028",
            "\u2029": "u2029"
          },
          sn = parseFloat,
          pn = parseInt,
          vn = "object" == typeof j && j && j.Object === Object && j,
          dn = "object" == typeof self && self && self.Object === Object && self,
          hn = vn || dn || Function("return this")(),
          mn = n && !n.nodeType && n,
          gn = mn && e && !e.nodeType && e,
          yn = gn && gn.exports === mn,
          bn = yn && vn.process,
          wn = function () {
            try {
              var e = gn && gn.require && gn.require("util").types;
              return e || bn && bn.binding && bn.binding("util");
            } catch (e) {}
          }(),
          _n = wn && wn.isArrayBuffer,
          En = wn && wn.isDate,
          Sn = wn && wn.isMap,
          Cn = wn && wn.isRegExp,
          xn = wn && wn.isSet,
          On = wn && wn.isTypedArray;
        function kn(e, n, t) {
          switch (t.length) {
            case 0:
              return e.call(n);
            case 1:
              return e.call(n, t[0]);
            case 2:
              return e.call(n, t[0], t[1]);
            case 3:
              return e.call(n, t[0], t[1], t[2]);
          }
          return e.apply(n, t);
        }
        function Nn(e, n, t, r) {
          for (var o = -1, i = null == e ? 0 : e.length; ++o < i;) {
            var u = e[o];
            n(r, u, t(u), e);
          }
          return r;
        }
        function Mn(e, n) {
          for (var t = -1, r = null == e ? 0 : e.length; ++t < r && !1 !== n(e[t], t, e););
          return e;
        }
        function Rn(e, n) {
          for (var t = null == e ? 0 : e.length; t-- && !1 !== n(e[t], t, e););
          return e;
        }
        function An(e, n) {
          for (var t = -1, r = null == e ? 0 : e.length; ++t < r;) if (!n(e[t], t, e)) return !1;
          return !0;
        }
        function Pn(e, n) {
          for (var t = -1, r = null == e ? 0 : e.length, o = 0, i = []; ++t < r;) {
            var u = e[t];
            n(u, t, e) && (i[o++] = u);
          }
          return i;
        }
        function In(e, n) {
          return !!(null == e ? 0 : e.length) && Un(e, n, 0) > -1;
        }
        function Dn(e, n, t) {
          for (var r = -1, o = null == e ? 0 : e.length; ++r < o;) if (t(n, e[r])) return !0;
          return !1;
        }
        function Tn(e, n) {
          for (var t = -1, r = null == e ? 0 : e.length, o = Array(r); ++t < r;) o[t] = n(e[t], t, e);
          return o;
        }
        function Ln(e, n) {
          for (var t = -1, r = n.length, o = e.length; ++t < r;) e[o + t] = n[t];
          return e;
        }
        function jn(e, n, t, r) {
          var o = -1,
            i = null == e ? 0 : e.length;
          for (r && i && (t = e[++o]); ++o < i;) t = n(t, e[o], o, e);
          return t;
        }
        function Vn(e, n, t, r) {
          var o = null == e ? 0 : e.length;
          for (r && o && (t = e[--o]); o--;) t = n(t, e[o], o, e);
          return t;
        }
        function zn(e, n) {
          for (var t = -1, r = null == e ? 0 : e.length; ++t < r;) if (n(e[t], t, e)) return !0;
          return !1;
        }
        var Fn = Yn("length");
        function Wn(e, n, t) {
          var r;
          return t(e, function (e, t, o) {
            if (n(e, t, o)) return r = t, !1;
          }), r;
        }
        function Hn(e, n, t, r) {
          for (var o = e.length, i = t + (r ? 1 : -1); r ? i-- : ++i < o;) if (n(e[i], i, e)) return i;
          return -1;
        }
        function Un(e, n, t) {
          return n == n ? function (e, n, t) {
            var r = t - 1,
              o = e.length;
            for (; ++r < o;) if (e[r] === n) return r;
            return -1;
          }(e, n, t) : Hn(e, Bn, t);
        }
        function Kn(e, n, t, r) {
          for (var o = t - 1, i = e.length; ++o < i;) if (r(e[o], n)) return o;
          return -1;
        }
        function Bn(e) {
          return e != e;
        }
        function $n(e, n) {
          var t = null == e ? 0 : e.length;
          return t ? Xn(e, n) / t : v;
        }
        function Yn(e) {
          return function (n) {
            return null == n ? t : n[e];
          };
        }
        function qn(e) {
          return function (n) {
            return null == e ? t : e[n];
          };
        }
        function Gn(e, n, t, r, o) {
          return o(e, function (e, o, i) {
            t = r ? (r = !1, e) : n(t, e, o, i);
          }), t;
        }
        function Xn(e, n) {
          for (var r, o = -1, i = e.length; ++o < i;) {
            var u = n(e[o]);
            u !== t && (r = r === t ? u : r + u);
          }
          return r;
        }
        function Zn(e, n) {
          for (var t = -1, r = Array(e); ++t < e;) r[t] = n(t);
          return r;
        }
        function Qn(e) {
          return e ? e.slice(0, ht(e) + 1).replace(ie, "") : e;
        }
        function Jn(e) {
          return function (n) {
            return e(n);
          };
        }
        function et(e, n) {
          return Tn(n, function (n) {
            return e[n];
          });
        }
        function nt(e, n) {
          return e.has(n);
        }
        function tt(e, n) {
          for (var t = -1, r = e.length; ++t < r && Un(n, e[t], 0) > -1;);
          return t;
        }
        function rt(e, n) {
          for (var t = e.length; t-- && Un(n, e[t], 0) > -1;);
          return t;
        }
        var ot = qn({
            "À": "A",
            "Á": "A",
            "Â": "A",
            "Ã": "A",
            "Ä": "A",
            "Å": "A",
            "à": "a",
            "á": "a",
            "â": "a",
            "ã": "a",
            "ä": "a",
            "å": "a",
            "Ç": "C",
            "ç": "c",
            "Ð": "D",
            "ð": "d",
            "È": "E",
            "É": "E",
            "Ê": "E",
            "Ë": "E",
            "è": "e",
            "é": "e",
            "ê": "e",
            "ë": "e",
            "Ì": "I",
            "Í": "I",
            "Î": "I",
            "Ï": "I",
            "ì": "i",
            "í": "i",
            "î": "i",
            "ï": "i",
            "Ñ": "N",
            "ñ": "n",
            "Ò": "O",
            "Ó": "O",
            "Ô": "O",
            "Õ": "O",
            "Ö": "O",
            "Ø": "O",
            "ò": "o",
            "ó": "o",
            "ô": "o",
            "õ": "o",
            "ö": "o",
            "ø": "o",
            "Ù": "U",
            "Ú": "U",
            "Û": "U",
            "Ü": "U",
            "ù": "u",
            "ú": "u",
            "û": "u",
            "ü": "u",
            "Ý": "Y",
            "ý": "y",
            "ÿ": "y",
            "Æ": "Ae",
            "æ": "ae",
            "Þ": "Th",
            "þ": "th",
            "ß": "ss",
            "Ā": "A",
            "Ă": "A",
            "Ą": "A",
            "ā": "a",
            "ă": "a",
            "ą": "a",
            "Ć": "C",
            "Ĉ": "C",
            "Ċ": "C",
            "Č": "C",
            "ć": "c",
            "ĉ": "c",
            "ċ": "c",
            "č": "c",
            "Ď": "D",
            "Đ": "D",
            "ď": "d",
            "đ": "d",
            "Ē": "E",
            "Ĕ": "E",
            "Ė": "E",
            "Ę": "E",
            "Ě": "E",
            "ē": "e",
            "ĕ": "e",
            "ė": "e",
            "ę": "e",
            "ě": "e",
            "Ĝ": "G",
            "Ğ": "G",
            "Ġ": "G",
            "Ģ": "G",
            "ĝ": "g",
            "ğ": "g",
            "ġ": "g",
            "ģ": "g",
            "Ĥ": "H",
            "Ħ": "H",
            "ĥ": "h",
            "ħ": "h",
            "Ĩ": "I",
            "Ī": "I",
            "Ĭ": "I",
            "Į": "I",
            "İ": "I",
            "ĩ": "i",
            "ī": "i",
            "ĭ": "i",
            "į": "i",
            "ı": "i",
            "Ĵ": "J",
            "ĵ": "j",
            "Ķ": "K",
            "ķ": "k",
            "ĸ": "k",
            "Ĺ": "L",
            "Ļ": "L",
            "Ľ": "L",
            "Ŀ": "L",
            "Ł": "L",
            "ĺ": "l",
            "ļ": "l",
            "ľ": "l",
            "ŀ": "l",
            "ł": "l",
            "Ń": "N",
            "Ņ": "N",
            "Ň": "N",
            "Ŋ": "N",
            "ń": "n",
            "ņ": "n",
            "ň": "n",
            "ŋ": "n",
            "Ō": "O",
            "Ŏ": "O",
            "Ő": "O",
            "ō": "o",
            "ŏ": "o",
            "ő": "o",
            "Ŕ": "R",
            "Ŗ": "R",
            "Ř": "R",
            "ŕ": "r",
            "ŗ": "r",
            "ř": "r",
            "Ś": "S",
            "Ŝ": "S",
            "Ş": "S",
            "Š": "S",
            "ś": "s",
            "ŝ": "s",
            "ş": "s",
            "š": "s",
            "Ţ": "T",
            "Ť": "T",
            "Ŧ": "T",
            "ţ": "t",
            "ť": "t",
            "ŧ": "t",
            "Ũ": "U",
            "Ū": "U",
            "Ŭ": "U",
            "Ů": "U",
            "Ű": "U",
            "Ų": "U",
            "ũ": "u",
            "ū": "u",
            "ŭ": "u",
            "ů": "u",
            "ű": "u",
            "ų": "u",
            "Ŵ": "W",
            "ŵ": "w",
            "Ŷ": "Y",
            "ŷ": "y",
            "Ÿ": "Y",
            "Ź": "Z",
            "Ż": "Z",
            "Ž": "Z",
            "ź": "z",
            "ż": "z",
            "ž": "z",
            "Ĳ": "IJ",
            "ĳ": "ij",
            "Œ": "Oe",
            "œ": "oe",
            "ŉ": "'n",
            "ſ": "s"
          }),
          it = qn({
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
          });
        function ut(e) {
          return "\\" + fn[e];
        }
        function at(e) {
          return rn.test(e);
        }
        function ct(e) {
          var n = -1,
            t = Array(e.size);
          return e.forEach(function (e, r) {
            t[++n] = [r, e];
          }), t;
        }
        function lt(e, n) {
          return function (t) {
            return e(n(t));
          };
        }
        function ft(e, n) {
          for (var t = -1, r = e.length, o = 0, u = []; ++t < r;) {
            var a = e[t];
            a !== n && a !== i || (e[t] = i, u[o++] = t);
          }
          return u;
        }
        function st(e) {
          var n = -1,
            t = Array(e.size);
          return e.forEach(function (e) {
            t[++n] = e;
          }), t;
        }
        function pt(e) {
          var n = -1,
            t = Array(e.size);
          return e.forEach(function (e) {
            t[++n] = [e, e];
          }), t;
        }
        function vt(e) {
          return at(e) ? function (e) {
            var n = nn.lastIndex = 0;
            for (; nn.test(e);) ++n;
            return n;
          }(e) : Fn(e);
        }
        function dt(e) {
          return at(e) ? function (e) {
            return e.match(nn) || [];
          }(e) : function (e) {
            return e.split("");
          }(e);
        }
        function ht(e) {
          for (var n = e.length; n-- && ue.test(e.charAt(n)););
          return n;
        }
        var mt = qn({
          "&amp;": "&",
          "&lt;": "<",
          "&gt;": ">",
          "&quot;": '"',
          "&#39;": "'"
        });
        var gt = function e(n) {
          var j,
            ue = (n = null == n ? hn : gt.defaults(hn.Object(), n, gt.pick(hn, un))).Array,
            Se = n.Date,
            Ce = n.Error,
            xe = n.Function,
            Oe = n.Math,
            ke = n.Object,
            Ne = n.RegExp,
            Me = n.String,
            Re = n.TypeError,
            Ae = ue.prototype,
            Pe = xe.prototype,
            Ie = ke.prototype,
            De = n["__core-js_shared__"],
            Te = Pe.toString,
            Le = Ie.hasOwnProperty,
            je = 0,
            Ve = (j = /[^.]+$/.exec(De && De.keys && De.keys.IE_PROTO || "")) ? "Symbol(src)_1." + j : "",
            ze = Ie.toString,
            Fe = Te.call(ke),
            We = hn._,
            He = Ne("^" + Te.call(Le).replace(re, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
            Ue = yn ? n.Buffer : t,
            Ke = n.Symbol,
            Be = n.Uint8Array,
            $e = Ue ? Ue.allocUnsafe : t,
            Ye = lt(ke.getPrototypeOf, ke),
            qe = ke.create,
            Ge = Ie.propertyIsEnumerable,
            Xe = Ae.splice,
            Ze = Ke ? Ke.isConcatSpreadable : t,
            Qe = Ke ? Ke.iterator : t,
            nn = Ke ? Ke.toStringTag : t,
            rn = function () {
              try {
                var e = vi(ke, "defineProperty");
                return e({}, "", {}), e;
              } catch (e) {}
            }(),
            fn = n.clearTimeout !== hn.clearTimeout && n.clearTimeout,
            vn = Se && Se.now !== hn.Date.now && Se.now,
            dn = n.setTimeout !== hn.setTimeout && n.setTimeout,
            mn = Oe.ceil,
            gn = Oe.floor,
            bn = ke.getOwnPropertySymbols,
            wn = Ue ? Ue.isBuffer : t,
            Fn = n.isFinite,
            qn = Ae.join,
            yt = lt(ke.keys, ke),
            bt = Oe.max,
            wt = Oe.min,
            _t = Se.now,
            Et = n.parseInt,
            St = Oe.random,
            Ct = Ae.reverse,
            xt = vi(n, "DataView"),
            Ot = vi(n, "Map"),
            kt = vi(n, "Promise"),
            Nt = vi(n, "Set"),
            Mt = vi(n, "WeakMap"),
            Rt = vi(ke, "create"),
            At = Mt && new Mt(),
            Pt = {},
            It = zi(xt),
            Dt = zi(Ot),
            Tt = zi(kt),
            Lt = zi(Nt),
            jt = zi(Mt),
            Vt = Ke ? Ke.prototype : t,
            zt = Vt ? Vt.valueOf : t,
            Ft = Vt ? Vt.toString : t;
          function Wt(e) {
            if (ta(e) && !Bu(e) && !(e instanceof Bt)) {
              if (e instanceof Kt) return e;
              if (Le.call(e, "__wrapped__")) return Fi(e);
            }
            return new Kt(e);
          }
          var Ht = function () {
            function e() {}
            return function (n) {
              if (!na(n)) return {};
              if (qe) return qe(n);
              e.prototype = n;
              var r = new e();
              return e.prototype = t, r;
            };
          }();
          function Ut() {}
          function Kt(e, n) {
            this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!n, this.__index__ = 0, this.__values__ = t;
          }
          function Bt(e) {
            this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = d, this.__views__ = [];
          }
          function $t(e) {
            var n = -1,
              t = null == e ? 0 : e.length;
            for (this.clear(); ++n < t;) {
              var r = e[n];
              this.set(r[0], r[1]);
            }
          }
          function Yt(e) {
            var n = -1,
              t = null == e ? 0 : e.length;
            for (this.clear(); ++n < t;) {
              var r = e[n];
              this.set(r[0], r[1]);
            }
          }
          function qt(e) {
            var n = -1,
              t = null == e ? 0 : e.length;
            for (this.clear(); ++n < t;) {
              var r = e[n];
              this.set(r[0], r[1]);
            }
          }
          function Gt(e) {
            var n = -1,
              t = null == e ? 0 : e.length;
            for (this.__data__ = new qt(); ++n < t;) this.add(e[n]);
          }
          function Xt(e) {
            var n = this.__data__ = new Yt(e);
            this.size = n.size;
          }
          function Zt(e, n) {
            var t = Bu(e),
              r = !t && Ku(e),
              o = !t && !r && Gu(e),
              i = !t && !r && !o && fa(e),
              u = t || r || o || i,
              a = u ? Zn(e.length, Me) : [],
              c = a.length;
            for (var l in e) !n && !Le.call(e, l) || u && ("length" == l || o && ("offset" == l || "parent" == l) || i && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || wi(l, c)) || a.push(l);
            return a;
          }
          function Qt(e) {
            var n = e.length;
            return n ? e[Gr(0, n - 1)] : t;
          }
          function Jt(e, n) {
            return Li(Ao(e), cr(n, 0, e.length));
          }
          function er(e) {
            return Li(Ao(e));
          }
          function nr(e, n, r) {
            (r !== t && !Wu(e[n], r) || r === t && !(n in e)) && ur(e, n, r);
          }
          function tr(e, n, r) {
            var o = e[n];
            Le.call(e, n) && Wu(o, r) && (r !== t || n in e) || ur(e, n, r);
          }
          function rr(e, n) {
            for (var t = e.length; t--;) if (Wu(e[t][0], n)) return t;
            return -1;
          }
          function or(e, n, t, r) {
            return vr(e, function (e, o, i) {
              n(r, e, t(e), i);
            }), r;
          }
          function ir(e, n) {
            return e && Po(n, Pa(n), e);
          }
          function ur(e, n, t) {
            "__proto__" == n && rn ? rn(e, n, {
              configurable: !0,
              enumerable: !0,
              value: t,
              writable: !0
            }) : e[n] = t;
          }
          function ar(e, n) {
            for (var r = -1, o = n.length, i = ue(o), u = null == e; ++r < o;) i[r] = u ? t : ka(e, n[r]);
            return i;
          }
          function cr(e, n, r) {
            return e == e && (r !== t && (e = e <= r ? e : r), n !== t && (e = e >= n ? e : n)), e;
          }
          function lr(e, n, r, o, i, u) {
            var a,
              c = 1 & n,
              l = 2 & n,
              f = 4 & n;
            if (r && (a = i ? r(e, o, i, u) : r(e)), a !== t) return a;
            if (!na(e)) return e;
            var s = Bu(e);
            if (s) {
              if (a = function (e) {
                var n = e.length,
                  t = new e.constructor(n);
                n && "string" == typeof e[0] && Le.call(e, "index") && (t.index = e.index, t.input = e.input);
                return t;
              }(e), !c) return Ao(e, a);
            } else {
              var p = mi(e),
                v = p == _ || p == E;
              if (Gu(e)) return xo(e, c);
              if (p == x || p == m || v && !i) {
                if (a = l || v ? {} : yi(e), !c) return l ? function (e, n) {
                  return Po(e, hi(e), n);
                }(e, function (e, n) {
                  return e && Po(n, Ia(n), e);
                }(a, e)) : function (e, n) {
                  return Po(e, di(e), n);
                }(e, ir(a, e));
              } else {
                if (!ln[p]) return i ? e : {};
                a = function (e, n, t) {
                  var r = e.constructor;
                  switch (n) {
                    case P:
                      return Oo(e);
                    case y:
                    case b:
                      return new r(+e);
                    case I:
                      return function (e, n) {
                        var t = n ? Oo(e.buffer) : e.buffer;
                        return new e.constructor(t, e.byteOffset, e.byteLength);
                      }(e, t);
                    case D:
                    case T:
                    case L:
                    case V:
                    case z:
                    case F:
                    case W:
                    case H:
                    case U:
                      return ko(e, t);
                    case S:
                      return new r();
                    case C:
                    case M:
                      return new r(e);
                    case k:
                      return function (e) {
                        var n = new e.constructor(e.source, de.exec(e));
                        return n.lastIndex = e.lastIndex, n;
                      }(e);
                    case N:
                      return new r();
                    case R:
                      return o = e, zt ? ke(zt.call(o)) : {};
                  }
                  var o;
                }(e, p, c);
              }
            }
            u || (u = new Xt());
            var d = u.get(e);
            if (d) return d;
            u.set(e, a), aa(e) ? e.forEach(function (t) {
              a.add(lr(t, n, r, t, e, u));
            }) : ra(e) && e.forEach(function (t, o) {
              a.set(o, lr(t, n, r, o, e, u));
            });
            var h = s ? t : (f ? l ? ui : ii : l ? Ia : Pa)(e);
            return Mn(h || e, function (t, o) {
              h && (t = e[o = t]), tr(a, o, lr(t, n, r, o, e, u));
            }), a;
          }
          function fr(e, n, r) {
            var o = r.length;
            if (null == e) return !o;
            for (e = ke(e); o--;) {
              var i = r[o],
                u = n[i],
                a = e[i];
              if (a === t && !(i in e) || !u(a)) return !1;
            }
            return !0;
          }
          function sr(e, n, o) {
            if ("function" != typeof e) throw new Re(r);
            return Pi(function () {
              e.apply(t, o);
            }, n);
          }
          function pr(e, n, t, r) {
            var o = -1,
              i = In,
              u = !0,
              a = e.length,
              c = [],
              l = n.length;
            if (!a) return c;
            t && (n = Tn(n, Jn(t))), r ? (i = Dn, u = !1) : n.length >= 200 && (i = nt, u = !1, n = new Gt(n));
            e: for (; ++o < a;) {
              var f = e[o],
                s = null == t ? f : t(f);
              if (f = r || 0 !== f ? f : 0, u && s == s) {
                for (var p = l; p--;) if (n[p] === s) continue e;
                c.push(f);
              } else i(n, s, r) || c.push(f);
            }
            return c;
          }
          Wt.templateSettings = {
            escape: Z,
            evaluate: Q,
            interpolate: J,
            variable: "",
            imports: {
              _: Wt
            }
          }, Wt.prototype = Ut.prototype, Wt.prototype.constructor = Wt, Kt.prototype = Ht(Ut.prototype), Kt.prototype.constructor = Kt, Bt.prototype = Ht(Ut.prototype), Bt.prototype.constructor = Bt, $t.prototype.clear = function () {
            this.__data__ = Rt ? Rt(null) : {}, this.size = 0;
          }, $t.prototype.delete = function (e) {
            var n = this.has(e) && delete this.__data__[e];
            return this.size -= n ? 1 : 0, n;
          }, $t.prototype.get = function (e) {
            var n = this.__data__;
            if (Rt) {
              var r = n[e];
              return r === o ? t : r;
            }
            return Le.call(n, e) ? n[e] : t;
          }, $t.prototype.has = function (e) {
            var n = this.__data__;
            return Rt ? n[e] !== t : Le.call(n, e);
          }, $t.prototype.set = function (e, n) {
            var r = this.__data__;
            return this.size += this.has(e) ? 0 : 1, r[e] = Rt && n === t ? o : n, this;
          }, Yt.prototype.clear = function () {
            this.__data__ = [], this.size = 0;
          }, Yt.prototype.delete = function (e) {
            var n = this.__data__,
              t = rr(n, e);
            return !(t < 0) && (t == n.length - 1 ? n.pop() : Xe.call(n, t, 1), --this.size, !0);
          }, Yt.prototype.get = function (e) {
            var n = this.__data__,
              r = rr(n, e);
            return r < 0 ? t : n[r][1];
          }, Yt.prototype.has = function (e) {
            return rr(this.__data__, e) > -1;
          }, Yt.prototype.set = function (e, n) {
            var t = this.__data__,
              r = rr(t, e);
            return r < 0 ? (++this.size, t.push([e, n])) : t[r][1] = n, this;
          }, qt.prototype.clear = function () {
            this.size = 0, this.__data__ = {
              hash: new $t(),
              map: new (Ot || Yt)(),
              string: new $t()
            };
          }, qt.prototype.delete = function (e) {
            var n = si(this, e).delete(e);
            return this.size -= n ? 1 : 0, n;
          }, qt.prototype.get = function (e) {
            return si(this, e).get(e);
          }, qt.prototype.has = function (e) {
            return si(this, e).has(e);
          }, qt.prototype.set = function (e, n) {
            var t = si(this, e),
              r = t.size;
            return t.set(e, n), this.size += t.size == r ? 0 : 1, this;
          }, Gt.prototype.add = Gt.prototype.push = function (e) {
            return this.__data__.set(e, o), this;
          }, Gt.prototype.has = function (e) {
            return this.__data__.has(e);
          }, Xt.prototype.clear = function () {
            this.__data__ = new Yt(), this.size = 0;
          }, Xt.prototype.delete = function (e) {
            var n = this.__data__,
              t = n.delete(e);
            return this.size = n.size, t;
          }, Xt.prototype.get = function (e) {
            return this.__data__.get(e);
          }, Xt.prototype.has = function (e) {
            return this.__data__.has(e);
          }, Xt.prototype.set = function (e, n) {
            var t = this.__data__;
            if (t instanceof Yt) {
              var r = t.__data__;
              if (!Ot || r.length < 199) return r.push([e, n]), this.size = ++t.size, this;
              t = this.__data__ = new qt(r);
            }
            return t.set(e, n), this.size = t.size, this;
          };
          var vr = To(_r),
            dr = To(Er, !0);
          function hr(e, n) {
            var t = !0;
            return vr(e, function (e, r, o) {
              return t = !!n(e, r, o);
            }), t;
          }
          function mr(e, n, r) {
            for (var o = -1, i = e.length; ++o < i;) {
              var u = e[o],
                a = n(u);
              if (null != a && (c === t ? a == a && !la(a) : r(a, c))) var c = a,
                l = u;
            }
            return l;
          }
          function gr(e, n) {
            var t = [];
            return vr(e, function (e, r, o) {
              n(e, r, o) && t.push(e);
            }), t;
          }
          function yr(e, n, t, r, o) {
            var i = -1,
              u = e.length;
            for (t || (t = bi), o || (o = []); ++i < u;) {
              var a = e[i];
              n > 0 && t(a) ? n > 1 ? yr(a, n - 1, t, r, o) : Ln(o, a) : r || (o[o.length] = a);
            }
            return o;
          }
          var br = Lo(),
            wr = Lo(!0);
          function _r(e, n) {
            return e && br(e, n, Pa);
          }
          function Er(e, n) {
            return e && wr(e, n, Pa);
          }
          function Sr(e, n) {
            return Pn(n, function (n) {
              return Qu(e[n]);
            });
          }
          function Cr(e, n) {
            for (var r = 0, o = (n = _o(n, e)).length; null != e && r < o;) e = e[Vi(n[r++])];
            return r && r == o ? e : t;
          }
          function xr(e, n, t) {
            var r = n(e);
            return Bu(e) ? r : Ln(r, t(e));
          }
          function Or(e) {
            return null == e ? e === t ? "[object Undefined]" : "[object Null]" : nn && nn in ke(e) ? function (e) {
              var n = Le.call(e, nn),
                r = e[nn];
              try {
                e[nn] = t;
                var o = !0;
              } catch (e) {}
              var i = ze.call(e);
              o && (n ? e[nn] = r : delete e[nn]);
              return i;
            }(e) : function (e) {
              return ze.call(e);
            }(e);
          }
          function kr(e, n) {
            return e > n;
          }
          function Nr(e, n) {
            return null != e && Le.call(e, n);
          }
          function Mr(e, n) {
            return null != e && n in ke(e);
          }
          function Rr(e, n, r) {
            for (var o = r ? Dn : In, i = e[0].length, u = e.length, a = u, c = ue(u), l = 1 / 0, f = []; a--;) {
              var s = e[a];
              a && n && (s = Tn(s, Jn(n))), l = wt(s.length, l), c[a] = !r && (n || i >= 120 && s.length >= 120) ? new Gt(a && s) : t;
            }
            s = e[0];
            var p = -1,
              v = c[0];
            e: for (; ++p < i && f.length < l;) {
              var d = s[p],
                h = n ? n(d) : d;
              if (d = r || 0 !== d ? d : 0, !(v ? nt(v, h) : o(f, h, r))) {
                for (a = u; --a;) {
                  var m = c[a];
                  if (!(m ? nt(m, h) : o(e[a], h, r))) continue e;
                }
                v && v.push(h), f.push(d);
              }
            }
            return f;
          }
          function Ar(e, n, r) {
            var o = null == (e = Mi(e, n = _o(n, e))) ? e : e[Vi(Zi(n))];
            return null == o ? t : kn(o, e, r);
          }
          function Pr(e) {
            return ta(e) && Or(e) == m;
          }
          function Ir(e, n, r, o, i) {
            return e === n || (null == e || null == n || !ta(e) && !ta(n) ? e != e && n != n : function (e, n, r, o, i, u) {
              var a = Bu(e),
                c = Bu(n),
                l = a ? g : mi(e),
                f = c ? g : mi(n),
                s = (l = l == m ? x : l) == x,
                p = (f = f == m ? x : f) == x,
                v = l == f;
              if (v && Gu(e)) {
                if (!Gu(n)) return !1;
                a = !0, s = !1;
              }
              if (v && !s) return u || (u = new Xt()), a || fa(e) ? ri(e, n, r, o, i, u) : function (e, n, t, r, o, i, u) {
                switch (t) {
                  case I:
                    if (e.byteLength != n.byteLength || e.byteOffset != n.byteOffset) return !1;
                    e = e.buffer, n = n.buffer;
                  case P:
                    return !(e.byteLength != n.byteLength || !i(new Be(e), new Be(n)));
                  case y:
                  case b:
                  case C:
                    return Wu(+e, +n);
                  case w:
                    return e.name == n.name && e.message == n.message;
                  case k:
                  case M:
                    return e == n + "";
                  case S:
                    var a = ct;
                  case N:
                    var c = 1 & r;
                    if (a || (a = st), e.size != n.size && !c) return !1;
                    var l = u.get(e);
                    if (l) return l == n;
                    r |= 2, u.set(e, n);
                    var f = ri(a(e), a(n), r, o, i, u);
                    return u.delete(e), f;
                  case R:
                    if (zt) return zt.call(e) == zt.call(n);
                }
                return !1;
              }(e, n, l, r, o, i, u);
              if (!(1 & r)) {
                var d = s && Le.call(e, "__wrapped__"),
                  h = p && Le.call(n, "__wrapped__");
                if (d || h) {
                  var _ = d ? e.value() : e,
                    E = h ? n.value() : n;
                  return u || (u = new Xt()), i(_, E, r, o, u);
                }
              }
              if (!v) return !1;
              return u || (u = new Xt()), function (e, n, r, o, i, u) {
                var a = 1 & r,
                  c = ii(e),
                  l = c.length,
                  f = ii(n),
                  s = f.length;
                if (l != s && !a) return !1;
                var p = l;
                for (; p--;) {
                  var v = c[p];
                  if (!(a ? v in n : Le.call(n, v))) return !1;
                }
                var d = u.get(e),
                  h = u.get(n);
                if (d && h) return d == n && h == e;
                var m = !0;
                u.set(e, n), u.set(n, e);
                var g = a;
                for (; ++p < l;) {
                  var y = e[v = c[p]],
                    b = n[v];
                  if (o) var w = a ? o(b, y, v, n, e, u) : o(y, b, v, e, n, u);
                  if (!(w === t ? y === b || i(y, b, r, o, u) : w)) {
                    m = !1;
                    break;
                  }
                  g || (g = "constructor" == v);
                }
                if (m && !g) {
                  var _ = e.constructor,
                    E = n.constructor;
                  _ == E || !("constructor" in e) || !("constructor" in n) || "function" == typeof _ && _ instanceof _ && "function" == typeof E && E instanceof E || (m = !1);
                }
                return u.delete(e), u.delete(n), m;
              }(e, n, r, o, i, u);
            }(e, n, r, o, Ir, i));
          }
          function Dr(e, n, r, o) {
            var i = r.length,
              u = i,
              a = !o;
            if (null == e) return !u;
            for (e = ke(e); i--;) {
              var c = r[i];
              if (a && c[2] ? c[1] !== e[c[0]] : !(c[0] in e)) return !1;
            }
            for (; ++i < u;) {
              var l = (c = r[i])[0],
                f = e[l],
                s = c[1];
              if (a && c[2]) {
                if (f === t && !(l in e)) return !1;
              } else {
                var p = new Xt();
                if (o) var v = o(f, s, l, e, n, p);
                if (!(v === t ? Ir(s, f, 3, o, p) : v)) return !1;
              }
            }
            return !0;
          }
          function Tr(e) {
            return !(!na(e) || (n = e, Ve && Ve in n)) && (Qu(e) ? He : ge).test(zi(e));
            var n;
          }
          function Lr(e) {
            return "function" == typeof e ? e : null == e ? oc : "object" == typeof e ? Bu(e) ? Hr(e[0], e[1]) : Wr(e) : vc(e);
          }
          function jr(e) {
            if (!xi(e)) return yt(e);
            var n = [];
            for (var t in ke(e)) Le.call(e, t) && "constructor" != t && n.push(t);
            return n;
          }
          function Vr(e) {
            if (!na(e)) return function (e) {
              var n = [];
              if (null != e) for (var t in ke(e)) n.push(t);
              return n;
            }(e);
            var n = xi(e),
              t = [];
            for (var r in e) ("constructor" != r || !n && Le.call(e, r)) && t.push(r);
            return t;
          }
          function zr(e, n) {
            return e < n;
          }
          function Fr(e, n) {
            var t = -1,
              r = Yu(e) ? ue(e.length) : [];
            return vr(e, function (e, o, i) {
              r[++t] = n(e, o, i);
            }), r;
          }
          function Wr(e) {
            var n = pi(e);
            return 1 == n.length && n[0][2] ? ki(n[0][0], n[0][1]) : function (t) {
              return t === e || Dr(t, e, n);
            };
          }
          function Hr(e, n) {
            return Ei(e) && Oi(n) ? ki(Vi(e), n) : function (r) {
              var o = ka(r, e);
              return o === t && o === n ? Na(r, e) : Ir(n, o, 3);
            };
          }
          function Ur(e, n, r, o, i) {
            e !== n && br(n, function (u, a) {
              if (i || (i = new Xt()), na(u)) !function (e, n, r, o, i, u, a) {
                var c = Ri(e, r),
                  l = Ri(n, r),
                  f = a.get(l);
                if (f) return void nr(e, r, f);
                var s = u ? u(c, l, r + "", e, n, a) : t,
                  p = s === t;
                if (p) {
                  var v = Bu(l),
                    d = !v && Gu(l),
                    h = !v && !d && fa(l);
                  s = l, v || d || h ? Bu(c) ? s = c : qu(c) ? s = Ao(c) : d ? (p = !1, s = xo(l, !0)) : h ? (p = !1, s = ko(l, !0)) : s = [] : ia(l) || Ku(l) ? (s = c, Ku(c) ? s = ya(c) : na(c) && !Qu(c) || (s = yi(l))) : p = !1;
                }
                p && (a.set(l, s), i(s, l, o, u, a), a.delete(l));
                nr(e, r, s);
              }(e, n, a, r, Ur, o, i);else {
                var c = o ? o(Ri(e, a), u, a + "", e, n, i) : t;
                c === t && (c = u), nr(e, a, c);
              }
            }, Ia);
          }
          function Kr(e, n) {
            var r = e.length;
            if (r) return wi(n += n < 0 ? r : 0, r) ? e[n] : t;
          }
          function Br(e, n, t) {
            n = n.length ? Tn(n, function (e) {
              return Bu(e) ? function (n) {
                return Cr(n, 1 === e.length ? e[0] : e);
              } : e;
            }) : [oc];
            var r = -1;
            n = Tn(n, Jn(fi()));
            var o = Fr(e, function (e, t, o) {
              var i = Tn(n, function (n) {
                return n(e);
              });
              return {
                criteria: i,
                index: ++r,
                value: e
              };
            });
            return function (e, n) {
              var t = e.length;
              for (e.sort(n); t--;) e[t] = e[t].value;
              return e;
            }(o, function (e, n) {
              return function (e, n, t) {
                var r = -1,
                  o = e.criteria,
                  i = n.criteria,
                  u = o.length,
                  a = t.length;
                for (; ++r < u;) {
                  var c = No(o[r], i[r]);
                  if (c) return r >= a ? c : c * ("desc" == t[r] ? -1 : 1);
                }
                return e.index - n.index;
              }(e, n, t);
            });
          }
          function $r(e, n, t) {
            for (var r = -1, o = n.length, i = {}; ++r < o;) {
              var u = n[r],
                a = Cr(e, u);
              t(a, u) && eo(i, _o(u, e), a);
            }
            return i;
          }
          function Yr(e, n, t, r) {
            var o = r ? Kn : Un,
              i = -1,
              u = n.length,
              a = e;
            for (e === n && (n = Ao(n)), t && (a = Tn(e, Jn(t))); ++i < u;) for (var c = 0, l = n[i], f = t ? t(l) : l; (c = o(a, f, c, r)) > -1;) a !== e && Xe.call(a, c, 1), Xe.call(e, c, 1);
            return e;
          }
          function qr(e, n) {
            for (var t = e ? n.length : 0, r = t - 1; t--;) {
              var o = n[t];
              if (t == r || o !== i) {
                var i = o;
                wi(o) ? Xe.call(e, o, 1) : po(e, o);
              }
            }
            return e;
          }
          function Gr(e, n) {
            return e + gn(St() * (n - e + 1));
          }
          function Xr(e, n) {
            var t = "";
            if (!e || n < 1 || n > p) return t;
            do {
              n % 2 && (t += e), (n = gn(n / 2)) && (e += e);
            } while (n);
            return t;
          }
          function Zr(e, n) {
            return Ii(Ni(e, n, oc), e + "");
          }
          function Qr(e) {
            return Qt(Wa(e));
          }
          function Jr(e, n) {
            var t = Wa(e);
            return Li(t, cr(n, 0, t.length));
          }
          function eo(e, n, r, o) {
            if (!na(e)) return e;
            for (var i = -1, u = (n = _o(n, e)).length, a = u - 1, c = e; null != c && ++i < u;) {
              var l = Vi(n[i]),
                f = r;
              if ("__proto__" === l || "constructor" === l || "prototype" === l) return e;
              if (i != a) {
                var s = c[l];
                (f = o ? o(s, l, c) : t) === t && (f = na(s) ? s : wi(n[i + 1]) ? [] : {});
              }
              tr(c, l, f), c = c[l];
            }
            return e;
          }
          var no = At ? function (e, n) {
              return At.set(e, n), e;
            } : oc,
            to = rn ? function (e, n) {
              return rn(e, "toString", {
                configurable: !0,
                enumerable: !1,
                value: nc(n),
                writable: !0
              });
            } : oc;
          function ro(e) {
            return Li(Wa(e));
          }
          function oo(e, n, t) {
            var r = -1,
              o = e.length;
            n < 0 && (n = -n > o ? 0 : o + n), (t = t > o ? o : t) < 0 && (t += o), o = n > t ? 0 : t - n >>> 0, n >>>= 0;
            for (var i = ue(o); ++r < o;) i[r] = e[r + n];
            return i;
          }
          function io(e, n) {
            var t;
            return vr(e, function (e, r, o) {
              return !(t = n(e, r, o));
            }), !!t;
          }
          function uo(e, n, t) {
            var r = 0,
              o = null == e ? r : e.length;
            if ("number" == typeof n && n == n && o <= 2147483647) {
              for (; r < o;) {
                var i = r + o >>> 1,
                  u = e[i];
                null !== u && !la(u) && (t ? u <= n : u < n) ? r = i + 1 : o = i;
              }
              return o;
            }
            return ao(e, n, oc, t);
          }
          function ao(e, n, r, o) {
            var i = 0,
              u = null == e ? 0 : e.length;
            if (0 === u) return 0;
            for (var a = (n = r(n)) != n, c = null === n, l = la(n), f = n === t; i < u;) {
              var s = gn((i + u) / 2),
                p = r(e[s]),
                v = p !== t,
                d = null === p,
                h = p == p,
                m = la(p);
              if (a) var g = o || h;else g = f ? h && (o || v) : c ? h && v && (o || !d) : l ? h && v && !d && (o || !m) : !d && !m && (o ? p <= n : p < n);
              g ? i = s + 1 : u = s;
            }
            return wt(u, 4294967294);
          }
          function co(e, n) {
            for (var t = -1, r = e.length, o = 0, i = []; ++t < r;) {
              var u = e[t],
                a = n ? n(u) : u;
              if (!t || !Wu(a, c)) {
                var c = a;
                i[o++] = 0 === u ? 0 : u;
              }
            }
            return i;
          }
          function lo(e) {
            return "number" == typeof e ? e : la(e) ? v : +e;
          }
          function fo(e) {
            if ("string" == typeof e) return e;
            if (Bu(e)) return Tn(e, fo) + "";
            if (la(e)) return Ft ? Ft.call(e) : "";
            var n = e + "";
            return "0" == n && 1 / e == -1 / 0 ? "-0" : n;
          }
          function so(e, n, t) {
            var r = -1,
              o = In,
              i = e.length,
              u = !0,
              a = [],
              c = a;
            if (t) u = !1, o = Dn;else if (i >= 200) {
              var l = n ? null : Zo(e);
              if (l) return st(l);
              u = !1, o = nt, c = new Gt();
            } else c = n ? [] : a;
            e: for (; ++r < i;) {
              var f = e[r],
                s = n ? n(f) : f;
              if (f = t || 0 !== f ? f : 0, u && s == s) {
                for (var p = c.length; p--;) if (c[p] === s) continue e;
                n && c.push(s), a.push(f);
              } else o(c, s, t) || (c !== a && c.push(s), a.push(f));
            }
            return a;
          }
          function po(e, n) {
            return null == (e = Mi(e, n = _o(n, e))) || delete e[Vi(Zi(n))];
          }
          function vo(e, n, t, r) {
            return eo(e, n, t(Cr(e, n)), r);
          }
          function ho(e, n, t, r) {
            for (var o = e.length, i = r ? o : -1; (r ? i-- : ++i < o) && n(e[i], i, e););
            return t ? oo(e, r ? 0 : i, r ? i + 1 : o) : oo(e, r ? i + 1 : 0, r ? o : i);
          }
          function mo(e, n) {
            var t = e;
            return t instanceof Bt && (t = t.value()), jn(n, function (e, n) {
              return n.func.apply(n.thisArg, Ln([e], n.args));
            }, t);
          }
          function go(e, n, t) {
            var r = e.length;
            if (r < 2) return r ? so(e[0]) : [];
            for (var o = -1, i = ue(r); ++o < r;) for (var u = e[o], a = -1; ++a < r;) a != o && (i[o] = pr(i[o] || u, e[a], n, t));
            return so(yr(i, 1), n, t);
          }
          function yo(e, n, r) {
            for (var o = -1, i = e.length, u = n.length, a = {}; ++o < i;) {
              var c = o < u ? n[o] : t;
              r(a, e[o], c);
            }
            return a;
          }
          function bo(e) {
            return qu(e) ? e : [];
          }
          function wo(e) {
            return "function" == typeof e ? e : oc;
          }
          function _o(e, n) {
            return Bu(e) ? e : Ei(e, n) ? [e] : ji(ba(e));
          }
          var Eo = Zr;
          function So(e, n, r) {
            var o = e.length;
            return r = r === t ? o : r, !n && r >= o ? e : oo(e, n, r);
          }
          var Co = fn || function (e) {
            return hn.clearTimeout(e);
          };
          function xo(e, n) {
            if (n) return e.slice();
            var t = e.length,
              r = $e ? $e(t) : new e.constructor(t);
            return e.copy(r), r;
          }
          function Oo(e) {
            var n = new e.constructor(e.byteLength);
            return new Be(n).set(new Be(e)), n;
          }
          function ko(e, n) {
            var t = n ? Oo(e.buffer) : e.buffer;
            return new e.constructor(t, e.byteOffset, e.length);
          }
          function No(e, n) {
            if (e !== n) {
              var r = e !== t,
                o = null === e,
                i = e == e,
                u = la(e),
                a = n !== t,
                c = null === n,
                l = n == n,
                f = la(n);
              if (!c && !f && !u && e > n || u && a && l && !c && !f || o && a && l || !r && l || !i) return 1;
              if (!o && !u && !f && e < n || f && r && i && !o && !u || c && r && i || !a && i || !l) return -1;
            }
            return 0;
          }
          function Mo(e, n, t, r) {
            for (var o = -1, i = e.length, u = t.length, a = -1, c = n.length, l = bt(i - u, 0), f = ue(c + l), s = !r; ++a < c;) f[a] = n[a];
            for (; ++o < u;) (s || o < i) && (f[t[o]] = e[o]);
            for (; l--;) f[a++] = e[o++];
            return f;
          }
          function Ro(e, n, t, r) {
            for (var o = -1, i = e.length, u = -1, a = t.length, c = -1, l = n.length, f = bt(i - a, 0), s = ue(f + l), p = !r; ++o < f;) s[o] = e[o];
            for (var v = o; ++c < l;) s[v + c] = n[c];
            for (; ++u < a;) (p || o < i) && (s[v + t[u]] = e[o++]);
            return s;
          }
          function Ao(e, n) {
            var t = -1,
              r = e.length;
            for (n || (n = ue(r)); ++t < r;) n[t] = e[t];
            return n;
          }
          function Po(e, n, r, o) {
            var i = !r;
            r || (r = {});
            for (var u = -1, a = n.length; ++u < a;) {
              var c = n[u],
                l = o ? o(r[c], e[c], c, r, e) : t;
              l === t && (l = e[c]), i ? ur(r, c, l) : tr(r, c, l);
            }
            return r;
          }
          function Io(e, n) {
            return function (t, r) {
              var o = Bu(t) ? Nn : or,
                i = n ? n() : {};
              return o(t, e, fi(r, 2), i);
            };
          }
          function Do(e) {
            return Zr(function (n, r) {
              var o = -1,
                i = r.length,
                u = i > 1 ? r[i - 1] : t,
                a = i > 2 ? r[2] : t;
              for (u = e.length > 3 && "function" == typeof u ? (i--, u) : t, a && _i(r[0], r[1], a) && (u = i < 3 ? t : u, i = 1), n = ke(n); ++o < i;) {
                var c = r[o];
                c && e(n, c, o, u);
              }
              return n;
            });
          }
          function To(e, n) {
            return function (t, r) {
              if (null == t) return t;
              if (!Yu(t)) return e(t, r);
              for (var o = t.length, i = n ? o : -1, u = ke(t); (n ? i-- : ++i < o) && !1 !== r(u[i], i, u););
              return t;
            };
          }
          function Lo(e) {
            return function (n, t, r) {
              for (var o = -1, i = ke(n), u = r(n), a = u.length; a--;) {
                var c = u[e ? a : ++o];
                if (!1 === t(i[c], c, i)) break;
              }
              return n;
            };
          }
          function jo(e) {
            return function (n) {
              var r = at(n = ba(n)) ? dt(n) : t,
                o = r ? r[0] : n.charAt(0),
                i = r ? So(r, 1).join("") : n.slice(1);
              return o[e]() + i;
            };
          }
          function Vo(e) {
            return function (n) {
              return jn(Qa(Ka(n).replace(Je, "")), e, "");
            };
          }
          function zo(e) {
            return function () {
              var n = arguments;
              switch (n.length) {
                case 0:
                  return new e();
                case 1:
                  return new e(n[0]);
                case 2:
                  return new e(n[0], n[1]);
                case 3:
                  return new e(n[0], n[1], n[2]);
                case 4:
                  return new e(n[0], n[1], n[2], n[3]);
                case 5:
                  return new e(n[0], n[1], n[2], n[3], n[4]);
                case 6:
                  return new e(n[0], n[1], n[2], n[3], n[4], n[5]);
                case 7:
                  return new e(n[0], n[1], n[2], n[3], n[4], n[5], n[6]);
              }
              var t = Ht(e.prototype),
                r = e.apply(t, n);
              return na(r) ? r : t;
            };
          }
          function Fo(e) {
            return function (n, r, o) {
              var i = ke(n);
              if (!Yu(n)) {
                var u = fi(r, 3);
                n = Pa(n), r = function (e) {
                  return u(i[e], e, i);
                };
              }
              var a = e(n, r, o);
              return a > -1 ? i[u ? n[a] : a] : t;
            };
          }
          function Wo(e) {
            return oi(function (n) {
              var o = n.length,
                i = o,
                u = Kt.prototype.thru;
              for (e && n.reverse(); i--;) {
                var a = n[i];
                if ("function" != typeof a) throw new Re(r);
                if (u && !c && "wrapper" == ci(a)) var c = new Kt([], !0);
              }
              for (i = c ? i : o; ++i < o;) {
                var l = ci(a = n[i]),
                  f = "wrapper" == l ? ai(a) : t;
                c = f && Si(f[0]) && 424 == f[1] && !f[4].length && 1 == f[9] ? c[ci(f[0])].apply(c, f[3]) : 1 == a.length && Si(a) ? c[l]() : c.thru(a);
              }
              return function () {
                var e = arguments,
                  t = e[0];
                if (c && 1 == e.length && Bu(t)) return c.plant(t).value();
                for (var r = 0, i = o ? n[r].apply(this, e) : t; ++r < o;) i = n[r].call(this, i);
                return i;
              };
            });
          }
          function Ho(e, n, r, o, i, u, a, c, f, s) {
            var p = n & l,
              v = 1 & n,
              d = 2 & n,
              h = 24 & n,
              m = 512 & n,
              g = d ? t : zo(e);
            return function l() {
              for (var y = arguments.length, b = ue(y), w = y; w--;) b[w] = arguments[w];
              if (h) var _ = li(l),
                E = function (e, n) {
                  for (var t = e.length, r = 0; t--;) e[t] === n && ++r;
                  return r;
                }(b, _);
              if (o && (b = Mo(b, o, i, h)), u && (b = Ro(b, u, a, h)), y -= E, h && y < s) {
                var S = ft(b, _);
                return Go(e, n, Ho, l.placeholder, r, b, S, c, f, s - y);
              }
              var C = v ? r : this,
                x = d ? C[e] : e;
              return y = b.length, c ? b = function (e, n) {
                var r = e.length,
                  o = wt(n.length, r),
                  i = Ao(e);
                for (; o--;) {
                  var u = n[o];
                  e[o] = wi(u, r) ? i[u] : t;
                }
                return e;
              }(b, c) : m && y > 1 && b.reverse(), p && f < y && (b.length = f), this && this !== hn && this instanceof l && (x = g || zo(x)), x.apply(C, b);
            };
          }
          function Uo(e, n) {
            return function (t, r) {
              return function (e, n, t, r) {
                return _r(e, function (e, o, i) {
                  n(r, t(e), o, i);
                }), r;
              }(t, e, n(r), {});
            };
          }
          function Ko(e, n) {
            return function (r, o) {
              var i;
              if (r === t && o === t) return n;
              if (r !== t && (i = r), o !== t) {
                if (i === t) return o;
                "string" == typeof r || "string" == typeof o ? (r = fo(r), o = fo(o)) : (r = lo(r), o = lo(o)), i = e(r, o);
              }
              return i;
            };
          }
          function Bo(e) {
            return oi(function (n) {
              return n = Tn(n, Jn(fi())), Zr(function (t) {
                var r = this;
                return e(n, function (e) {
                  return kn(e, r, t);
                });
              });
            });
          }
          function $o(e, n) {
            var r = (n = n === t ? " " : fo(n)).length;
            if (r < 2) return r ? Xr(n, e) : n;
            var o = Xr(n, mn(e / vt(n)));
            return at(n) ? So(dt(o), 0, e).join("") : o.slice(0, e);
          }
          function Yo(e) {
            return function (n, r, o) {
              return o && "number" != typeof o && _i(n, r, o) && (r = o = t), n = da(n), r === t ? (r = n, n = 0) : r = da(r), function (e, n, t, r) {
                for (var o = -1, i = bt(mn((n - e) / (t || 1)), 0), u = ue(i); i--;) u[r ? i : ++o] = e, e += t;
                return u;
              }(n, r, o = o === t ? n < r ? 1 : -1 : da(o), e);
            };
          }
          function qo(e) {
            return function (n, t) {
              return "string" == typeof n && "string" == typeof t || (n = ga(n), t = ga(t)), e(n, t);
            };
          }
          function Go(e, n, r, o, i, u, l, f, s, p) {
            var v = 8 & n;
            n |= v ? a : c, 4 & (n &= ~(v ? c : a)) || (n &= -4);
            var d = [e, n, i, v ? u : t, v ? l : t, v ? t : u, v ? t : l, f, s, p],
              h = r.apply(t, d);
            return Si(e) && Ai(h, d), h.placeholder = o, Di(h, e, n);
          }
          function Xo(e) {
            var n = Oe[e];
            return function (e, t) {
              if (e = ga(e), (t = null == t ? 0 : wt(ha(t), 292)) && Fn(e)) {
                var r = (ba(e) + "e").split("e");
                return +((r = (ba(n(r[0] + "e" + (+r[1] + t))) + "e").split("e"))[0] + "e" + (+r[1] - t));
              }
              return n(e);
            };
          }
          var Zo = Nt && 1 / st(new Nt([, -0]))[1] == s ? function (e) {
            return new Nt(e);
          } : lc;
          function Qo(e) {
            return function (n) {
              var t = mi(n);
              return t == S ? ct(n) : t == N ? pt(n) : function (e, n) {
                return Tn(n, function (n) {
                  return [n, e[n]];
                });
              }(n, e(n));
            };
          }
          function Jo(e, n, o, s, p, v, d, h) {
            var m = 2 & n;
            if (!m && "function" != typeof e) throw new Re(r);
            var g = s ? s.length : 0;
            if (g || (n &= -97, s = p = t), d = d === t ? d : bt(ha(d), 0), h = h === t ? h : ha(h), g -= p ? p.length : 0, n & c) {
              var y = s,
                b = p;
              s = p = t;
            }
            var w = m ? t : ai(e),
              _ = [e, n, o, s, p, y, b, v, d, h];
            if (w && function (e, n) {
              var t = e[1],
                r = n[1],
                o = t | r,
                u = o < 131,
                a = r == l && 8 == t || r == l && t == f && e[7].length <= n[8] || 384 == r && n[7].length <= n[8] && 8 == t;
              if (!u && !a) return e;
              1 & r && (e[2] = n[2], o |= 1 & t ? 0 : 4);
              var c = n[3];
              if (c) {
                var s = e[3];
                e[3] = s ? Mo(s, c, n[4]) : c, e[4] = s ? ft(e[3], i) : n[4];
              }
              (c = n[5]) && (s = e[5], e[5] = s ? Ro(s, c, n[6]) : c, e[6] = s ? ft(e[5], i) : n[6]);
              (c = n[7]) && (e[7] = c);
              r & l && (e[8] = null == e[8] ? n[8] : wt(e[8], n[8]));
              null == e[9] && (e[9] = n[9]);
              e[0] = n[0], e[1] = o;
            }(_, w), e = _[0], n = _[1], o = _[2], s = _[3], p = _[4], !(h = _[9] = _[9] === t ? m ? 0 : e.length : bt(_[9] - g, 0)) && 24 & n && (n &= -25), n && 1 != n) E = 8 == n || n == u ? function (e, n, r) {
              var o = zo(e);
              return function i() {
                for (var u = arguments.length, a = ue(u), c = u, l = li(i); c--;) a[c] = arguments[c];
                var f = u < 3 && a[0] !== l && a[u - 1] !== l ? [] : ft(a, l);
                return (u -= f.length) < r ? Go(e, n, Ho, i.placeholder, t, a, f, t, t, r - u) : kn(this && this !== hn && this instanceof i ? o : e, this, a);
              };
            }(e, n, h) : n != a && 33 != n || p.length ? Ho.apply(t, _) : function (e, n, t, r) {
              var o = 1 & n,
                i = zo(e);
              return function n() {
                for (var u = -1, a = arguments.length, c = -1, l = r.length, f = ue(l + a), s = this && this !== hn && this instanceof n ? i : e; ++c < l;) f[c] = r[c];
                for (; a--;) f[c++] = arguments[++u];
                return kn(s, o ? t : this, f);
              };
            }(e, n, o, s);else var E = function (e, n, t) {
              var r = 1 & n,
                o = zo(e);
              return function n() {
                return (this && this !== hn && this instanceof n ? o : e).apply(r ? t : this, arguments);
              };
            }(e, n, o);
            return Di((w ? no : Ai)(E, _), e, n);
          }
          function ei(e, n, r, o) {
            return e === t || Wu(e, Ie[r]) && !Le.call(o, r) ? n : e;
          }
          function ni(e, n, r, o, i, u) {
            return na(e) && na(n) && (u.set(n, e), Ur(e, n, t, ni, u), u.delete(n)), e;
          }
          function ti(e) {
            return ia(e) ? t : e;
          }
          function ri(e, n, r, o, i, u) {
            var a = 1 & r,
              c = e.length,
              l = n.length;
            if (c != l && !(a && l > c)) return !1;
            var f = u.get(e),
              s = u.get(n);
            if (f && s) return f == n && s == e;
            var p = -1,
              v = !0,
              d = 2 & r ? new Gt() : t;
            for (u.set(e, n), u.set(n, e); ++p < c;) {
              var h = e[p],
                m = n[p];
              if (o) var g = a ? o(m, h, p, n, e, u) : o(h, m, p, e, n, u);
              if (g !== t) {
                if (g) continue;
                v = !1;
                break;
              }
              if (d) {
                if (!zn(n, function (e, n) {
                  if (!nt(d, n) && (h === e || i(h, e, r, o, u))) return d.push(n);
                })) {
                  v = !1;
                  break;
                }
              } else if (h !== m && !i(h, m, r, o, u)) {
                v = !1;
                break;
              }
            }
            return u.delete(e), u.delete(n), v;
          }
          function oi(e) {
            return Ii(Ni(e, t, $i), e + "");
          }
          function ii(e) {
            return xr(e, Pa, di);
          }
          function ui(e) {
            return xr(e, Ia, hi);
          }
          var ai = At ? function (e) {
            return At.get(e);
          } : lc;
          function ci(e) {
            for (var n = e.name + "", t = Pt[n], r = Le.call(Pt, n) ? t.length : 0; r--;) {
              var o = t[r],
                i = o.func;
              if (null == i || i == e) return o.name;
            }
            return n;
          }
          function li(e) {
            return (Le.call(Wt, "placeholder") ? Wt : e).placeholder;
          }
          function fi() {
            var e = Wt.iteratee || ic;
            return e = e === ic ? Lr : e, arguments.length ? e(arguments[0], arguments[1]) : e;
          }
          function si(e, n) {
            var t,
              r,
              o = e.__data__;
            return ("string" == (r = typeof (t = n)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== t : null === t) ? o["string" == typeof n ? "string" : "hash"] : o.map;
          }
          function pi(e) {
            for (var n = Pa(e), t = n.length; t--;) {
              var r = n[t],
                o = e[r];
              n[t] = [r, o, Oi(o)];
            }
            return n;
          }
          function vi(e, n) {
            var r = function (e, n) {
              return null == e ? t : e[n];
            }(e, n);
            return Tr(r) ? r : t;
          }
          var di = bn ? function (e) {
              return null == e ? [] : (e = ke(e), Pn(bn(e), function (n) {
                return Ge.call(e, n);
              }));
            } : mc,
            hi = bn ? function (e) {
              for (var n = []; e;) Ln(n, di(e)), e = Ye(e);
              return n;
            } : mc,
            mi = Or;
          function gi(e, n, t) {
            for (var r = -1, o = (n = _o(n, e)).length, i = !1; ++r < o;) {
              var u = Vi(n[r]);
              if (!(i = null != e && t(e, u))) break;
              e = e[u];
            }
            return i || ++r != o ? i : !!(o = null == e ? 0 : e.length) && ea(o) && wi(u, o) && (Bu(e) || Ku(e));
          }
          function yi(e) {
            return "function" != typeof e.constructor || xi(e) ? {} : Ht(Ye(e));
          }
          function bi(e) {
            return Bu(e) || Ku(e) || !!(Ze && e && e[Ze]);
          }
          function wi(e, n) {
            var t = typeof e;
            return !!(n = null == n ? p : n) && ("number" == t || "symbol" != t && be.test(e)) && e > -1 && e % 1 == 0 && e < n;
          }
          function _i(e, n, t) {
            if (!na(t)) return !1;
            var r = typeof n;
            return !!("number" == r ? Yu(t) && wi(n, t.length) : "string" == r && n in t) && Wu(t[n], e);
          }
          function Ei(e, n) {
            if (Bu(e)) return !1;
            var t = typeof e;
            return !("number" != t && "symbol" != t && "boolean" != t && null != e && !la(e)) || ne.test(e) || !ee.test(e) || null != n && e in ke(n);
          }
          function Si(e) {
            var n = ci(e),
              t = Wt[n];
            if ("function" != typeof t || !(n in Bt.prototype)) return !1;
            if (e === t) return !0;
            var r = ai(t);
            return !!r && e === r[0];
          }
          (xt && mi(new xt(new ArrayBuffer(1))) != I || Ot && mi(new Ot()) != S || kt && mi(kt.resolve()) != O || Nt && mi(new Nt()) != N || Mt && mi(new Mt()) != A) && (mi = function (e) {
            var n = Or(e),
              r = n == x ? e.constructor : t,
              o = r ? zi(r) : "";
            if (o) switch (o) {
              case It:
                return I;
              case Dt:
                return S;
              case Tt:
                return O;
              case Lt:
                return N;
              case jt:
                return A;
            }
            return n;
          });
          var Ci = De ? Qu : gc;
          function xi(e) {
            var n = e && e.constructor;
            return e === ("function" == typeof n && n.prototype || Ie);
          }
          function Oi(e) {
            return e == e && !na(e);
          }
          function ki(e, n) {
            return function (r) {
              return null != r && r[e] === n && (n !== t || e in ke(r));
            };
          }
          function Ni(e, n, r) {
            return n = bt(n === t ? e.length - 1 : n, 0), function () {
              for (var t = arguments, o = -1, i = bt(t.length - n, 0), u = ue(i); ++o < i;) u[o] = t[n + o];
              o = -1;
              for (var a = ue(n + 1); ++o < n;) a[o] = t[o];
              return a[n] = r(u), kn(e, this, a);
            };
          }
          function Mi(e, n) {
            return n.length < 2 ? e : Cr(e, oo(n, 0, -1));
          }
          function Ri(e, n) {
            if (("constructor" !== n || "function" != typeof e[n]) && "__proto__" != n) return e[n];
          }
          var Ai = Ti(no),
            Pi = dn || function (e, n) {
              return hn.setTimeout(e, n);
            },
            Ii = Ti(to);
          function Di(e, n, t) {
            var r = n + "";
            return Ii(e, function (e, n) {
              var t = n.length;
              if (!t) return e;
              var r = t - 1;
              return n[r] = (t > 1 ? "& " : "") + n[r], n = n.join(t > 2 ? ", " : " "), e.replace(ae, "{\n/* [wrapped with " + n + "] */\n");
            }(r, function (e, n) {
              return Mn(h, function (t) {
                var r = "_." + t[0];
                n & t[1] && !In(e, r) && e.push(r);
              }), e.sort();
            }(function (e) {
              var n = e.match(ce);
              return n ? n[1].split(le) : [];
            }(r), t)));
          }
          function Ti(e) {
            var n = 0,
              r = 0;
            return function () {
              var o = _t(),
                i = 16 - (o - r);
              if (r = o, i > 0) {
                if (++n >= 800) return arguments[0];
              } else n = 0;
              return e.apply(t, arguments);
            };
          }
          function Li(e, n) {
            var r = -1,
              o = e.length,
              i = o - 1;
            for (n = n === t ? o : n; ++r < n;) {
              var u = Gr(r, i),
                a = e[u];
              e[u] = e[r], e[r] = a;
            }
            return e.length = n, e;
          }
          var ji = function (e) {
            var n = Tu(e, function (e) {
                return 500 === t.size && t.clear(), e;
              }),
              t = n.cache;
            return n;
          }(function (e) {
            var n = [];
            return 46 === e.charCodeAt(0) && n.push(""), e.replace(te, function (e, t, r, o) {
              n.push(r ? o.replace(pe, "$1") : t || e);
            }), n;
          });
          function Vi(e) {
            if ("string" == typeof e || la(e)) return e;
            var n = e + "";
            return "0" == n && 1 / e == -1 / 0 ? "-0" : n;
          }
          function zi(e) {
            if (null != e) {
              try {
                return Te.call(e);
              } catch (e) {}
              try {
                return e + "";
              } catch (e) {}
            }
            return "";
          }
          function Fi(e) {
            if (e instanceof Bt) return e.clone();
            var n = new Kt(e.__wrapped__, e.__chain__);
            return n.__actions__ = Ao(e.__actions__), n.__index__ = e.__index__, n.__values__ = e.__values__, n;
          }
          var Wi = Zr(function (e, n) {
              return qu(e) ? pr(e, yr(n, 1, qu, !0)) : [];
            }),
            Hi = Zr(function (e, n) {
              var r = Zi(n);
              return qu(r) && (r = t), qu(e) ? pr(e, yr(n, 1, qu, !0), fi(r, 2)) : [];
            }),
            Ui = Zr(function (e, n) {
              var r = Zi(n);
              return qu(r) && (r = t), qu(e) ? pr(e, yr(n, 1, qu, !0), t, r) : [];
            });
          function Ki(e, n, t) {
            var r = null == e ? 0 : e.length;
            if (!r) return -1;
            var o = null == t ? 0 : ha(t);
            return o < 0 && (o = bt(r + o, 0)), Hn(e, fi(n, 3), o);
          }
          function Bi(e, n, r) {
            var o = null == e ? 0 : e.length;
            if (!o) return -1;
            var i = o - 1;
            return r !== t && (i = ha(r), i = r < 0 ? bt(o + i, 0) : wt(i, o - 1)), Hn(e, fi(n, 3), i, !0);
          }
          function $i(e) {
            return (null == e ? 0 : e.length) ? yr(e, 1) : [];
          }
          function Yi(e) {
            return e && e.length ? e[0] : t;
          }
          var qi = Zr(function (e) {
              var n = Tn(e, bo);
              return n.length && n[0] === e[0] ? Rr(n) : [];
            }),
            Gi = Zr(function (e) {
              var n = Zi(e),
                r = Tn(e, bo);
              return n === Zi(r) ? n = t : r.pop(), r.length && r[0] === e[0] ? Rr(r, fi(n, 2)) : [];
            }),
            Xi = Zr(function (e) {
              var n = Zi(e),
                r = Tn(e, bo);
              return (n = "function" == typeof n ? n : t) && r.pop(), r.length && r[0] === e[0] ? Rr(r, t, n) : [];
            });
          function Zi(e) {
            var n = null == e ? 0 : e.length;
            return n ? e[n - 1] : t;
          }
          var Qi = Zr(Ji);
          function Ji(e, n) {
            return e && e.length && n && n.length ? Yr(e, n) : e;
          }
          var eu = oi(function (e, n) {
            var t = null == e ? 0 : e.length,
              r = ar(e, n);
            return qr(e, Tn(n, function (e) {
              return wi(e, t) ? +e : e;
            }).sort(No)), r;
          });
          function nu(e) {
            return null == e ? e : Ct.call(e);
          }
          var tu = Zr(function (e) {
              return so(yr(e, 1, qu, !0));
            }),
            ru = Zr(function (e) {
              var n = Zi(e);
              return qu(n) && (n = t), so(yr(e, 1, qu, !0), fi(n, 2));
            }),
            ou = Zr(function (e) {
              var n = Zi(e);
              return n = "function" == typeof n ? n : t, so(yr(e, 1, qu, !0), t, n);
            });
          function iu(e) {
            if (!e || !e.length) return [];
            var n = 0;
            return e = Pn(e, function (e) {
              if (qu(e)) return n = bt(e.length, n), !0;
            }), Zn(n, function (n) {
              return Tn(e, Yn(n));
            });
          }
          function uu(e, n) {
            if (!e || !e.length) return [];
            var r = iu(e);
            return null == n ? r : Tn(r, function (e) {
              return kn(n, t, e);
            });
          }
          var au = Zr(function (e, n) {
              return qu(e) ? pr(e, n) : [];
            }),
            cu = Zr(function (e) {
              return go(Pn(e, qu));
            }),
            lu = Zr(function (e) {
              var n = Zi(e);
              return qu(n) && (n = t), go(Pn(e, qu), fi(n, 2));
            }),
            fu = Zr(function (e) {
              var n = Zi(e);
              return n = "function" == typeof n ? n : t, go(Pn(e, qu), t, n);
            }),
            su = Zr(iu);
          var pu = Zr(function (e) {
            var n = e.length,
              r = n > 1 ? e[n - 1] : t;
            return r = "function" == typeof r ? (e.pop(), r) : t, uu(e, r);
          });
          function vu(e) {
            var n = Wt(e);
            return n.__chain__ = !0, n;
          }
          function du(e, n) {
            return n(e);
          }
          var hu = oi(function (e) {
            var n = e.length,
              r = n ? e[0] : 0,
              o = this.__wrapped__,
              i = function (n) {
                return ar(n, e);
              };
            return !(n > 1 || this.__actions__.length) && o instanceof Bt && wi(r) ? ((o = o.slice(r, +r + (n ? 1 : 0))).__actions__.push({
              func: du,
              args: [i],
              thisArg: t
            }), new Kt(o, this.__chain__).thru(function (e) {
              return n && !e.length && e.push(t), e;
            })) : this.thru(i);
          });
          var mu = Io(function (e, n, t) {
            Le.call(e, t) ? ++e[t] : ur(e, t, 1);
          });
          var gu = Fo(Ki),
            yu = Fo(Bi);
          function bu(e, n) {
            return (Bu(e) ? Mn : vr)(e, fi(n, 3));
          }
          function wu(e, n) {
            return (Bu(e) ? Rn : dr)(e, fi(n, 3));
          }
          var _u = Io(function (e, n, t) {
            Le.call(e, t) ? e[t].push(n) : ur(e, t, [n]);
          });
          var Eu = Zr(function (e, n, t) {
              var r = -1,
                o = "function" == typeof n,
                i = Yu(e) ? ue(e.length) : [];
              return vr(e, function (e) {
                i[++r] = o ? kn(n, e, t) : Ar(e, n, t);
              }), i;
            }),
            Su = Io(function (e, n, t) {
              ur(e, t, n);
            });
          function Cu(e, n) {
            return (Bu(e) ? Tn : Fr)(e, fi(n, 3));
          }
          var xu = Io(function (e, n, t) {
            e[t ? 0 : 1].push(n);
          }, function () {
            return [[], []];
          });
          var Ou = Zr(function (e, n) {
              if (null == e) return [];
              var t = n.length;
              return t > 1 && _i(e, n[0], n[1]) ? n = [] : t > 2 && _i(n[0], n[1], n[2]) && (n = [n[0]]), Br(e, yr(n, 1), []);
            }),
            ku = vn || function () {
              return hn.Date.now();
            };
          function Nu(e, n, r) {
            return n = r ? t : n, n = e && null == n ? e.length : n, Jo(e, l, t, t, t, t, n);
          }
          function Mu(e, n) {
            var o;
            if ("function" != typeof n) throw new Re(r);
            return e = ha(e), function () {
              return --e > 0 && (o = n.apply(this, arguments)), e <= 1 && (n = t), o;
            };
          }
          var Ru = Zr(function (e, n, t) {
              var r = 1;
              if (t.length) {
                var o = ft(t, li(Ru));
                r |= a;
              }
              return Jo(e, r, n, t, o);
            }),
            Au = Zr(function (e, n, t) {
              var r = 3;
              if (t.length) {
                var o = ft(t, li(Au));
                r |= a;
              }
              return Jo(n, r, e, t, o);
            });
          function Pu(e, n, o) {
            var i,
              u,
              a,
              c,
              l,
              f,
              s = 0,
              p = !1,
              v = !1,
              d = !0;
            if ("function" != typeof e) throw new Re(r);
            function h(n) {
              var r = i,
                o = u;
              return i = u = t, s = n, c = e.apply(o, r);
            }
            function m(e) {
              var r = e - f;
              return f === t || r >= n || r < 0 || v && e - s >= a;
            }
            function g() {
              var e = ku();
              if (m(e)) return y(e);
              l = Pi(g, function (e) {
                var t = n - (e - f);
                return v ? wt(t, a - (e - s)) : t;
              }(e));
            }
            function y(e) {
              return l = t, d && i ? h(e) : (i = u = t, c);
            }
            function b() {
              var e = ku(),
                r = m(e);
              if (i = arguments, u = this, f = e, r) {
                if (l === t) return function (e) {
                  return s = e, l = Pi(g, n), p ? h(e) : c;
                }(f);
                if (v) return Co(l), l = Pi(g, n), h(f);
              }
              return l === t && (l = Pi(g, n)), c;
            }
            return n = ga(n) || 0, na(o) && (p = !!o.leading, a = (v = "maxWait" in o) ? bt(ga(o.maxWait) || 0, n) : a, d = "trailing" in o ? !!o.trailing : d), b.cancel = function () {
              l !== t && Co(l), s = 0, i = f = u = l = t;
            }, b.flush = function () {
              return l === t ? c : y(ku());
            }, b;
          }
          var Iu = Zr(function (e, n) {
              return sr(e, 1, n);
            }),
            Du = Zr(function (e, n, t) {
              return sr(e, ga(n) || 0, t);
            });
          function Tu(e, n) {
            if ("function" != typeof e || null != n && "function" != typeof n) throw new Re(r);
            var t = function () {
              var r = arguments,
                o = n ? n.apply(this, r) : r[0],
                i = t.cache;
              if (i.has(o)) return i.get(o);
              var u = e.apply(this, r);
              return t.cache = i.set(o, u) || i, u;
            };
            return t.cache = new (Tu.Cache || qt)(), t;
          }
          function Lu(e) {
            if ("function" != typeof e) throw new Re(r);
            return function () {
              var n = arguments;
              switch (n.length) {
                case 0:
                  return !e.call(this);
                case 1:
                  return !e.call(this, n[0]);
                case 2:
                  return !e.call(this, n[0], n[1]);
                case 3:
                  return !e.call(this, n[0], n[1], n[2]);
              }
              return !e.apply(this, n);
            };
          }
          Tu.Cache = qt;
          var ju = Eo(function (e, n) {
              var t = (n = 1 == n.length && Bu(n[0]) ? Tn(n[0], Jn(fi())) : Tn(yr(n, 1), Jn(fi()))).length;
              return Zr(function (r) {
                for (var o = -1, i = wt(r.length, t); ++o < i;) r[o] = n[o].call(this, r[o]);
                return kn(e, this, r);
              });
            }),
            Vu = Zr(function (e, n) {
              var r = ft(n, li(Vu));
              return Jo(e, a, t, n, r);
            }),
            zu = Zr(function (e, n) {
              var r = ft(n, li(zu));
              return Jo(e, c, t, n, r);
            }),
            Fu = oi(function (e, n) {
              return Jo(e, f, t, t, t, n);
            });
          function Wu(e, n) {
            return e === n || e != e && n != n;
          }
          var Hu = qo(kr),
            Uu = qo(function (e, n) {
              return e >= n;
            }),
            Ku = Pr(function () {
              return arguments;
            }()) ? Pr : function (e) {
              return ta(e) && Le.call(e, "callee") && !Ge.call(e, "callee");
            },
            Bu = ue.isArray,
            $u = _n ? Jn(_n) : function (e) {
              return ta(e) && Or(e) == P;
            };
          function Yu(e) {
            return null != e && ea(e.length) && !Qu(e);
          }
          function qu(e) {
            return ta(e) && Yu(e);
          }
          var Gu = wn || gc,
            Xu = En ? Jn(En) : function (e) {
              return ta(e) && Or(e) == b;
            };
          function Zu(e) {
            if (!ta(e)) return !1;
            var n = Or(e);
            return n == w || "[object DOMException]" == n || "string" == typeof e.message && "string" == typeof e.name && !ia(e);
          }
          function Qu(e) {
            if (!na(e)) return !1;
            var n = Or(e);
            return n == _ || n == E || "[object AsyncFunction]" == n || "[object Proxy]" == n;
          }
          function Ju(e) {
            return "number" == typeof e && e == ha(e);
          }
          function ea(e) {
            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= p;
          }
          function na(e) {
            var n = typeof e;
            return null != e && ("object" == n || "function" == n);
          }
          function ta(e) {
            return null != e && "object" == typeof e;
          }
          var ra = Sn ? Jn(Sn) : function (e) {
            return ta(e) && mi(e) == S;
          };
          function oa(e) {
            return "number" == typeof e || ta(e) && Or(e) == C;
          }
          function ia(e) {
            if (!ta(e) || Or(e) != x) return !1;
            var n = Ye(e);
            if (null === n) return !0;
            var t = Le.call(n, "constructor") && n.constructor;
            return "function" == typeof t && t instanceof t && Te.call(t) == Fe;
          }
          var ua = Cn ? Jn(Cn) : function (e) {
            return ta(e) && Or(e) == k;
          };
          var aa = xn ? Jn(xn) : function (e) {
            return ta(e) && mi(e) == N;
          };
          function ca(e) {
            return "string" == typeof e || !Bu(e) && ta(e) && Or(e) == M;
          }
          function la(e) {
            return "symbol" == typeof e || ta(e) && Or(e) == R;
          }
          var fa = On ? Jn(On) : function (e) {
            return ta(e) && ea(e.length) && !!cn[Or(e)];
          };
          var sa = qo(zr),
            pa = qo(function (e, n) {
              return e <= n;
            });
          function va(e) {
            if (!e) return [];
            if (Yu(e)) return ca(e) ? dt(e) : Ao(e);
            if (Qe && e[Qe]) return function (e) {
              for (var n, t = []; !(n = e.next()).done;) t.push(n.value);
              return t;
            }(e[Qe]());
            var n = mi(e);
            return (n == S ? ct : n == N ? st : Wa)(e);
          }
          function da(e) {
            return e ? (e = ga(e)) === s || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
          }
          function ha(e) {
            var n = da(e),
              t = n % 1;
            return n == n ? t ? n - t : n : 0;
          }
          function ma(e) {
            return e ? cr(ha(e), 0, d) : 0;
          }
          function ga(e) {
            if ("number" == typeof e) return e;
            if (la(e)) return v;
            if (na(e)) {
              var n = "function" == typeof e.valueOf ? e.valueOf() : e;
              e = na(n) ? n + "" : n;
            }
            if ("string" != typeof e) return 0 === e ? e : +e;
            e = Qn(e);
            var t = me.test(e);
            return t || ye.test(e) ? pn(e.slice(2), t ? 2 : 8) : he.test(e) ? v : +e;
          }
          function ya(e) {
            return Po(e, Ia(e));
          }
          function ba(e) {
            return null == e ? "" : fo(e);
          }
          var wa = Do(function (e, n) {
              if (xi(n) || Yu(n)) Po(n, Pa(n), e);else for (var t in n) Le.call(n, t) && tr(e, t, n[t]);
            }),
            _a = Do(function (e, n) {
              Po(n, Ia(n), e);
            }),
            Ea = Do(function (e, n, t, r) {
              Po(n, Ia(n), e, r);
            }),
            Sa = Do(function (e, n, t, r) {
              Po(n, Pa(n), e, r);
            }),
            Ca = oi(ar);
          var xa = Zr(function (e, n) {
              e = ke(e);
              var r = -1,
                o = n.length,
                i = o > 2 ? n[2] : t;
              for (i && _i(n[0], n[1], i) && (o = 1); ++r < o;) for (var u = n[r], a = Ia(u), c = -1, l = a.length; ++c < l;) {
                var f = a[c],
                  s = e[f];
                (s === t || Wu(s, Ie[f]) && !Le.call(e, f)) && (e[f] = u[f]);
              }
              return e;
            }),
            Oa = Zr(function (e) {
              return e.push(t, ni), kn(Ta, t, e);
            });
          function ka(e, n, r) {
            var o = null == e ? t : Cr(e, n);
            return o === t ? r : o;
          }
          function Na(e, n) {
            return null != e && gi(e, n, Mr);
          }
          var Ma = Uo(function (e, n, t) {
              null != n && "function" != typeof n.toString && (n = ze.call(n)), e[n] = t;
            }, nc(oc)),
            Ra = Uo(function (e, n, t) {
              null != n && "function" != typeof n.toString && (n = ze.call(n)), Le.call(e, n) ? e[n].push(t) : e[n] = [t];
            }, fi),
            Aa = Zr(Ar);
          function Pa(e) {
            return Yu(e) ? Zt(e) : jr(e);
          }
          function Ia(e) {
            return Yu(e) ? Zt(e, !0) : Vr(e);
          }
          var Da = Do(function (e, n, t) {
              Ur(e, n, t);
            }),
            Ta = Do(function (e, n, t, r) {
              Ur(e, n, t, r);
            }),
            La = oi(function (e, n) {
              var t = {};
              if (null == e) return t;
              var r = !1;
              n = Tn(n, function (n) {
                return n = _o(n, e), r || (r = n.length > 1), n;
              }), Po(e, ui(e), t), r && (t = lr(t, 7, ti));
              for (var o = n.length; o--;) po(t, n[o]);
              return t;
            });
          var ja = oi(function (e, n) {
            return null == e ? {} : function (e, n) {
              return $r(e, n, function (n, t) {
                return Na(e, t);
              });
            }(e, n);
          });
          function Va(e, n) {
            if (null == e) return {};
            var t = Tn(ui(e), function (e) {
              return [e];
            });
            return n = fi(n), $r(e, t, function (e, t) {
              return n(e, t[0]);
            });
          }
          var za = Qo(Pa),
            Fa = Qo(Ia);
          function Wa(e) {
            return null == e ? [] : et(e, Pa(e));
          }
          var Ha = Vo(function (e, n, t) {
            return n = n.toLowerCase(), e + (t ? Ua(n) : n);
          });
          function Ua(e) {
            return Za(ba(e).toLowerCase());
          }
          function Ka(e) {
            return (e = ba(e)) && e.replace(we, ot).replace(en, "");
          }
          var Ba = Vo(function (e, n, t) {
              return e + (t ? "-" : "") + n.toLowerCase();
            }),
            $a = Vo(function (e, n, t) {
              return e + (t ? " " : "") + n.toLowerCase();
            }),
            Ya = jo("toLowerCase");
          var qa = Vo(function (e, n, t) {
            return e + (t ? "_" : "") + n.toLowerCase();
          });
          var Ga = Vo(function (e, n, t) {
            return e + (t ? " " : "") + Za(n);
          });
          var Xa = Vo(function (e, n, t) {
              return e + (t ? " " : "") + n.toUpperCase();
            }),
            Za = jo("toUpperCase");
          function Qa(e, n, r) {
            return e = ba(e), (n = r ? t : n) === t ? function (e) {
              return on.test(e);
            }(e) ? function (e) {
              return e.match(tn) || [];
            }(e) : function (e) {
              return e.match(fe) || [];
            }(e) : e.match(n) || [];
          }
          var Ja = Zr(function (e, n) {
              try {
                return kn(e, t, n);
              } catch (e) {
                return Zu(e) ? e : new Ce(e);
              }
            }),
            ec = oi(function (e, n) {
              return Mn(n, function (n) {
                n = Vi(n), ur(e, n, Ru(e[n], e));
              }), e;
            });
          function nc(e) {
            return function () {
              return e;
            };
          }
          var tc = Wo(),
            rc = Wo(!0);
          function oc(e) {
            return e;
          }
          function ic(e) {
            return Lr("function" == typeof e ? e : lr(e, 1));
          }
          var uc = Zr(function (e, n) {
              return function (t) {
                return Ar(t, e, n);
              };
            }),
            ac = Zr(function (e, n) {
              return function (t) {
                return Ar(e, t, n);
              };
            });
          function cc(e, n, t) {
            var r = Pa(n),
              o = Sr(n, r);
            null != t || na(n) && (o.length || !r.length) || (t = n, n = e, e = this, o = Sr(n, Pa(n)));
            var i = !(na(t) && "chain" in t && !t.chain),
              u = Qu(e);
            return Mn(o, function (t) {
              var r = n[t];
              e[t] = r, u && (e.prototype[t] = function () {
                var n = this.__chain__;
                if (i || n) {
                  var t = e(this.__wrapped__);
                  return (t.__actions__ = Ao(this.__actions__)).push({
                    func: r,
                    args: arguments,
                    thisArg: e
                  }), t.__chain__ = n, t;
                }
                return r.apply(e, Ln([this.value()], arguments));
              });
            }), e;
          }
          function lc() {}
          var fc = Bo(Tn),
            sc = Bo(An),
            pc = Bo(zn);
          function vc(e) {
            return Ei(e) ? Yn(Vi(e)) : function (e) {
              return function (n) {
                return Cr(n, e);
              };
            }(e);
          }
          var dc = Yo(),
            hc = Yo(!0);
          function mc() {
            return [];
          }
          function gc() {
            return !1;
          }
          var yc = Ko(function (e, n) {
              return e + n;
            }, 0),
            bc = Xo("ceil"),
            wc = Ko(function (e, n) {
              return e / n;
            }, 1),
            _c = Xo("floor");
          var Ec,
            Sc = Ko(function (e, n) {
              return e * n;
            }, 1),
            Cc = Xo("round"),
            xc = Ko(function (e, n) {
              return e - n;
            }, 0);
          return Wt.after = function (e, n) {
            if ("function" != typeof n) throw new Re(r);
            return e = ha(e), function () {
              if (--e < 1) return n.apply(this, arguments);
            };
          }, Wt.ary = Nu, Wt.assign = wa, Wt.assignIn = _a, Wt.assignInWith = Ea, Wt.assignWith = Sa, Wt.at = Ca, Wt.before = Mu, Wt.bind = Ru, Wt.bindAll = ec, Wt.bindKey = Au, Wt.castArray = function () {
            if (!arguments.length) return [];
            var e = arguments[0];
            return Bu(e) ? e : [e];
          }, Wt.chain = vu, Wt.chunk = function (e, n, r) {
            n = (r ? _i(e, n, r) : n === t) ? 1 : bt(ha(n), 0);
            var o = null == e ? 0 : e.length;
            if (!o || n < 1) return [];
            for (var i = 0, u = 0, a = ue(mn(o / n)); i < o;) a[u++] = oo(e, i, i += n);
            return a;
          }, Wt.compact = function (e) {
            for (var n = -1, t = null == e ? 0 : e.length, r = 0, o = []; ++n < t;) {
              var i = e[n];
              i && (o[r++] = i);
            }
            return o;
          }, Wt.concat = function () {
            var e = arguments.length;
            if (!e) return [];
            for (var n = ue(e - 1), t = arguments[0], r = e; r--;) n[r - 1] = arguments[r];
            return Ln(Bu(t) ? Ao(t) : [t], yr(n, 1));
          }, Wt.cond = function (e) {
            var n = null == e ? 0 : e.length,
              t = fi();
            return e = n ? Tn(e, function (e) {
              if ("function" != typeof e[1]) throw new Re(r);
              return [t(e[0]), e[1]];
            }) : [], Zr(function (t) {
              for (var r = -1; ++r < n;) {
                var o = e[r];
                if (kn(o[0], this, t)) return kn(o[1], this, t);
              }
            });
          }, Wt.conforms = function (e) {
            return function (e) {
              var n = Pa(e);
              return function (t) {
                return fr(t, e, n);
              };
            }(lr(e, 1));
          }, Wt.constant = nc, Wt.countBy = mu, Wt.create = function (e, n) {
            var t = Ht(e);
            return null == n ? t : ir(t, n);
          }, Wt.curry = function e(n, r, o) {
            var i = Jo(n, 8, t, t, t, t, t, r = o ? t : r);
            return i.placeholder = e.placeholder, i;
          }, Wt.curryRight = function e(n, r, o) {
            var i = Jo(n, u, t, t, t, t, t, r = o ? t : r);
            return i.placeholder = e.placeholder, i;
          }, Wt.debounce = Pu, Wt.defaults = xa, Wt.defaultsDeep = Oa, Wt.defer = Iu, Wt.delay = Du, Wt.difference = Wi, Wt.differenceBy = Hi, Wt.differenceWith = Ui, Wt.drop = function (e, n, r) {
            var o = null == e ? 0 : e.length;
            return o ? oo(e, (n = r || n === t ? 1 : ha(n)) < 0 ? 0 : n, o) : [];
          }, Wt.dropRight = function (e, n, r) {
            var o = null == e ? 0 : e.length;
            return o ? oo(e, 0, (n = o - (n = r || n === t ? 1 : ha(n))) < 0 ? 0 : n) : [];
          }, Wt.dropRightWhile = function (e, n) {
            return e && e.length ? ho(e, fi(n, 3), !0, !0) : [];
          }, Wt.dropWhile = function (e, n) {
            return e && e.length ? ho(e, fi(n, 3), !0) : [];
          }, Wt.fill = function (e, n, r, o) {
            var i = null == e ? 0 : e.length;
            return i ? (r && "number" != typeof r && _i(e, n, r) && (r = 0, o = i), function (e, n, r, o) {
              var i = e.length;
              for ((r = ha(r)) < 0 && (r = -r > i ? 0 : i + r), (o = o === t || o > i ? i : ha(o)) < 0 && (o += i), o = r > o ? 0 : ma(o); r < o;) e[r++] = n;
              return e;
            }(e, n, r, o)) : [];
          }, Wt.filter = function (e, n) {
            return (Bu(e) ? Pn : gr)(e, fi(n, 3));
          }, Wt.flatMap = function (e, n) {
            return yr(Cu(e, n), 1);
          }, Wt.flatMapDeep = function (e, n) {
            return yr(Cu(e, n), s);
          }, Wt.flatMapDepth = function (e, n, r) {
            return r = r === t ? 1 : ha(r), yr(Cu(e, n), r);
          }, Wt.flatten = $i, Wt.flattenDeep = function (e) {
            return (null == e ? 0 : e.length) ? yr(e, s) : [];
          }, Wt.flattenDepth = function (e, n) {
            return (null == e ? 0 : e.length) ? yr(e, n = n === t ? 1 : ha(n)) : [];
          }, Wt.flip = function (e) {
            return Jo(e, 512);
          }, Wt.flow = tc, Wt.flowRight = rc, Wt.fromPairs = function (e) {
            for (var n = -1, t = null == e ? 0 : e.length, r = {}; ++n < t;) {
              var o = e[n];
              r[o[0]] = o[1];
            }
            return r;
          }, Wt.functions = function (e) {
            return null == e ? [] : Sr(e, Pa(e));
          }, Wt.functionsIn = function (e) {
            return null == e ? [] : Sr(e, Ia(e));
          }, Wt.groupBy = _u, Wt.initial = function (e) {
            return (null == e ? 0 : e.length) ? oo(e, 0, -1) : [];
          }, Wt.intersection = qi, Wt.intersectionBy = Gi, Wt.intersectionWith = Xi, Wt.invert = Ma, Wt.invertBy = Ra, Wt.invokeMap = Eu, Wt.iteratee = ic, Wt.keyBy = Su, Wt.keys = Pa, Wt.keysIn = Ia, Wt.map = Cu, Wt.mapKeys = function (e, n) {
            var t = {};
            return n = fi(n, 3), _r(e, function (e, r, o) {
              ur(t, n(e, r, o), e);
            }), t;
          }, Wt.mapValues = function (e, n) {
            var t = {};
            return n = fi(n, 3), _r(e, function (e, r, o) {
              ur(t, r, n(e, r, o));
            }), t;
          }, Wt.matches = function (e) {
            return Wr(lr(e, 1));
          }, Wt.matchesProperty = function (e, n) {
            return Hr(e, lr(n, 1));
          }, Wt.memoize = Tu, Wt.merge = Da, Wt.mergeWith = Ta, Wt.method = uc, Wt.methodOf = ac, Wt.mixin = cc, Wt.negate = Lu, Wt.nthArg = function (e) {
            return e = ha(e), Zr(function (n) {
              return Kr(n, e);
            });
          }, Wt.omit = La, Wt.omitBy = function (e, n) {
            return Va(e, Lu(fi(n)));
          }, Wt.once = function (e) {
            return Mu(2, e);
          }, Wt.orderBy = function (e, n, r, o) {
            return null == e ? [] : (Bu(n) || (n = null == n ? [] : [n]), Bu(r = o ? t : r) || (r = null == r ? [] : [r]), Br(e, n, r));
          }, Wt.over = fc, Wt.overArgs = ju, Wt.overEvery = sc, Wt.overSome = pc, Wt.partial = Vu, Wt.partialRight = zu, Wt.partition = xu, Wt.pick = ja, Wt.pickBy = Va, Wt.property = vc, Wt.propertyOf = function (e) {
            return function (n) {
              return null == e ? t : Cr(e, n);
            };
          }, Wt.pull = Qi, Wt.pullAll = Ji, Wt.pullAllBy = function (e, n, t) {
            return e && e.length && n && n.length ? Yr(e, n, fi(t, 2)) : e;
          }, Wt.pullAllWith = function (e, n, r) {
            return e && e.length && n && n.length ? Yr(e, n, t, r) : e;
          }, Wt.pullAt = eu, Wt.range = dc, Wt.rangeRight = hc, Wt.rearg = Fu, Wt.reject = function (e, n) {
            return (Bu(e) ? Pn : gr)(e, Lu(fi(n, 3)));
          }, Wt.remove = function (e, n) {
            var t = [];
            if (!e || !e.length) return t;
            var r = -1,
              o = [],
              i = e.length;
            for (n = fi(n, 3); ++r < i;) {
              var u = e[r];
              n(u, r, e) && (t.push(u), o.push(r));
            }
            return qr(e, o), t;
          }, Wt.rest = function (e, n) {
            if ("function" != typeof e) throw new Re(r);
            return Zr(e, n = n === t ? n : ha(n));
          }, Wt.reverse = nu, Wt.sampleSize = function (e, n, r) {
            return n = (r ? _i(e, n, r) : n === t) ? 1 : ha(n), (Bu(e) ? Jt : Jr)(e, n);
          }, Wt.set = function (e, n, t) {
            return null == e ? e : eo(e, n, t);
          }, Wt.setWith = function (e, n, r, o) {
            return o = "function" == typeof o ? o : t, null == e ? e : eo(e, n, r, o);
          }, Wt.shuffle = function (e) {
            return (Bu(e) ? er : ro)(e);
          }, Wt.slice = function (e, n, r) {
            var o = null == e ? 0 : e.length;
            return o ? (r && "number" != typeof r && _i(e, n, r) ? (n = 0, r = o) : (n = null == n ? 0 : ha(n), r = r === t ? o : ha(r)), oo(e, n, r)) : [];
          }, Wt.sortBy = Ou, Wt.sortedUniq = function (e) {
            return e && e.length ? co(e) : [];
          }, Wt.sortedUniqBy = function (e, n) {
            return e && e.length ? co(e, fi(n, 2)) : [];
          }, Wt.split = function (e, n, r) {
            return r && "number" != typeof r && _i(e, n, r) && (n = r = t), (r = r === t ? d : r >>> 0) ? (e = ba(e)) && ("string" == typeof n || null != n && !ua(n)) && !(n = fo(n)) && at(e) ? So(dt(e), 0, r) : e.split(n, r) : [];
          }, Wt.spread = function (e, n) {
            if ("function" != typeof e) throw new Re(r);
            return n = null == n ? 0 : bt(ha(n), 0), Zr(function (t) {
              var r = t[n],
                o = So(t, 0, n);
              return r && Ln(o, r), kn(e, this, o);
            });
          }, Wt.tail = function (e) {
            var n = null == e ? 0 : e.length;
            return n ? oo(e, 1, n) : [];
          }, Wt.take = function (e, n, r) {
            return e && e.length ? oo(e, 0, (n = r || n === t ? 1 : ha(n)) < 0 ? 0 : n) : [];
          }, Wt.takeRight = function (e, n, r) {
            var o = null == e ? 0 : e.length;
            return o ? oo(e, (n = o - (n = r || n === t ? 1 : ha(n))) < 0 ? 0 : n, o) : [];
          }, Wt.takeRightWhile = function (e, n) {
            return e && e.length ? ho(e, fi(n, 3), !1, !0) : [];
          }, Wt.takeWhile = function (e, n) {
            return e && e.length ? ho(e, fi(n, 3)) : [];
          }, Wt.tap = function (e, n) {
            return n(e), e;
          }, Wt.throttle = function (e, n, t) {
            var o = !0,
              i = !0;
            if ("function" != typeof e) throw new Re(r);
            return na(t) && (o = "leading" in t ? !!t.leading : o, i = "trailing" in t ? !!t.trailing : i), Pu(e, n, {
              leading: o,
              maxWait: n,
              trailing: i
            });
          }, Wt.thru = du, Wt.toArray = va, Wt.toPairs = za, Wt.toPairsIn = Fa, Wt.toPath = function (e) {
            return Bu(e) ? Tn(e, Vi) : la(e) ? [e] : Ao(ji(ba(e)));
          }, Wt.toPlainObject = ya, Wt.transform = function (e, n, t) {
            var r = Bu(e),
              o = r || Gu(e) || fa(e);
            if (n = fi(n, 4), null == t) {
              var i = e && e.constructor;
              t = o ? r ? new i() : [] : na(e) && Qu(i) ? Ht(Ye(e)) : {};
            }
            return (o ? Mn : _r)(e, function (e, r, o) {
              return n(t, e, r, o);
            }), t;
          }, Wt.unary = function (e) {
            return Nu(e, 1);
          }, Wt.union = tu, Wt.unionBy = ru, Wt.unionWith = ou, Wt.uniq = function (e) {
            return e && e.length ? so(e) : [];
          }, Wt.uniqBy = function (e, n) {
            return e && e.length ? so(e, fi(n, 2)) : [];
          }, Wt.uniqWith = function (e, n) {
            return n = "function" == typeof n ? n : t, e && e.length ? so(e, t, n) : [];
          }, Wt.unset = function (e, n) {
            return null == e || po(e, n);
          }, Wt.unzip = iu, Wt.unzipWith = uu, Wt.update = function (e, n, t) {
            return null == e ? e : vo(e, n, wo(t));
          }, Wt.updateWith = function (e, n, r, o) {
            return o = "function" == typeof o ? o : t, null == e ? e : vo(e, n, wo(r), o);
          }, Wt.values = Wa, Wt.valuesIn = function (e) {
            return null == e ? [] : et(e, Ia(e));
          }, Wt.without = au, Wt.words = Qa, Wt.wrap = function (e, n) {
            return Vu(wo(n), e);
          }, Wt.xor = cu, Wt.xorBy = lu, Wt.xorWith = fu, Wt.zip = su, Wt.zipObject = function (e, n) {
            return yo(e || [], n || [], tr);
          }, Wt.zipObjectDeep = function (e, n) {
            return yo(e || [], n || [], eo);
          }, Wt.zipWith = pu, Wt.entries = za, Wt.entriesIn = Fa, Wt.extend = _a, Wt.extendWith = Ea, cc(Wt, Wt), Wt.add = yc, Wt.attempt = Ja, Wt.camelCase = Ha, Wt.capitalize = Ua, Wt.ceil = bc, Wt.clamp = function (e, n, r) {
            return r === t && (r = n, n = t), r !== t && (r = (r = ga(r)) == r ? r : 0), n !== t && (n = (n = ga(n)) == n ? n : 0), cr(ga(e), n, r);
          }, Wt.clone = function (e) {
            return lr(e, 4);
          }, Wt.cloneDeep = function (e) {
            return lr(e, 5);
          }, Wt.cloneDeepWith = function (e, n) {
            return lr(e, 5, n = "function" == typeof n ? n : t);
          }, Wt.cloneWith = function (e, n) {
            return lr(e, 4, n = "function" == typeof n ? n : t);
          }, Wt.conformsTo = function (e, n) {
            return null == n || fr(e, n, Pa(n));
          }, Wt.deburr = Ka, Wt.defaultTo = function (e, n) {
            return null == e || e != e ? n : e;
          }, Wt.divide = wc, Wt.endsWith = function (e, n, r) {
            e = ba(e), n = fo(n);
            var o = e.length,
              i = r = r === t ? o : cr(ha(r), 0, o);
            return (r -= n.length) >= 0 && e.slice(r, i) == n;
          }, Wt.eq = Wu, Wt.escape = function (e) {
            return (e = ba(e)) && X.test(e) ? e.replace(q, it) : e;
          }, Wt.escapeRegExp = function (e) {
            return (e = ba(e)) && oe.test(e) ? e.replace(re, "\\$&") : e;
          }, Wt.every = function (e, n, r) {
            var o = Bu(e) ? An : hr;
            return r && _i(e, n, r) && (n = t), o(e, fi(n, 3));
          }, Wt.find = gu, Wt.findIndex = Ki, Wt.findKey = function (e, n) {
            return Wn(e, fi(n, 3), _r);
          }, Wt.findLast = yu, Wt.findLastIndex = Bi, Wt.findLastKey = function (e, n) {
            return Wn(e, fi(n, 3), Er);
          }, Wt.floor = _c, Wt.forEach = bu, Wt.forEachRight = wu, Wt.forIn = function (e, n) {
            return null == e ? e : br(e, fi(n, 3), Ia);
          }, Wt.forInRight = function (e, n) {
            return null == e ? e : wr(e, fi(n, 3), Ia);
          }, Wt.forOwn = function (e, n) {
            return e && _r(e, fi(n, 3));
          }, Wt.forOwnRight = function (e, n) {
            return e && Er(e, fi(n, 3));
          }, Wt.get = ka, Wt.gt = Hu, Wt.gte = Uu, Wt.has = function (e, n) {
            return null != e && gi(e, n, Nr);
          }, Wt.hasIn = Na, Wt.head = Yi, Wt.identity = oc, Wt.includes = function (e, n, t, r) {
            e = Yu(e) ? e : Wa(e), t = t && !r ? ha(t) : 0;
            var o = e.length;
            return t < 0 && (t = bt(o + t, 0)), ca(e) ? t <= o && e.indexOf(n, t) > -1 : !!o && Un(e, n, t) > -1;
          }, Wt.indexOf = function (e, n, t) {
            var r = null == e ? 0 : e.length;
            if (!r) return -1;
            var o = null == t ? 0 : ha(t);
            return o < 0 && (o = bt(r + o, 0)), Un(e, n, o);
          }, Wt.inRange = function (e, n, r) {
            return n = da(n), r === t ? (r = n, n = 0) : r = da(r), function (e, n, t) {
              return e >= wt(n, t) && e < bt(n, t);
            }(e = ga(e), n, r);
          }, Wt.invoke = Aa, Wt.isArguments = Ku, Wt.isArray = Bu, Wt.isArrayBuffer = $u, Wt.isArrayLike = Yu, Wt.isArrayLikeObject = qu, Wt.isBoolean = function (e) {
            return !0 === e || !1 === e || ta(e) && Or(e) == y;
          }, Wt.isBuffer = Gu, Wt.isDate = Xu, Wt.isElement = function (e) {
            return ta(e) && 1 === e.nodeType && !ia(e);
          }, Wt.isEmpty = function (e) {
            if (null == e) return !0;
            if (Yu(e) && (Bu(e) || "string" == typeof e || "function" == typeof e.splice || Gu(e) || fa(e) || Ku(e))) return !e.length;
            var n = mi(e);
            if (n == S || n == N) return !e.size;
            if (xi(e)) return !jr(e).length;
            for (var t in e) if (Le.call(e, t)) return !1;
            return !0;
          }, Wt.isEqual = function (e, n) {
            return Ir(e, n);
          }, Wt.isEqualWith = function (e, n, r) {
            var o = (r = "function" == typeof r ? r : t) ? r(e, n) : t;
            return o === t ? Ir(e, n, t, r) : !!o;
          }, Wt.isError = Zu, Wt.isFinite = function (e) {
            return "number" == typeof e && Fn(e);
          }, Wt.isFunction = Qu, Wt.isInteger = Ju, Wt.isLength = ea, Wt.isMap = ra, Wt.isMatch = function (e, n) {
            return e === n || Dr(e, n, pi(n));
          }, Wt.isMatchWith = function (e, n, r) {
            return r = "function" == typeof r ? r : t, Dr(e, n, pi(n), r);
          }, Wt.isNaN = function (e) {
            return oa(e) && e != +e;
          }, Wt.isNative = function (e) {
            if (Ci(e)) throw new Ce("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
            return Tr(e);
          }, Wt.isNil = function (e) {
            return null == e;
          }, Wt.isNull = function (e) {
            return null === e;
          }, Wt.isNumber = oa, Wt.isObject = na, Wt.isObjectLike = ta, Wt.isPlainObject = ia, Wt.isRegExp = ua, Wt.isSafeInteger = function (e) {
            return Ju(e) && e >= -9007199254740991 && e <= p;
          }, Wt.isSet = aa, Wt.isString = ca, Wt.isSymbol = la, Wt.isTypedArray = fa, Wt.isUndefined = function (e) {
            return e === t;
          }, Wt.isWeakMap = function (e) {
            return ta(e) && mi(e) == A;
          }, Wt.isWeakSet = function (e) {
            return ta(e) && "[object WeakSet]" == Or(e);
          }, Wt.join = function (e, n) {
            return null == e ? "" : qn.call(e, n);
          }, Wt.kebabCase = Ba, Wt.last = Zi, Wt.lastIndexOf = function (e, n, r) {
            var o = null == e ? 0 : e.length;
            if (!o) return -1;
            var i = o;
            return r !== t && (i = (i = ha(r)) < 0 ? bt(o + i, 0) : wt(i, o - 1)), n == n ? function (e, n, t) {
              for (var r = t + 1; r--;) if (e[r] === n) return r;
              return r;
            }(e, n, i) : Hn(e, Bn, i, !0);
          }, Wt.lowerCase = $a, Wt.lowerFirst = Ya, Wt.lt = sa, Wt.lte = pa, Wt.max = function (e) {
            return e && e.length ? mr(e, oc, kr) : t;
          }, Wt.maxBy = function (e, n) {
            return e && e.length ? mr(e, fi(n, 2), kr) : t;
          }, Wt.mean = function (e) {
            return $n(e, oc);
          }, Wt.meanBy = function (e, n) {
            return $n(e, fi(n, 2));
          }, Wt.min = function (e) {
            return e && e.length ? mr(e, oc, zr) : t;
          }, Wt.minBy = function (e, n) {
            return e && e.length ? mr(e, fi(n, 2), zr) : t;
          }, Wt.stubArray = mc, Wt.stubFalse = gc, Wt.stubObject = function () {
            return {};
          }, Wt.stubString = function () {
            return "";
          }, Wt.stubTrue = function () {
            return !0;
          }, Wt.multiply = Sc, Wt.nth = function (e, n) {
            return e && e.length ? Kr(e, ha(n)) : t;
          }, Wt.noConflict = function () {
            return hn._ === this && (hn._ = We), this;
          }, Wt.noop = lc, Wt.now = ku, Wt.pad = function (e, n, t) {
            e = ba(e);
            var r = (n = ha(n)) ? vt(e) : 0;
            if (!n || r >= n) return e;
            var o = (n - r) / 2;
            return $o(gn(o), t) + e + $o(mn(o), t);
          }, Wt.padEnd = function (e, n, t) {
            e = ba(e);
            var r = (n = ha(n)) ? vt(e) : 0;
            return n && r < n ? e + $o(n - r, t) : e;
          }, Wt.padStart = function (e, n, t) {
            e = ba(e);
            var r = (n = ha(n)) ? vt(e) : 0;
            return n && r < n ? $o(n - r, t) + e : e;
          }, Wt.parseInt = function (e, n, t) {
            return t || null == n ? n = 0 : n && (n = +n), Et(ba(e).replace(ie, ""), n || 0);
          }, Wt.random = function (e, n, r) {
            if (r && "boolean" != typeof r && _i(e, n, r) && (n = r = t), r === t && ("boolean" == typeof n ? (r = n, n = t) : "boolean" == typeof e && (r = e, e = t)), e === t && n === t ? (e = 0, n = 1) : (e = da(e), n === t ? (n = e, e = 0) : n = da(n)), e > n) {
              var o = e;
              e = n, n = o;
            }
            if (r || e % 1 || n % 1) {
              var i = St();
              return wt(e + i * (n - e + sn("1e-" + ((i + "").length - 1))), n);
            }
            return Gr(e, n);
          }, Wt.reduce = function (e, n, t) {
            var r = Bu(e) ? jn : Gn,
              o = arguments.length < 3;
            return r(e, fi(n, 4), t, o, vr);
          }, Wt.reduceRight = function (e, n, t) {
            var r = Bu(e) ? Vn : Gn,
              o = arguments.length < 3;
            return r(e, fi(n, 4), t, o, dr);
          }, Wt.repeat = function (e, n, r) {
            return n = (r ? _i(e, n, r) : n === t) ? 1 : ha(n), Xr(ba(e), n);
          }, Wt.replace = function () {
            var e = arguments,
              n = ba(e[0]);
            return e.length < 3 ? n : n.replace(e[1], e[2]);
          }, Wt.result = function (e, n, r) {
            var o = -1,
              i = (n = _o(n, e)).length;
            for (i || (i = 1, e = t); ++o < i;) {
              var u = null == e ? t : e[Vi(n[o])];
              u === t && (o = i, u = r), e = Qu(u) ? u.call(e) : u;
            }
            return e;
          }, Wt.round = Cc, Wt.runInContext = e, Wt.sample = function (e) {
            return (Bu(e) ? Qt : Qr)(e);
          }, Wt.size = function (e) {
            if (null == e) return 0;
            if (Yu(e)) return ca(e) ? vt(e) : e.length;
            var n = mi(e);
            return n == S || n == N ? e.size : jr(e).length;
          }, Wt.snakeCase = qa, Wt.some = function (e, n, r) {
            var o = Bu(e) ? zn : io;
            return r && _i(e, n, r) && (n = t), o(e, fi(n, 3));
          }, Wt.sortedIndex = function (e, n) {
            return uo(e, n);
          }, Wt.sortedIndexBy = function (e, n, t) {
            return ao(e, n, fi(t, 2));
          }, Wt.sortedIndexOf = function (e, n) {
            var t = null == e ? 0 : e.length;
            if (t) {
              var r = uo(e, n);
              if (r < t && Wu(e[r], n)) return r;
            }
            return -1;
          }, Wt.sortedLastIndex = function (e, n) {
            return uo(e, n, !0);
          }, Wt.sortedLastIndexBy = function (e, n, t) {
            return ao(e, n, fi(t, 2), !0);
          }, Wt.sortedLastIndexOf = function (e, n) {
            if (null == e ? 0 : e.length) {
              var t = uo(e, n, !0) - 1;
              if (Wu(e[t], n)) return t;
            }
            return -1;
          }, Wt.startCase = Ga, Wt.startsWith = function (e, n, t) {
            return e = ba(e), t = null == t ? 0 : cr(ha(t), 0, e.length), n = fo(n), e.slice(t, t + n.length) == n;
          }, Wt.subtract = xc, Wt.sum = function (e) {
            return e && e.length ? Xn(e, oc) : 0;
          }, Wt.sumBy = function (e, n) {
            return e && e.length ? Xn(e, fi(n, 2)) : 0;
          }, Wt.template = function (e, n, r) {
            var o = Wt.templateSettings;
            r && _i(e, n, r) && (n = t), e = ba(e), n = Ea({}, n, o, ei);
            var i,
              u,
              a = Ea({}, n.imports, o.imports, ei),
              c = Pa(a),
              l = et(a, c),
              f = 0,
              s = n.interpolate || _e,
              p = "__p += '",
              v = Ne((n.escape || _e).source + "|" + s.source + "|" + (s === J ? ve : _e).source + "|" + (n.evaluate || _e).source + "|$", "g"),
              d = "//# sourceURL=" + (Le.call(n, "sourceURL") ? (n.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++an + "]") + "\n";
            e.replace(v, function (n, t, r, o, a, c) {
              return r || (r = o), p += e.slice(f, c).replace(Ee, ut), t && (i = !0, p += "' +\n__e(" + t + ") +\n'"), a && (u = !0, p += "';\n" + a + ";\n__p += '"), r && (p += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"), f = c + n.length, n;
            }), p += "';\n";
            var h = Le.call(n, "variable") && n.variable;
            if (h) {
              if (se.test(h)) throw new Ce("Invalid `variable` option passed into `_.template`");
            } else p = "with (obj) {\n" + p + "\n}\n";
            p = (u ? p.replace(K, "") : p).replace(B, "$1").replace($, "$1;"), p = "function(" + (h || "obj") + ") {\n" + (h ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (i ? ", __e = _.escape" : "") + (u ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + p + "return __p\n}";
            var m = Ja(function () {
              return xe(c, d + "return " + p).apply(t, l);
            });
            if (m.source = p, Zu(m)) throw m;
            return m;
          }, Wt.times = function (e, n) {
            if ((e = ha(e)) < 1 || e > p) return [];
            var t = d,
              r = wt(e, d);
            n = fi(n), e -= d;
            for (var o = Zn(r, n); ++t < e;) n(t);
            return o;
          }, Wt.toFinite = da, Wt.toInteger = ha, Wt.toLength = ma, Wt.toLower = function (e) {
            return ba(e).toLowerCase();
          }, Wt.toNumber = ga, Wt.toSafeInteger = function (e) {
            return e ? cr(ha(e), -9007199254740991, p) : 0 === e ? e : 0;
          }, Wt.toString = ba, Wt.toUpper = function (e) {
            return ba(e).toUpperCase();
          }, Wt.trim = function (e, n, r) {
            if ((e = ba(e)) && (r || n === t)) return Qn(e);
            if (!e || !(n = fo(n))) return e;
            var o = dt(e),
              i = dt(n);
            return So(o, tt(o, i), rt(o, i) + 1).join("");
          }, Wt.trimEnd = function (e, n, r) {
            if ((e = ba(e)) && (r || n === t)) return e.slice(0, ht(e) + 1);
            if (!e || !(n = fo(n))) return e;
            var o = dt(e);
            return So(o, 0, rt(o, dt(n)) + 1).join("");
          }, Wt.trimStart = function (e, n, r) {
            if ((e = ba(e)) && (r || n === t)) return e.replace(ie, "");
            if (!e || !(n = fo(n))) return e;
            var o = dt(e);
            return So(o, tt(o, dt(n))).join("");
          }, Wt.truncate = function (e, n) {
            var r = 30,
              o = "...";
            if (na(n)) {
              var i = "separator" in n ? n.separator : i;
              r = "length" in n ? ha(n.length) : r, o = "omission" in n ? fo(n.omission) : o;
            }
            var u = (e = ba(e)).length;
            if (at(e)) {
              var a = dt(e);
              u = a.length;
            }
            if (r >= u) return e;
            var c = r - vt(o);
            if (c < 1) return o;
            var l = a ? So(a, 0, c).join("") : e.slice(0, c);
            if (i === t) return l + o;
            if (a && (c += l.length - c), ua(i)) {
              if (e.slice(c).search(i)) {
                var f,
                  s = l;
                for (i.global || (i = Ne(i.source, ba(de.exec(i)) + "g")), i.lastIndex = 0; f = i.exec(s);) var p = f.index;
                l = l.slice(0, p === t ? c : p);
              }
            } else if (e.indexOf(fo(i), c) != c) {
              var v = l.lastIndexOf(i);
              v > -1 && (l = l.slice(0, v));
            }
            return l + o;
          }, Wt.unescape = function (e) {
            return (e = ba(e)) && G.test(e) ? e.replace(Y, mt) : e;
          }, Wt.uniqueId = function (e) {
            var n = ++je;
            return ba(e) + n;
          }, Wt.upperCase = Xa, Wt.upperFirst = Za, Wt.each = bu, Wt.eachRight = wu, Wt.first = Yi, cc(Wt, (Ec = {}, _r(Wt, function (e, n) {
            Le.call(Wt.prototype, n) || (Ec[n] = e);
          }), Ec), {
            chain: !1
          }), Wt.VERSION = "4.17.21", Mn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (e) {
            Wt[e].placeholder = Wt;
          }), Mn(["drop", "take"], function (e, n) {
            Bt.prototype[e] = function (r) {
              r = r === t ? 1 : bt(ha(r), 0);
              var o = this.__filtered__ && !n ? new Bt(this) : this.clone();
              return o.__filtered__ ? o.__takeCount__ = wt(r, o.__takeCount__) : o.__views__.push({
                size: wt(r, d),
                type: e + (o.__dir__ < 0 ? "Right" : "")
              }), o;
            }, Bt.prototype[e + "Right"] = function (n) {
              return this.reverse()[e](n).reverse();
            };
          }), Mn(["filter", "map", "takeWhile"], function (e, n) {
            var t = n + 1,
              r = 1 == t || 3 == t;
            Bt.prototype[e] = function (e) {
              var n = this.clone();
              return n.__iteratees__.push({
                iteratee: fi(e, 3),
                type: t
              }), n.__filtered__ = n.__filtered__ || r, n;
            };
          }), Mn(["head", "last"], function (e, n) {
            var t = "take" + (n ? "Right" : "");
            Bt.prototype[e] = function () {
              return this[t](1).value()[0];
            };
          }), Mn(["initial", "tail"], function (e, n) {
            var t = "drop" + (n ? "" : "Right");
            Bt.prototype[e] = function () {
              return this.__filtered__ ? new Bt(this) : this[t](1);
            };
          }), Bt.prototype.compact = function () {
            return this.filter(oc);
          }, Bt.prototype.find = function (e) {
            return this.filter(e).head();
          }, Bt.prototype.findLast = function (e) {
            return this.reverse().find(e);
          }, Bt.prototype.invokeMap = Zr(function (e, n) {
            return "function" == typeof e ? new Bt(this) : this.map(function (t) {
              return Ar(t, e, n);
            });
          }), Bt.prototype.reject = function (e) {
            return this.filter(Lu(fi(e)));
          }, Bt.prototype.slice = function (e, n) {
            e = ha(e);
            var r = this;
            return r.__filtered__ && (e > 0 || n < 0) ? new Bt(r) : (e < 0 ? r = r.takeRight(-e) : e && (r = r.drop(e)), n !== t && (r = (n = ha(n)) < 0 ? r.dropRight(-n) : r.take(n - e)), r);
          }, Bt.prototype.takeRightWhile = function (e) {
            return this.reverse().takeWhile(e).reverse();
          }, Bt.prototype.toArray = function () {
            return this.take(d);
          }, _r(Bt.prototype, function (e, n) {
            var r = /^(?:filter|find|map|reject)|While$/.test(n),
              o = /^(?:head|last)$/.test(n),
              i = Wt[o ? "take" + ("last" == n ? "Right" : "") : n],
              u = o || /^find/.test(n);
            i && (Wt.prototype[n] = function () {
              var n = this.__wrapped__,
                a = o ? [1] : arguments,
                c = n instanceof Bt,
                l = a[0],
                f = c || Bu(n),
                s = function (e) {
                  var n = i.apply(Wt, Ln([e], a));
                  return o && p ? n[0] : n;
                };
              f && r && "function" == typeof l && 1 != l.length && (c = f = !1);
              var p = this.__chain__,
                v = !!this.__actions__.length,
                d = u && !p,
                h = c && !v;
              if (!u && f) {
                n = h ? n : new Bt(this);
                var m = e.apply(n, a);
                return m.__actions__.push({
                  func: du,
                  args: [s],
                  thisArg: t
                }), new Kt(m, p);
              }
              return d && h ? e.apply(this, a) : (m = this.thru(s), d ? o ? m.value()[0] : m.value() : m);
            });
          }), Mn(["pop", "push", "shift", "sort", "splice", "unshift"], function (e) {
            var n = Ae[e],
              t = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
              r = /^(?:pop|shift)$/.test(e);
            Wt.prototype[e] = function () {
              var e = arguments;
              if (r && !this.__chain__) {
                var o = this.value();
                return n.apply(Bu(o) ? o : [], e);
              }
              return this[t](function (t) {
                return n.apply(Bu(t) ? t : [], e);
              });
            };
          }), _r(Bt.prototype, function (e, n) {
            var t = Wt[n];
            if (t) {
              var r = t.name + "";
              Le.call(Pt, r) || (Pt[r] = []), Pt[r].push({
                name: n,
                func: t
              });
            }
          }), Pt[Ho(t, 2).name] = [{
            name: "wrapper",
            func: t
          }], Bt.prototype.clone = function () {
            var e = new Bt(this.__wrapped__);
            return e.__actions__ = Ao(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Ao(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Ao(this.__views__), e;
          }, Bt.prototype.reverse = function () {
            if (this.__filtered__) {
              var e = new Bt(this);
              e.__dir__ = -1, e.__filtered__ = !0;
            } else (e = this.clone()).__dir__ *= -1;
            return e;
          }, Bt.prototype.value = function () {
            var e = this.__wrapped__.value(),
              n = this.__dir__,
              t = Bu(e),
              r = n < 0,
              o = t ? e.length : 0,
              i = function (e, n, t) {
                var r = -1,
                  o = t.length;
                for (; ++r < o;) {
                  var i = t[r],
                    u = i.size;
                  switch (i.type) {
                    case "drop":
                      e += u;
                      break;
                    case "dropRight":
                      n -= u;
                      break;
                    case "take":
                      n = wt(n, e + u);
                      break;
                    case "takeRight":
                      e = bt(e, n - u);
                  }
                }
                return {
                  start: e,
                  end: n
                };
              }(0, o, this.__views__),
              u = i.start,
              a = i.end,
              c = a - u,
              l = r ? a : u - 1,
              f = this.__iteratees__,
              s = f.length,
              p = 0,
              v = wt(c, this.__takeCount__);
            if (!t || !r && o == c && v == c) return mo(e, this.__actions__);
            var d = [];
            e: for (; c-- && p < v;) {
              for (var h = -1, m = e[l += n]; ++h < s;) {
                var g = f[h],
                  y = g.iteratee,
                  b = g.type,
                  w = y(m);
                if (2 == b) m = w;else if (!w) {
                  if (1 == b) continue e;
                  break e;
                }
              }
              d[p++] = m;
            }
            return d;
          }, Wt.prototype.at = hu, Wt.prototype.chain = function () {
            return vu(this);
          }, Wt.prototype.commit = function () {
            return new Kt(this.value(), this.__chain__);
          }, Wt.prototype.next = function () {
            this.__values__ === t && (this.__values__ = va(this.value()));
            var e = this.__index__ >= this.__values__.length;
            return {
              done: e,
              value: e ? t : this.__values__[this.__index__++]
            };
          }, Wt.prototype.plant = function (e) {
            for (var n, r = this; r instanceof Ut;) {
              var o = Fi(r);
              o.__index__ = 0, o.__values__ = t, n ? i.__wrapped__ = o : n = o;
              var i = o;
              r = r.__wrapped__;
            }
            return i.__wrapped__ = e, n;
          }, Wt.prototype.reverse = function () {
            var e = this.__wrapped__;
            if (e instanceof Bt) {
              var n = e;
              return this.__actions__.length && (n = new Bt(this)), (n = n.reverse()).__actions__.push({
                func: du,
                args: [nu],
                thisArg: t
              }), new Kt(n, this.__chain__);
            }
            return this.thru(nu);
          }, Wt.prototype.toJSON = Wt.prototype.valueOf = Wt.prototype.value = function () {
            return mo(this.__wrapped__, this.__actions__);
          }, Wt.prototype.first = Wt.prototype.head, Qe && (Wt.prototype[Qe] = function () {
            return this;
          }), Wt;
        }();
        gn ? ((gn.exports = gt)._ = gt, mn._ = gt) : hn._ = gt;
      }).call(j);
    });
  function ui() {
    return ui = Object.assign ? Object.assign.bind() : function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = arguments[n];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
      return e;
    }, ui.apply(null, arguments);
  }
  var ai,
    ci,
    li,
    fi,
    si = function (e) {
      return i.createElement("svg", ui({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none"
      }, e), ri || (ri = i.createElement("path", {
        stroke: "#4C6AFF",
        strokeWidth: 2,
        d: "M13.926 8A5.926 5.926 0 1 0 2.074 8a5.926 5.926 0 0 0 11.852 0Z",
        opacity: .27
      })), oi || (oi = i.createElement("path", {
        stroke: "#4C6AFF",
        strokeLinecap: "round",
        strokeWidth: 2,
        d: "M2.074 8a5.926 5.926 0 0 1 10.76-3.428"
      })));
    };
  function pi() {
    return pi = Object.assign ? Object.assign.bind() : function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = arguments[n];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
      return e;
    }, pi.apply(null, arguments);
  }
  var vi,
    di = function (e) {
      return i.createElement("svg", pi({
        xmlns: "http://www.w3.org/2000/svg",
        width: 102,
        height: 78,
        fill: "none"
      }, e), ai || (ai = i.createElement("ellipse", {
        cx: 51,
        cy: 37.206,
        fill: "#EBEDF2",
        rx: 33.824,
        ry: 8.794
      })), ci || (ci = i.createElement("path", {
        stroke: "#E1E3E8",
        d: "M25.794 36.235V15.068L37.628 1.366A2.5 2.5 0 0 1 39.52.5h22.96a2.5 2.5 0 0 1 1.892.866l11.834 13.702v21.167a2.5 2.5 0 0 1-2.5 2.5H28.294a2.5 2.5 0 0 1-2.5-2.5Z"
      })), li || (li = i.createElement("path", {
        fill: "#F6F7FA",
        stroke: "#E1E3E8",
        d: "M25.794 15.382h13.059a1.5 1.5 0 0 1 1.5 1.5v2.765a2.5 2.5 0 0 0 2.5 2.5h16.294a2.5 2.5 0 0 0 2.5-2.5v-2.765a1.5 1.5 0 0 1 1.5-1.5h13.059v20.853a2.5 2.5 0 0 1-2.5 2.5H28.294a2.5 2.5 0 0 1-2.5-2.5z"
      })), fi || (fi = i.createElement("path", {
        fill: "#747A8C",
        d: "M30.014 67.616q-.966.084-2.058.168v-1.106h2.184v-.826h-2.184v-.924h-.924v.924h-1.624c.35-.462.686-.994.994-1.582h3.836v-.896h-3.416c.112-.252.21-.504.308-.756l-1.008-.168c-.112.308-.238.616-.364.924h-1.946v.896h1.498a8.5 8.5 0 0 1-1.106 1.61l.224.798h2.604v1.162c-.952.056-1.974.098-3.038.154l.126.896c1.008-.056 1.988-.126 2.912-.182v1.008h.924v-1.078c.714-.07 1.4-.14 2.058-.196zm1.96-.924h1.82v3.038h.966v-3.038h1.484v-.882h-4.2v-1.456c1.512-.168 2.772-.49 3.808-.938l-.644-.756c-.98.448-2.352.756-4.088.924v2.198c-.028 1.26-.364 2.338-.98 3.248l.7.728q.903-1.302 1.134-3.066m2.702 3.444h-9.184V75.4h1.036v-.546h7.112v.546h1.036zm-8.148 3.85v-1.092h7.112v1.092zm0-1.904V70.99h7.112v1.092zm12.334-8.764v.98h4.018v.938c-.014.868-.07 1.694-.182 2.45h-4.774v.966h4.606c-.182.882-.434 1.68-.77 2.38-.756 1.428-2.086 2.562-4.018 3.43l.56.896c1.946-.84 3.346-2.03 4.214-3.542.476-.896.826-1.946 1.05-3.164H44.7v5.096c0 .952.448 1.428 1.372 1.428h2.268c.588 0 1.008-.126 1.274-.378.308-.308.518-1.134.63-2.506l-.952-.308c-.07 1.092-.196 1.736-.392 1.96-.154.182-.406.28-.742.28H46.38c-.448 0-.672-.238-.672-.686v-4.886h4.34v-.966H43.72c.098-.756.154-1.582.182-2.45v-.938h5.012v-.98zm21.35 2.352h2.072c-.056 1.89-.35 3.542-.896 4.956-.56-1.176-1.008-2.59-1.358-4.228zm.714 5.964a8.24 8.24 0 0 1-2.59 2.912l.518.84a9.4 9.4 0 0 0 2.59-2.814c.7 1.176 1.54 2.128 2.52 2.828l.546-.826c-1.008-.686-1.862-1.652-2.59-2.912.784-1.652 1.218-3.654 1.288-5.992h.91v-.966h-3.696c.112-.616.224-1.288.308-2.002l-.98-.168c-.28 2.66-.84 4.774-1.666 6.342l.63.77a12.4 12.4 0 0 0 .826-1.722c.378 1.4.84 2.632 1.386 3.71m-6.636-2.562q-.147.42-.336.882H51.91v.882h1.652c-.28.56-.602 1.134-.966 1.75.686.252 1.33.518 1.946.784-.812.462-1.806.84-2.954 1.148l.476.84q2.1-.588 3.486-1.554c.826.364 1.54.742 2.156 1.106l.546-.784a31 31 0 0 0-1.932-.952 5.64 5.64 0 0 0 1.554-2.394v-.826h-2.926c.084-.252.182-.504.28-.77zm1.106 3.71a30 30 0 0 0-1.596-.602q.42-.63.756-1.344h2.408c-.336.728-.868 1.386-1.568 1.946m-2.38-9.954-.798.266c.336.532.644 1.134.938 1.82l.728-.336a12 12 0 0 0-.868-1.75m4.256-.042c-.252.588-.616 1.176-1.064 1.778l.714.364A9.3 9.3 0 0 0 58 63.122zm-5.334 2.464v.882h1.988c-.42.77-1.176 1.47-2.254 2.1l.49.812c1.204-.812 2.044-1.764 2.506-2.87v2.66h.938v-1.82q.756.504 1.806 1.344l.518-.784a33 33 0 0 0-2.324-1.288v-.154h2.548v-.882h-2.548v-2.674h-.938v2.674zm15.358 10.024c.784 0 1.176-.42 1.176-1.232v-4.088c.434-.196.868-.392 1.302-.616v-.994q-.63.336-1.302.63v-2.758h1.344v-.966h-1.344v-2.646h-.98v2.646h-1.68v.966h1.68v3.164c-.616.224-1.26.42-1.904.574l.252.98a29 29 0 0 0 1.652-.574v3.43c0 .392-.182.602-.532.602-.336 0-.7-.028-1.064-.07l.21.952zm4.186-6.188h2.856v1.722H72V75.4h.938v-.686h3.794v.686h.938v-4.592h-2.352v-1.722h2.996v-.91h-2.996v-1.652h2.632v-3.402h-7.378v4.382c-.014 2.94-.518 5.348-1.512 7.196l.784.7c.924-1.82 1.47-3.92 1.638-6.314m2.856-2.562v1.652h-2.8c0-.224.014-.448.014-.672v-.98zm-1.4 7.294v-2.114h3.794v2.114zm4.032-9.758v1.554h-5.418V64.06z"
      })));
    };
  function hi() {
    return hi = Object.assign ? Object.assign.bind() : function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = arguments[n];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
      return e;
    }, hi.apply(null, arguments);
  }
  var mi,
    gi,
    yi = function (e) {
      return i.createElement("svg", hi({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none"
      }, e), vi || (vi = i.createElement("path", {
        fill: "#C0C8D6",
        fillRule: "evenodd",
        d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m3-10a.6.6 0 0 0-.848 0L8 7.152 5.85 5A.6.6 0 1 0 5 5.85L7.152 8 5 10.152a.6.6 0 1 0 .849.848L8 8.85 10.152 11a.6.6 0 0 0 .849-.848L8.849 8 11 5.85A.6.6 0 0 0 11 5",
        clipRule: "evenodd"
      })));
    };
  function bi() {
    return bi = Object.assign ? Object.assign.bind() : function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = arguments[n];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
      return e;
    }, bi.apply(null, arguments);
  }
  var wi,
    _i = function (e) {
      return i.createElement("svg", bi({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none"
      }, e), mi || (mi = i.createElement("path", {
        stroke: "#8D92A1",
        d: "M7.5 13a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z",
        clipRule: "evenodd"
      })), gi || (gi = i.createElement("path", {
        stroke: "#8D92A1",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m14.438 14-1.5-1.5-.75-.75-.188-.187"
      })));
    };
  function Ei() {
    return Ei = Object.assign ? Object.assign.bind() : function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = arguments[n];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
      return e;
    }, Ei.apply(null, arguments);
  }
  var Si,
    Ci = function (e) {
      return i.createElement("svg", Ei({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none"
      }, e), wi || (wi = i.createElement("path", {
        fill: "#8D92A1",
        d: "M4.207 6.575a.5.5 0 0 1 .38-.825h6.826a.5.5 0 0 1 .38.825L8.38 10.557a.5.5 0 0 1-.76 0z"
      })));
    };
  function xi() {
    return xi = Object.assign ? Object.assign.bind() : function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = arguments[n];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
      return e;
    }, xi.apply(null, arguments);
  }
  var Oi,
    ki = function (e) {
      return i.createElement("svg", xi({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none"
      }, e), Si || (Si = i.createElement("path", {
        fill: "#8D92A1",
        d: "M11.793 9.425a.5.5 0 0 1-.38.825H4.587a.5.5 0 0 1-.38-.825L7.62 5.443a.5.5 0 0 1 .76 0z"
      })));
    };
  function Ni() {
    return Ni = Object.assign ? Object.assign.bind() : function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = arguments[n];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
      return e;
    }, Ni.apply(null, arguments);
  }
  var Mi = function (e) {
    return i.createElement("svg", Ni({
      xmlns: "http://www.w3.org/2000/svg",
      width: 16,
      height: 16,
      fill: "none"
    }, e), Oi || (Oi = i.createElement("path", {
      stroke: "#3F465C",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "m6 4 4 4-4 4"
    })));
  };
  function Ri(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }
  function Ai() {
    return Ai = Object.assign || function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = arguments[n];
        for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
      return e;
    }, Ai.apply(this, arguments);
  }
  function Pi(e, n) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      n && (r = r.filter(function (n) {
        return Object.getOwnPropertyDescriptor(e, n).enumerable;
      })), t.push.apply(t, r);
    }
    return t;
  }
  function Ii(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = null != arguments[n] ? arguments[n] : {};
      n % 2 ? Pi(Object(t), !0).forEach(function (n) {
        Ri(e, n, t[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Pi(Object(t)).forEach(function (n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
      });
    }
    return e;
  }
  function Di(e, n) {
    if (null == e) return {};
    var t,
      r,
      o = function (e, n) {
        if (null == e) return {};
        var t,
          r,
          o = {},
          i = Object.keys(e);
        for (r = 0; r < i.length; r++) t = i[r], n.indexOf(t) >= 0 || (o[t] = e[t]);
        return o;
      }(e, n);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);
      for (r = 0; r < i.length; r++) t = i[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
    }
    return o;
  }
  var Ti = function (e, n) {
      var t = e.wrapClassName,
        r = void 0 === t ? "" : t,
        o = e.wrapStyle,
        i = void 0 === o ? {} : o,
        a = Di(e, ["wrapClassName", "wrapStyle"]);
      return u.default.createElement("span", {
        ref: n,
        role: "img",
        style: Ii({}, i),
        className: "sirius-icon " + r
      }, u.default.createElement("svg", Ai({
        fill: "none",
        viewBox: "0 0 16 16",
        width: "1em",
        height: "1em",
        stroke: "currentColor",
        strokeWidth: "1"
      }, a), u.default.createElement("path", {
        strokeLinecap: "round",
        d: "m4.111 11.89 7.778-7.78M11.889 11.89 4.111 4.11"
      })));
    },
    Li = u.default.forwardRef(Ti);
  const {
      SHOW_CHILD: ji,
      SHOW_PARENT: Vi
    } = ti,
    zi = "sirius-cascader-select",
    Fi = "sirius-cascader",
    Wi = i.forwardRef((e, t) => {
      const {
          fetching: r,
          suffixIcon: o,
          showSearch: u,
          onFocus: a,
          onBlur: c,
          onDropdownVisibleChange: l,
          multiple: f,
          className: s,
          popupClassName: p,
          bordered: v,
          size: d,
          multiline: h
        } = e,
        m = function (e, n) {
          var t = {};
          for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) n.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (t[r[o]] = e[r[o]]);
          }
          return t;
        }(e, ["fetching", "suffixIcon", "showSearch", "onFocus", "onBlur", "onDropdownVisibleChange", "multiple", "className", "popupClassName", "bordered", "size", "multiline"]),
        [g, y] = n.useState(!0),
        [b, w] = n.useState(!1),
        [_, E] = n.useState(!1),
        S = ii.omit(m);
      n.useEffect(() => {
        y(!_);
      }, [_]);
      const C = (e, n, t, r) => {
          const o = [],
            u = e.toLowerCase();
          return n.forEach((e, n) => {
            0 !== n && o.push(" / ");
            let a = e[r.label];
            const c = typeof a;
            "string" !== c && "number" !== c || (a = ((e, n, t) => {
              const r = e.toLowerCase().split(n).reduce((e, t, r) => 0 === r ? [t] : [...e, n, t], []),
                o = [];
              let u = 0;
              return r.forEach((n, r) => {
                const a = u + n.length;
                let c = e.slice(u, a);
                u = a, r % 2 == 1 && (c = i.createElement("span", {
                  className: "".concat(t, "-menu-item-keyword"),
                  key: "seperator-".concat(r)
                }, c)), o.push(c);
              }), o;
            })(String(a), u, t)), o.push(a);
          }), o;
        },
        x = n.useMemo(() => r ? i.createElement("div", {
          className: "".concat(Fi, "-menu-loading")
        }, i.createElement(si, null)) : i.createElement(di, null), []),
        O = n.useMemo(() => o || (u && b ? i.createElement(_i, null) : g ? i.createElement(Ci, null) : i.createElement(ki, null)), [u, b, g]),
        k = n.useMemo(() => {
          if (!u) return u;
          let e = {
            render: C
          };
          return "object" == typeof u && (e = Object.assign(Object.assign({}, e), u)), e;
        }, [u]);
      return i.createElement(ti, Object.assign({
        ref: t,
        prefixCls: zi,
        className: F(s, Fi, {
          ["".concat(zi, "-mn")]: "mini" === d,
          ["".concat(zi, "-sm")]: "small" === d,
          ["".concat(zi, "-lg")]: "large" === d,
          ["".concat(zi, "-borderless")]: !v,
          ["".concat(zi, "-multi-line")]: h
        })
      }, S, {
        inputIcon: O,
        clearIcon: i.createElement(yi, null),
        removeIcon: i.createElement(Li, {
          className: "".concat(Fi, "-removeIcon")
        }),
        expandTrigger: e.expandTrigger || "hover",
        onFocus: e => {
          w(!a), a && a(e);
        },
        onBlur: e => {
          w(!1), c && c(e);
        },
        onDropdownVisibleChange: e => {
          E(e), l && l(e);
        },
        expandIcon: i.createElement(Mi, null),
        dropdownPrefixCls: Fi,
        dropdownClassName: F(p, "".concat(Fi, "-dropdown"), {
          ["".concat(Fi, "-single")]: !f,
          ["".concat(Fi, "-multiple")]: f
        }),
        showSearch: k,
        checkable: f,
        notFoundContent: x
      }));
    });
  Wi.defaultProps = {
    bordered: !0
  }, Wi.SHOW_PARENT = Vi, Wi.SHOW_CHILD = ji, e.default = Wi, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});